/*
  Ukrainian interface strings. Keys are the English source (see ./index.js);
  a key missing here falls back to English. Generated from the Russian/Spanish key set
  and checked for placeholders and markup; edit by hand like any other map.
*/

const uk = {
  "White pages": "White pages",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Статичні сторінки для ботів/перевірки реклами — розміщені тут, роздаються з того самого origin на вашому домені (клоакінг, безпечний для Google)",
  "White pages (hosted, same-origin)": "White pages (розміщені, same-origin)",
  "Safe page URL (external)": "URL безпечної сторінки (зовнішній)",
  "External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.": "Зовнішня безпечна сторінка — трекер проксує її з того самого origin (ідентифікаційні теги видаляються). Використовується, якщо white page не вибрано. Має бути абсолютним URL http(s). Цей метод сам по собі проходить перевірку Google; розміщена white page — просто надійніша альтернатива, що роздається повністю з вашого домену.",
  "Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.": "Необов'язково — найнадійніший варіант для Google/Facebook: роздається з домену вашої кампанії (/wp/…), тому фінальний URL залишається на домені. Виберіть кілька, щоб ротувати випадкову при кожному запиті — так одна white не повторюється в сотнях оголошень. Керуйте у розділі White pages.",
  "selected — rotated per request": "вибрано — ротуються при кожному запиті",
  "No white pages yet. Upload some under White pages, then pick them here.": "White pages ще відсутні. Завантажте їх у розділі White pages, а потім виберіть тут.",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Select several to rotate a random one per request — so one white isn’t reused across hundreds of ads. Manage under White pages.": "Рекомендовано для Google/Facebook: роздається з домену вашої кампанії (/wp/…), тому фінальний URL оголошення залишається на домені та проходить перевірку. Виберіть кілька, щоб ротувати випадкову при кожному запиті — так одна white не повторюється в сотнях оголошень. Керуйте у розділі White pages.",
  "Static pages for bots & ad review": "Статичні сторінки для ботів і перевірки реклами",
  "Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.": "Відповідні статичні сторінки, що роздаються ботам і перевіряючим рекламу — same-origin на домені вашої кампанії.",
  "These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.": "Ці сторінки розміщені тут і роздаються з того самого origin за адресою /wp/<slug>/ на будь-якому з ваших верифікованих доменів. Виберіть одну в налаштуваннях клоакінгу кампанії — боти та перевіряючі Google/Facebook бачать цю сторінку, а реальні користувачі — офер.",
  "Upload white page": "Завантажити white page",
  "Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.": "Завантажте статичний ZIP-архів (index.html + ресурси). PHP заборонено. Макс. 50 МБ.",
  "My white page": "Моя white page",
  "What this white page is for": "Призначення цієї white page",
  "Static files only (.html/.css/.js/images). No .php.": "Лише статичні файли (.html/.css/.js/зображення). Без .php.",
  "Please enter a name for the white page": "Введіть назву для white page",
  "White page uploaded successfully": "White page успішно завантажено",
  "Error uploading white page": "Помилка завантаження white page",
  "Error loading white pages": "Помилка завантаження white pages",
  "Error deleting white page": "Помилка видалення white page",
  "White page deleted": "White page видалено",
  "No white pages": "White pages відсутні",
  "Upload a static white page to use for campaign cloaking": "Завантажте статичну white page для використання в клоакінгу кампанії",
  "Search white pages…": "Пошук white pages…",
  "Same-origin path": "Шлях same-origin",
  "Delete white page": "Видалити white page",
  "This permanently deletes \"{name}\" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).": "Це назавжди видалить \"{name}\" та її файли. Кампанії, що досі посилаються на неї, переключаться на URL безпечної сторінки (або на офер, якщо його немає).",
  "Multiple HTML pages detected. Select the main page bots will land on.": "Виявлено кілька HTML-сторінок. Виберіть головну сторінку, на яку потраплятимуть боти.",
  "White page (hosted, same-origin)": "White page (розміщена, same-origin)",
  "None — use Safe page URL below": "Немає — використовувати URL безпечної сторінки нижче",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Manage these under White pages.": "Рекомендовано для Google/Facebook: роздається з домену вашої кампанії (/wp/…), тому фінальний URL оголошення залишається на домені та проходить перевірку. Керуйте ними у розділі White pages.",
  "Safe page URL (external fallback)": "URL безпечної сторінки (зовнішній fallback)",
  "Optional fallback, used only when no white page is selected above. Must be an absolute http(s) URL. Note: an external URL lives on another domain — exactly what triggers Google’s “destination mismatch”, so prefer a white page for paid search.": "Необов'язковий fallback, що використовується лише якщо вище не вибрано жодної white page. Має бути абсолютним URL http(s). Примітка: зовнішній URL знаходиться на іншому домені — саме це викликає помилку «destination mismatch» у Google, тому для платного пошуку краще використовуйте white page.",
  "Select a white page or enter a valid http(s) Safe page URL for cloaking": "Виберіть white page або введіть коректний URL http(s) безпечної сторінки для клоакінгу",
  "The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.": "Готове до копіювання трекінгове посилання для цієї кампанії. Замініть домен на будь-який верифікований домен воркспейсу, щоб використовувати кілька доменів в одній кампанії; рекламна мережа підставляє плейсхолдери в момент кліку.",
  "Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.": "Секрет для автентифікації вхідних постбеків цієї кампанії. Вставте його як &token=… у URL постбеків, які ви передаєте мережі. Тримайте його в таємниці — будь-хто, хто його має, може реєструвати конверсії.",
  "Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.": "Перетворює «сирі» статуси, які надсилає мережа, на наші категорії. Пріоритет: параметр у URL > мапа цієї кампанії > пресет партнерської мережі > кастомні типи > вбудовані значення за замовчуванням.",
  "Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.": "Вихідні виклики, що сповіщають іншу систему (ваше джерело трафіку, інший трекер, Telegram) про нову конверсію. Для CAPI рекламних платформ (Facebook/Google/TikTok) використовуйте натомість Conversion forwarders — з хешуванням персональних даних і повторними спробами.",
  "The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.": "Назва параметра рядка запиту у вашому трекінговому посиланні — має бути безпечною для URL: літери, цифри та _ (без пробілів). Пробіли автоматично замінюються на _, тому в посиланні ніколи не з'явиться %20.",
  "UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.": "Боти, визначені за UA-патерном, та UA, що імітують пошукового краулера (невдала перевірка DNS), отримують безпечну сторінку.",
  "DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.": "Верифіковані через DNS пошукові краулери (Googlebot/Bingbot/…) отримують безпечну сторінку. Вимкніть, щоб дозволити їм індексувати реальний офер.",
  "Visitors from datacenter or Tor-exit IPs get the safe page.": "Відвідувачі з IP дата-центрів або вихідних вузлів Tor отримують безпечну сторінку.",
  "Visitors behind a proxy/VPN get the safe page.": "Відвідувачі за proxy/VPN отримують безпечну сторінку.",
  "Works only when an active Google Ads forwarder exists (simple mode or with a conversion tag). The AW-…/label can be passed per click via the tm parameter, so one campaign credits conversions to different accounts.": "Працює лише за наявності активного Google Ads forwarder (простий режим або з тегом конверсії). AW-…/label можна передавати на кожен клік через параметр tm, завдяки чому одна кампанія зараховує конверсії на різні акаунти.",
  "Fire Google Ads gtag on redirect (click-time conversion)": "Надсилати Google Ads gtag при редиректі (конверсія в момент кліку)",
  "Fires a Google Ads conversion at the click moment (on /r/, before the offer) from the AW-…/label in the {tm} parameter — no forwarder needed. This optimizes Google on CLICKS, not on registrations/deposits.": "Надсилає конверсію Google Ads у момент кліку (на /r/, до оферу) на основі AW-…/label з параметра {tm} — forwarder не потрібен. Це оптимізує Google за КЛІКАМИ, а не за реєстраціями/депозитами.",
  "Click-time signal: the conversion fires for every clean click, so Google optimizes on clicks. To optimize on real registrations/deposits keep this OFF and use the \"Google Ads\" button under Forwarding — S2S postbacks (fires on the broker postback by {gclid}). Leaving both on double-counts.": "Сигнал у момент кліку: конверсія зараховується для кожного чистого кліку, тому Google оптимізує за кліками. Щоб оптимізувати за реальними реєстраціями/депозитами, залиште це ВИМКНЕНИМ і використовуйте кнопку «Google Ads» у розділі Forwarding — S2S постбеки (надсилаються при постбеку брокера за {gclid}). Якщо увімкнути обидва — конверсії рахуватимуться двічі.",
  "Bot model": "Модель ботів",
  "Member access": "Доступ учасників",
  "Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.": "Визначте, що кожен учасник команди може бачити та редагувати — для кожної сутності окремо, а також які метрики звітів він може переглядати. Власники та адміністратори обмеженням не підлягають.",
  "Member": "Учасник",
  "Choose a member…": "Оберіть учасника…",
  "Failed to load members": "Не вдалося завантажити учасників",
  "Retry": "Повторити",
  "No team members yet": "Учасників команди ще немає",
  "Invite teammates from the Workspace page, then configure their access here.": "Запросіть учасників зі сторінки Workspace, а потім налаштуйте їхній доступ тут.",
  "Pick a member to configure": "Оберіть учасника для налаштування",
  "Their entity access and allowed report metrics will show up here.": "Тут відображатиметься доступ до сутностей та дозволені метрики звітів.",
  "Failed to load member access": "Не вдалося завантажити доступ учасника",
  "Owners and admins have full, unrestricted access": "Власники та адміністратори мають повний, необмежений доступ",
  "You can still save these rules, but they stay inert unless the role changes to manager or viewer.": "Ви можете зберегти ці правила, але вони залишатимуться неактивними, доки роль не зміниться на менеджера або глядача.",
  "Entity access": "Доступ до сутностей",
  "Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.": "Повний — значення за замовчуванням: без обмежень. Лише читання блокує редагування. До вибраних обмежує учасника вказаними ID. Створені та вибрані додає все, що учасник створив самостійно.",
  "Entity": "Сутність",
  "Access mode": "Режим доступу",
  "Allowed IDs": "Дозволені ID",
  "Full": "Повний",
  "Read-only": "Лише читання",
  "To selected": "До вибраних",
  "Created and selected": "Створені та вибрані",
  "IDs, comma or space separated": "ID через кому або пробіл",
  "IDs of the specific items this member may access": "ID конкретних елементів, до яких цей учасник має доступ",
  "No IDs yet — the member will only see items they created themselves.": "ID ще немає — учасник бачитиме лише елементи, які створив сам.",
  "No IDs yet — the member will not see any items of this type.": "ID ще немає — учасник не бачитиме жодних елементів цього типу.",
  "All items": "Усі елементи",
  "Allowed report metrics": "Дозволені метрики звітів",
  "Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.": "Увімкніть або вимкніть метрики, які цей учасник може бачити у звітах і дашбордах. Якщо жодну метрику не вибрано, обмежень немає.",
  "All metrics (no restriction)": "Усі метрики (без обмежень)",
  "metrics allowed": "дозволених метрик",
  "Clear (allow all)": "Очистити (дозволити всі)",
  "Save access": "Зберегти доступ",
  "Member access saved": "Доступ учасника збережено",
  "Failed to save member access": "Не вдалося зберегти доступ учасника",
  "Click traces": "Трейси кліків",
  "Diagnostics": "Діагностика",
  "Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.": "Вибірка реальних кліків із повним рішенням маршрутизації для кожного — які потоки оцінювались і чому переміг саме цей.",
  "Pick a campaign above to inspect where its real clicks were routed and why.": "Оберіть кампанію вище, щоб перевірити, куди спрямовувались її реальні кліки і чому.",
  "Live-click tracing": "Трейсинг кліків у реальному часі",
  "Enable live-click tracing": "Увімкнути трейсинг кліків у реальному часі",
  "Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.": "Вимкнено за замовчуванням. Після увімкнення вибрана частка реальних кліків записує повний трейс маршрутизації. Безпечно для приватності: IP-адреси та user agent не зберігаються, а трейси видаляються автоматично.",
  "Sample rate (%)": "Частка вибірки (%)",
  "Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.": "Частка кліків для трейсингу, від 0 до 100%. Наприклад: 10% — приблизно кожен десятий клік.",
  "Sample rate must be between 0 and 100": "Частка вибірки має бути від 0 до 100",
  "Trace settings saved": "Налаштування трейсингу збережено",
  "Error loading click traces": "Помилка завантаження трейсів кліків",
  "Could not load traces": "Не вдалося завантажити трейси",
  "Something went wrong while loading click traces for this campaign.": "Під час завантаження трейсів кліків для цієї кампанії сталася помилка.",
  "No traces yet": "Трейсів ще немає",
  "Enable tracing above; traces of sampled real clicks will appear here.": "Увімкніть трейсинг вище; тут з'являться трейси вибіркових реальних кліків.",
  "Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.": "Трейсинг увімкнено — трейси вибіркових реальних кліків з'являтимуться тут у міру надходження трафіку. Якщо нічого не відображається, перевірте частоту вибірки.",
  "Flags": "Прапорці",
  "Show routing trace": "Показати трейс роутингу",
  "Hide routing trace": "Приховати трейс роутингу",
  "Per-stream verdicts": "Вердикти по потоках",
  "No per-stream verdicts were recorded for this click.": "Для цього кліку не записано жодних вердиктів по потоках.",
  "Not matched": "Не збіглося",
  "Filters evaluated": "Перевірені фільтри",
  "Relation": "Відношення",
  "Page": "Сторінка",
  "entries": "записів",
  "just now": "щойно",
  "{n}m ago": "{n}хв тому",
  "{n}h ago": "{n}год тому",
  "ML bot model": "ML-модель ботів",
  "Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.": "Класифікатор ботів на основі слабкого навчання: тренуйте на останніх кліках, перевіряйте метрики та оцінюйте довільні payload-и. Лише тіньовий режим — ніколи не впливає на живий роутинг.",
  "Admin access required": "Потрібен доступ адміністратора",
  "The ML bot-model panel is only available to workspace admins.": "Панель ML-моделі ботів доступна лише адміністраторам воркспейсу.",
  "Error loading bot-model status": "Помилка завантаження статусу моделі ботів",
  "Model status": "Статус моделі",
  "Trained": "Натренована",
  "Not trained": "Не натренована",
  "Inference": "Інференс",
  "Degenerate": "Вироджена",
  "Trained on a single class or too few samples — metrics are not meaningful.": "Натренована на одному класі або занадто малій кількості зразків — метрики не є показовими.",
  "Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.": "Інференс вимкнено за замовчуванням і працює лише в тіньовому режимі — навіть після увімкнення результати лише записуються на кліках для аналізу і ніколи не впливають на роутинг.",
  "Accuracy": "Точність",
  "Positive rate": "Частка позитивних",
  "Log loss": "Log loss",
  "AUC": "AUC",
  "Training samples": "Тренувальні зразки",
  "Trained at": "Натреновано",
  "No bot model trained yet. Train one on recent clicks below.": "Модель ботів ще не натренована. Натренуйте її нижче на останніх кліках.",
  "Train model": "Тренувати модель",
  "Training…": "Тренування…",
  "Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.": "Тренування завантажує до 5 000 останніх кліків, слабко розмічає їх за допомогою наявних евристик ботів (user agent, унікальність, поведінковий скор) та навчає невелику модель логістичної регресії. Повторне тренування замінює збережену модель.",
  "Model trained on {n} clicks — accuracy {acc}": "Модель натренована на {n} кліках — точність {acc}",
  "Model trained on {n} clicks": "Модель натренована на {n} кліках",
  "No click data to train on yet.": "Даних кліків для тренування ще немає.",
  "Training finished": "Тренування завершено",
  "Training failed": "Помилка тренування моделі",
  "Score a sample": "Оцінити зразок",
  "Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.": "Інструмент для розробника: вставте JSON-payload у форматі кліку та запустіть його через навчену модель. Нічого не зберігається, живий трафік не зачіпається.",
  "Click payload (JSON)": "Click payload (JSON)",
  "Score": "Оцінити",
  "Scoring…": "Оцінювання…",
  "Reset example": "Скинути приклад",
  "Invalid JSON — check the payload and try again.": "Невалідний JSON — перевірте payload і спробуйте ще раз.",
  "Payload must be a JSON object.": "Payload має бути об'єктом JSON.",
  "No trained model — train one first.": "Немає навченої моделі — спочатку навчіть її.",
  "Scoring failed": "Помилка оцінювання",
  "Likely bot": "Схоже на бота",
  "Likely human": "Схоже на людину",
  "Threshold 0.5 — scores above are flagged as bots.": "Поріг 0.5 — результати вище позначаються як боти.",
  "Heuristic weak label": "Слабка евристична мітка",
  "Human": "Людина",
  "Feature": "Ознака",
  "{n} min ago": "{n} хв тому",
  "{n} h ago": "{n} год тому",
  "{n} d ago": "{n} д тому",
  "Archive & restore": "Архівування та відновлення",
  "Access control": "Контроль доступу",
  "Offer rotation on daily cap": "Ротація офера при досягненні денного ліміту",
  "No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.": "Поріг не потрібен. Це правило спрацьовує, коли будь-який офер, що використовується кампанією, досягає свого денного ліміту, і сповіщає вас про те, що трафік ротується на резервний / решту офферів. Встановіть ліміт і резервний офер для кожного офера окремо.",
  "Connection types": "Типи з'єднання",
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Фільтрувати за типом мережевого з'єднання. 'hosting' (датацентр/хмара) працює одразу; інші значення, як-от cellular або wifi, вимагають, щоб edge-проксі надсилало заголовок X-Connection-Type.",
  "Status mapping": "Маппінг статусів",
  "Add status": "Додати статус",
  "No status mappings added": "Маппінги статусів не додано",
  "Network status (e.g. ftd)": "Статус мережі (напр. ftd)",
  "Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.": "Зіставте сирий статус, який надсилає ця мережа, з канонічним бакетом. Застосовується до вхідних постбеків, якщо мапа статусів кампанії не збігається.",
  "Lead": "Лід",
  "Sale": "Продаж",
  "Reject": "Відхилити",
  "Upsell": "Upsell",
  "Ignore": "Ігнорувати",
  "Split testing": "Split testing",
  "Parameter filters": "Фільтри параметрів",
  "Params": "Параметри",
  "Split testing enabled": "Split testing увімкнено",
  "Split testing disabled": "Split testing вимкнено",
  "Failed to update campaign": "Не вдалося оновити кампанію",
  "Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.": "Ротація потоків. Увімкнено: потоки Normal ротуються за вагою, позиція ігнорується. Вимкнено: потоки перевіряються зверху вниз за позицією, і перший збіг отримує весь трафік. Потоки Catch завжди перехоплюють першими і ніколи не ротуються за вагою.",
  "Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.": "Маршрутизація за sub-параметрами URL. Одне правило на рядок: name=value1, value2 дозволяє вказані значення; name!=value1, value2 блокує їх (відсутній параметр проходить блокуюче правило). Правило без значень не додає жодного обмеження.",
  "Regions": "Регіони",
  "GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.": "Назви регіону / штату / області з GeoIP (напр. California, Bavaria). Підтримуються маски, /regex/ та @empty.",
  "IP addresses": "IP-адреси",
  "Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.": "Точні IP, CIDR-блоки (10.0.0.0/8) або маски (192.168.*). Зручно для додавання власних тестових IP до білого списку або блокування діапазону датацентру.",
  "User agents": "User agent'и",
  "Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.": "Підрядки, маски або /regex/, що зіставляються з raw User-Agent — напр., *Chrome/12* охоплює Chrome 120+, HeadlessChrome виявляє headless-браузери.",
  "Clicks per hour": "Кліки за годину",
  "Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.": "Ліміт у ковзному вікні: потік перестає приймати НОВІ кліки після досягнення цієї кількості за останню годину, трафік переходить до наступного потоку. Порожньо = без ліміту.",
  "Clicks per 24h": "Кліки за 24 год",
  "Rolling-window limit over the last 24 hours. Empty = no limit.": "Ліміт у ковзному вікні за останні 24 години. Порожньо = без ліміту.",
  "Filter relation": "Відношення фільтрів",
  "AND: the click must pass every configured filter. OR: any single passing filter admits the click.": "AND: клік має пройти кожен налаштований фільтр. OR: достатньо, щоб клік пройшов хоча б один фільтр.",
  "AND (all)": "AND (всі)",
  "OR (any)": "OR (будь-який)",
  "Is": "Є",
  "Is not": "Не є",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Дні тижня та години, коли потік активний. Час вказано в часовому поясі власника кампанії. «Не є» інвертує розклад: потік приймає кліки КРІМ зазначених часових проміжків.",
  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Довільна текстова мітка мережі лише для нотаток і фільтрів — не має жодного ефекту. Для реального зв'язку використовуйте поле «Партнерська мережа» або блок Affiliate routing нижче.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Багаторазова партнерська мережа з розділу Affiliate networks: шаблон постбеку, параметри офера та звіти по мережі. Необов'язково.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "Куди переходить клік при звичайному редиректному офері. Підтримуються макроси: {click_id}, {country_code}, {gclid} та інші. Для форм-офферів (лід до CRM) URL може бути будь-яким.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Максимальна кількість конверсій на офер на день. Після досягнення ліміту трафік переходить до резервного офера. Порожньо = без ліміту.",
  "Time zone in which the daily cap is counted and the counter resets.": "Часовий пояс, у якому відраховується денний ліміт і скидається лічильник.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Резервний офер: трафік переходить сюди, коли основний офер досягає денного ліміту.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "Партнер/CRM, до якого надсилається лід. Налаштовується один раз у розділі Integrations (TrackBox або Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "Box/Goal ID офера у партнера — який продукт/box отримує лід. Значення надає партнер (напр., 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Частка лідів для цього партнера за наявності кількох (split/ротація). Напр., 70 і 30 = 70% і 30%.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Вимкнено = партнер тимчасово пропускається (напр., до узгодження запуску); його налаштування зберігаються.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Ендпоінт форми, прив'язаний виключно до ЦЬОГО офера. Зазвичай НЕ потрібен — використовуйте спільний /api/lead (див. документацію). Лише для прив'язки форми до конкретного офера.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Telegram-сповіщення при КОЖНОМУ надсиланні форми (прийнято/відхилено/тест). Окремо від Telegram-постбеку кампанії (він спрацьовує при підтвердженій конверсії). Токен бота з @BotFather; Chat ID групи починається з -100…",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "URL за замовчуванням, якщо жоден потік не підійшов. Маршрутизація зазвичай визначається потоками — це поле є запасним варіантом.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "Рекламна платформа (Google Ads, Facebook…). Визначає набір макросів/sub-параметрів, що додаються до трекінгового посилання для передачі даних кліку.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Спосіб підрахунку витрат: CPC — за клік, CPM — за 1000 показів, CPA — за конверсію. Впливає на Cost / ROI / CPC / CPA у звітах.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "Назва GET-параметра, яким трекер додає click_id до URL офера (наприклад, click_id → ?click_id=…). Потрібно, щоб партнер повернув цей click_id у постбеку. Сніпети форм зчитують як click_id, так і clickid.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "Не встановлювати cookie xpnsr_vid (для мереж, що забороняють cookies). Унікальність тоді визначається за IP+User Agent, а click_id передається через URL — поле Click ID forward parameter вище.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "Хешувати IP перед збереженням (для GDPR). GEO визначається ДО хешування, тому таргетинг за країною/містом не порушується.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Спосіб редиректу: 302 — звичайний швидкий редирект; Meta refresh / JS — коли мережа не слідує за 302 або потрібен gtag; Cloaked (iframe) — приховує URL офера в адресному рядку.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — звичайний потік із фільтрами; Catch — перехоплює трафік, що не підійшов жодному Normal-потоку; Default — потік останнього шансу, коли нічого не збіглося.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Пріоритет перевірки. Чим менше число, тим раніше перевіряється потік. Трафік потрапляє до першого відповідного.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "Коли кілька потоків мають однаковий тип — розподіл трафіку між ними. Наприклад, 70 і 30 = 70% і 30%.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Максимальна кількість кліків для цього потоку. Після досягнення ліміту потік перестає приймати трафік. Порожньо = без обмежень.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — перенаправити на лендинг/офер потоку; Action — спеціальна відповідь (наприклад, 404 / порожня відповідь для антифроду); Split test — розподіл між варіантами.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Фільтр за унікальністю візиту: лише унікальні / лише повторні / не фільтрувати.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Як обробляти ботів (визначаються за User-Agent): не фільтрувати / лише боти / виключити ботів. Зручно для антифрод-потоку.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Фільтр proxy/VPN (датацентр/Tor): не фільтрувати / лише proxy / виключити proxy.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Дозволити лише IPv4 або лише IPv6, або не фільтрувати.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Дні тижня та години, коли потік активний. Час вказано в часовому поясі власника кампанії.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Готовий пресет платформи (Google Ads, Facebook…) — заповнює назву, стандартні макроси/sub-параметри та S2S постбек для цього джерела трафіку.",
  "Search templates…": "Пошук шаблонів…",
  "All categories": "Всі категорії",
  "Templates in catalog": "Шаблони в каталозі",
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "Необов'язково. Вихідний постбек ДО рекламної мережі при конверсії — щоб платформа могла оптимізувати кампанії зі свого боку (наприклад, застарілий Facebook CAPI).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Параметри, які платформа передає у кліку (sub1…subN, gclid, tm тощо). Вони стають макросами, відображаються у звітах і додаються до трекінгового посилання.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — типізований адаптер для їхнього API. Custom API — для будь-якої іншої CRM: ви налаштовуєте запит самостійно (URL, заголовки, body, звідки читати redirect).",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "Секретний ключ Push/Registration партнера. Знайдіть його в панелі партнера (розділ API / API Testing) або запитайте у свого affiliate manager.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Ваш Affiliate ID у партнера. Надається партнером.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Campaign ID у партнера. Зазвичай 1, якщо не вказано інше.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "Сирі статуси мережі, що трактуються як LEAD (реєстрація). Розділяйте комами. Напр.: new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "Сирі статуси, що трактуються як SALE/депозит. Напр.: ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Статуси відхилення / поганої якості. Напр.: bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Ці статуси мовчки ігноруються — не записуються як конверсії. Напр.: spam, junk, test.",
  "Dashboard": "Дашборд",
  "Campaigns": "Кампанії",
  "Landing pages": "Лендинги",
  "Offers": "Офери",
  "Sources": "Джерела",
  "Report": "Звіт",
  "Group clicks and conversions by any dimension with full metrics.": "Групуйте кліки та конверсії за будь-яким виміром із повним набором метрик.",
  "Grouped by": "Групування за",
  "No data for this period.": "Немає даних за цей період.",
  "Empty ref.": "Порожній ref.",
  "Group": "Група",
  "— no level —": "— без рівня —",
  "Click a row to drill in": "Натисніть на рядок для деталізації",
  "Expand": "Розгорнути",
  "Collapse": "Згорнути",
  "Open in clicks log": "Відкрити в лозі кліків",
  "Failed to load": "Не вдалося завантажити",
  "Card view": "Вигляд карток",
  "Table view": "Вигляд таблиці",
  "Save view": "Зберегти вигляд",
  "Save current view": "Зберегти поточний вигляд",
  "Saved views": "Збережені вигляди",
  "Delete view": "Видалити вигляд",
  "View saved": "Вигляд збережено",
  "View name": "Назва вигляду",
  "Remember the current filters, sort and layout under a name for one-click recall.": "Збережіть поточні фільтри, сортування та розмітку під назвою, щоб відновити їх одним кліком.",
  "e.g. Tier-1 by revenue": "напр. Tier-1 за доходом",
  "Upload pre-landing (ZIP)": "Завантажити прелендинг (ZIP)",
  "Upload a ZIP with your warm-up page. index.html is auto-detected.": "Завантажте ZIP зі своєю сторінкою прогріву. index.html визначається автоматично.",
  "ZIP file": "ZIP-файл",
  "Pre-landing uploaded": "Прелендинг завантажено",
  "Upload failed": "Помилка завантаження",
  "Choose a ZIP file": "Оберіть ZIP-файл",
  "Uploaded": "Завантажено",
  "Uploading…": "Завантаження…",
  "Columns": "Колонки",
  "Receiving conversions (incoming postback)": "Отримання конверсій (вхідний постбек)",
  "Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.": "Вставте ці URL у свою партнерську мережу (наприклад, TrackBox), щоб вона надсилала сповіщення про конверсії до цієї кампанії. Передайте свій click_id у параметрі мережі — і він повернеться сюди.",
  "Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.": "Зіставте «сирі» статуси мережі з нашими (через кому). Працює для будь-якої мережі та застосовується до кожного вхідного постбеку цієї кампанії. Inline-параметри URL мають пріоритет.",
  "Forwarding — S2S postbacks": "Пересилання — S2S постбеки",
  "Landing click": "Клік на лендинг",
  "Time on landing": "Час на лендингу",
  "sec": "сек",
  "OS": "OS",
  "ISP / provider": "ISP / провайдер",
  "Proxy": "Proxy",
  "Empty referrer": "Порожній referrer",
  "Bots": "Боти",
  "Only bots": "Тільки боти",
  "Exclude bots": "Виключити ботів",
  "Proxy / VPN": "Proxy / VPN",
  "Only proxy": "Тільки proxy",
  "Exclude proxy": "Виключити proxy",
  "IP version": "Версія IP",
  "Show 404": "Показати 404",
  "Do nothing": "Нічого не робити",
  "Schedule": "Розклад",
  "Add interval": "Додати інтервал",
  "Every day, all day": "Щодня, цілодобово",
  "Every day": "Щодня",
  "Error loading affiliate networks": "Помилка завантаження партнерських мереж",
  "Quick start from preset": "Швидкий старт із пресету",
  "Affiliate network name": "Назва партнерської мережі",
  "Vertical": "Вертикаль",
  "Postback URL template": "Шаблон URL постбеку",
  "Outbound postback the tracker calls to notify this network.": "Вихідний постбек, який трекер викликає для сповіщення цієї мережі.",
  "Offer parameters": "Параметри офера",
  "Key": "Ключ",
  "Notes": "Нотатки",
  "Internal notes": "Внутрішні нотатки",
  "Affiliate networks": "Партнерські мережі",
  "Reusable partner networks: postback template, offer params and inbound URL.": "Багаторазові партнерські мережі: шаблон постбеку, параметри офера та вхідний URL.",
  "Create network": "Створити мережу",
  "Create affiliate network": "Створити партнерську мережу",
  "Pick a preset or configure a partner network from scratch.": "Оберіть пресет або налаштуйте партнерську мережу з нуля.",
  "Search networks": "Пошук мереж",
  "No affiliate networks yet": "Партнерських мереж ще немає",
  "Create one from a preset like TrackBox or Adcombo.": "Створіть одну з пресету, наприклад TrackBox або Adcombo.",
  "Postback copied": "Постбек скопійовано",
  "Inbound postback URL (paste in the network)": "URL вхідного постбеку (вставте в мережу)",
  "Inbound URL copied": "Вхідний URL скопійовано",
  "conv.": "конв.",
  "offer parameter(s)": "параметр(и) офера",
  "Edit affiliate network": "Редагувати партнерську мережу",
  "Update partner network settings": "Оновити налаштування партнерської мережі",
  "Delete affiliate network": "Видалити партнерську мережу",
  "This permanently deletes the network. Offers linked to it keep their other settings.": "Це назавжди видалить мережу. Офери, пов'язані з нею, збережуть інші налаштування.",
  "Affiliate network created": "Партнерську мережу створено",
  "Error creating affiliate network": "Помилка під час створення партнерської мережі",
  "Affiliate network updated": "Партнерську мережу оновлено",
  "Error updating affiliate network": "Помилка під час оновлення партнерської мережі",
  "Affiliate network deleted": "Партнерську мережу видалено",
  "Cannot delete: network is linked to offers": "Неможливо видалити: мережу пов'язано з оферами",
  "Error deleting affiliate network": "Помилка під час видалення партнерської мережі",
  "Copy failed": "Не вдалося скопіювати",
  "Network (text label)": "Мережа (текстова мітка)",
  "Traffic": "Трафік",
  "A/B Tests": "A/B Тести",
  "Anti-fraud": "Антифрод",
  "Analytics": "Аналітика",
  "Automation": "Автоматизація",
  "Integrations": "Інтеграції",
  "Settings": "Налаштування",
  "Account": "Акаунт",
  "My account": "Мій акаунт",
  "Profile": "Профіль",
  "Sign out": "Вийти",
  "User": "Користувач",
  "Welcome, {name}.": "Вітаємо, {name}.",
  "Welcome,": "Вітаємо,",
  "Real-time overview of your campaigns and stats": "Огляд кампаній і статистики в реальному часі",
  "Create campaign": "Створити кампанію",
  "Clicks": "Кліки",
  "Unique visitors": "Унікальні відвідувачі",
  "Conversions": "Конверсії",
  "Total active campaigns": "Усього активних кампаній",
  "Total clicks": "Усього кліків",
  "Unique clicks": "Унікальні кліки",
  "{rate}% conversion": "{rate}% конверсія",
  "Recent campaigns": "Останні кампанії",
  "Your latest campaigns": "Ваші найновіші кампанії",
  "You have no campaigns yet": "У вас ще немає кампаній",
  "Create your first campaign": "Створіть свою першу кампанію",
  "Quick actions": "Швидкі дії",
  "Commonly used features": "Функції, що використовуються найчастіше",
  "Add a new ad campaign": "Додати нову рекламну кампанію",
  "View detailed statistics": "Переглянути детальну статистику",
  "Manage campaigns": "Керування кампаніями",
  "Edit existing campaigns": "Редагування наявних кампаній",
  "Show all campaigns": "Показати всі кампанії",
  "More details": "Детальніше",
  "Active": "Активна",
  "Paused": "Призупинена",
  "No description": "Без опису",
  "{n} clicks": "{n} кліків",
  "{n} unique": "{n} унікальних",
  "{n} conversions": "{n} конверсій",
  "Loading workspace": "Завантаження робочого простору",
  "Loading your data…": "Завантаження ваших даних…",
  "Sign in": "Увійти",
  "Sign up": "Зареєструватися",
  "Email": "Email",
  "Work email": "Робочий email",
  "Password": "Пароль",
  "Full name": "Повне ім'я",
  "Jane Doe": "Іван Петренко",
  "Create account": "Створити акаунт",
  "Create new account": "Створити новий акаунт",
  "Already have an account?": "Вже маєте акаунт?",
  "Don't have an account?": "Немає акаунту?",
  "Welcome back": "З поверненням",
  "Sign in to your xpnsr account": "Увійдіть до свого акаунту xpnsr",
  "Attribution,": "Атрибуція,",
  "honest": "чесна",
  "Create": "Створити",
  "account": "акаунт",
  "S2S postback · bot shield": "Постбек S2S · захист від ботів",
  "Remember this device": "Запам'ятати цей пристрій",
  "Reset": "Скинути",
  "Access tracker": "Відкрити трекер",
  "Hide password": "Приховати пароль",
  "Show password": "Показати пароль",
  "At least 6 characters": "Щонайменше 6 символів",
  "Signing in…": "Вхід…",
  "Creating account…": "Створення акаунту…",
  "Invalid email or password": "Невірний email або пароль",
  "Registration failed. Please try again.": "Реєстрація не вдалася. Спробуйте ще раз.",
  "New registrations are disabled. Contact your workspace admin for an invitation.": "Нові реєстрації вимкнено. Зверніться до адміністратора робочого простору для отримання запрошення.",
  "Home": "Головна",
  "Auth": "Авторизація",
  "Book Demo": "Замовити демо",
  "Search campaigns, streams…": "Пошук кампаній, потоків…",
  "One visual language for the xpnsr.tech family.": "Єдина візуальна мова для сімейства xpnsr.tech.",
  "Control": "Контроль",
  "Operations": "Операції",
  "Precise tracking": "Точний трекінг",
  "KPIs, sources and leads in one panel.": "KPI, джерела трафіку та ліди в одній панелі.",
  "Readable reports": "Зрозумілі звіти",
  "Data visualization for fast decisions.": "Візуалізація даних для швидких рішень.",
  "Scale your team": "Масштабуйте команду",
  "Organize teams, campaigns and sources without friction.": "Організовуйте команди, кампанії та джерела без зайвих перешкод.",
  "Enter your credentials to continue.": "Введіть свої облікові дані, щоб продовжити.",
  "Create a new xpnsr.tech account.": "Створіть новий акаунт xpnsr.tech.",
  "Campaign management": "Управління кампаніями",
  "Create, edit and track your ad campaigns in real time": "Створюйте, редагуйте та відстежуйте свої рекламні кампанії в реальному часі",
  "Search campaigns…": "Пошук кампаній…",
  "Create new campaign": "Створити нову кампанію",
  "Edit campaign": "Редагувати кампанію",
  "Fill in the details of your new ad campaign": "Заповніть деталі нової рекламної кампанії",
  "Update campaign details": "Оновити деталі кампанії",
  "Campaign name": "Назва кампанії",
  "Description (optional)": "Опис (необов'язково)",
  "Target URL": "Цільовий URL",
  "Traffic source": "Джерело трафіку",
  "Cost model": "Модель оплати",
  "Select a traffic source (optional)": "Оберіть джерело трафіку (необов'язково)",
  "CPC (per click)": "CPC (за клік)",
  "CPM (per impression)": "CPM (за покази)",
  "CPA (per action)": "CPA (за дію)",
  "Cancel": "Скасувати",
  "Save changes": "Зберегти зміни",
  "Edit": "Редагувати",
  "Copy link": "Копіювати посилання",
  "Delete": "Видалити",
  "Are you sure you want to delete this campaign?": "Ви впевнені, що хочете видалити цю кампанію?",
  "Campaign created successfully!": "Кампанію успішно створено!",
  "Campaign updated successfully!": "Кампанію успішно оновлено!",
  "Campaign deleted successfully!": "Кампанію успішно видалено!",
  "No campaigns": "Немає кампаній",
  "Campaigns not found": "Кампанії не знайдено",
  "Create your first campaign to start tracking traffic": "Створіть свою першу кампанію, щоб почати відстежувати трафік",
  "Try adjusting search criteria": "Спробуйте змінити критерії пошуку",
  "Tracking ID": "Tracking ID",
  "Link copied to clipboard!": "Посилання скопійовано в буфер обміну!",
  "Failed to copy link": "Не вдалося скопіювати посилання",
  "Error loading campaigns": "Помилка завантаження кампаній",
  "Error creating campaign": "Помилка створення кампанії",
  "Error updating campaign": "Помилка оновлення кампанії",
  "Error deleting campaign": "Помилка видалення кампанії",
  "For example: Product A ad": "Наприклад: Реклама продукту A",
  "Short campaign description": "Короткий опис кампанії",
  "New landing page": "Новий лендинг",
  "Add landing page": "Додати лендинг",
  "Add a landing page for use in campaigns and A/B tests": "Додайте лендинг для використання в кампаніях та A/B тестах",
  "Edit landing page": "Редагувати лендинг",
  "Edit landing page settings": "Редагувати налаштування лендингу",
  "Search landing pages…": "Пошук лендингів…",
  "Create landing pages for use in campaigns": "Створюйте лендинги для використання в кампаніях",
  "No landing pages": "Немає лендингів",
  "Nothing found": "Нічого не знайдено",
  "Landing page created": "Лендинг створено",
  "Landing page updated": "Лендинг оновлено",
  "Landing page deleted": "Лендинг видалено",
  "Delete this landing page?": "Видалити цей лендинг?",
  "Error loading landing pages": "Помилка завантаження лендингів",
  "Error creating landing page": "Помилка створення лендингу",
  "Error updating landing page": "Помилка оновлення лендингу",
  "Error deleting landing page": "Помилка видалення лендингу",
  "Please fill in name and URL": "Будь ласка, заповніть назву та URL",
  "URL copied": "URL скопійовано",
  "My landing": "Мій лендинг",
  "Landing page description": "Опис лендингу",
  "Lead generation": "Генерація лідів",
  "Subscription": "Підписка",
  "Download": "Завантаження",
  "Other": "Інше",
  "Category": "Категорія",
  "Select category": "Оберіть категорію",
  "Description": "Опис",
  "Tags": "Теги",
  "Add tag": "Додати тег",
  "Status": "Статус",
  "Inactive": "Неактивний",
  "Visits": "Візити",
  "CR": "CR",
  "Actions": "Дії",
  "Name": "Назва",
  "URL": "URL",
  "Save": "Зберегти",
  "Unique": "Унікальні",
  "Add offer": "Додати офер",
  "New offer": "Новий офер",
  "Edit offer": "Редагувати офер",
  "Add an offer to use in campaigns": "Додайте офер для використання в кампаніях",
  "Change offer parameters": "Змінити параметри офера",
  "Search offers…": "Пошук оферів…",
  "No offers": "Немає оферів",
  "Create offers to monetize your traffic": "Створюйте офери для монетизації трафіку",
  "Offer created": "Офер створено",
  "Offer updated": "Офер оновлено",
  "Offer deleted": "Офер видалено",
  "Delete this offer?": "Видалити цей офер?",
  "Error loading offers": "Помилка завантаження оферів",
  "Error creating offer": "Помилка створення офера",
  "Error updating offer": "Помилка оновлення офера",
  "Error deleting offer": "Помилка видалення офера",
  "My offer": "Мій офер",
  "Offer URL": "URL офера",
  "Offer description": "Опис офера",
  "Affiliate network": "Партнерська мережа",
  "Network": "Мережа",
  "Payout": "Виплата",
  "Currency": "Валюта",
  "Geo": "GEO",
  "Countries (ISO codes, e.g. US, RU)": "Країни (коди ISO, напр. US, RU)",
  "Nutra": "Nutra",
  "Gambling": "Gambling",
  "Dating": "Dating",
  "Finance": "Фінанси",
  "Crypto": "Crypto",
  "Sweepstakes": "Sweepstakes",
  "Back": "Назад",
  "Streams": "Потоки",
  "Open target URL": "Відкрити цільовий URL",
  "Copy tracking link": "Копіювати трекінгове посилання",
  "Tracking link copied!": "Трекінгове посилання скопійовано!",
  "Campaign not found": "Кампанію не знайдено",
  "Successful conversions": "Успішні конверсії",
  "Conversion rate": "Коефіцієнт конверсії",
  "Conversion percentage": "Відсоток конверсій",
  "Campaign info": "Інформація про кампанію",
  "Tracking link": "Трекінгове посилання",
  "Created": "Створено",
  "Updated": "Оновлено",
  "Recent clicks": "Останні кліки",
  "Recent activity for this campaign": "Остання активність цієї кампанії",
  "No clicks for this campaign yet": "Кліків для цієї кампанії ще немає",
  "Showing latest 10 clicks": "Показую останні 10 кліків",
  "Device breakdown": "Розбивка за пристроями",
  "Browser breakdown": "Розбивка за браузерами",
  "No data to display": "Немає даних для відображення",
  "Unknown": "Невідомо",
  "Traffic sources": "Джерела трафіку",
  "Create source": "Створити джерело",
  "Create traffic source": "Створити джерело трафіку",
  "Edit traffic source": "Редагувати джерело трафіку",
  "Update traffic source settings": "Оновити налаштування джерела трафіку",
  "Configure a traffic source for UTM tags and conversion postbacks": "Налаштуйте джерело трафіку для UTM-тегів і постбеків конверсій",
  "Source template": "Шаблон джерела",
  "Pick a template or create your own": "Оберіть шаблон або створіть власний",
  "Traffic source name": "Назва джерела трафіку",
  "Traffic source description": "Опис джерела трафіку",
  "Postback URL": "Postback URL",
  "Postback URL copied": "Postback URL скопійовано",
  "UTM parameters": "UTM-параметри",
  "Add parameter": "Додати параметр",
  "Enter parameter name:": "Введіть назву параметра:",
  "Parameter": "Параметр",
  "Alias": "Аліас",
  "Placeholder": "Placeholder",
  "Action": "Дія",
  "Source macro": "Макрос джерела",
  "No parameters added": "Параметри не додано",
  "Search traffic sources…": "Пошук джерел трафіку…",
  "Sources not found": "Джерела не знайдено",
  "No traffic sources": "Немає джерел трафіку",
  "Create sources to integrate with ad networks": "Створіть джерела для інтеграції з рекламними мережами",
  "Spend": "Витрати",
  "Parameters configured:": "Налаштовані параметри:",
  "Traffic source created": "Джерело трафіку створено",
  "Traffic source updated": "Джерело трафіку оновлено",
  "Traffic source deleted": "Джерело трафіку видалено",
  "Are you sure you want to delete this traffic source?": "Ви впевнені, що хочете видалити це джерело трафіку?",
  "Cannot delete: source is in use by campaigns": "Неможливо видалити: джерело використовується кампаніями",
  "Error loading traffic sources": "Помилка завантаження джерел трафіку",
  "Error creating traffic source": "Помилка створення джерела трафіку",
  "Error updating traffic source": "Помилка оновлення джерела трафіку",
  "Error deleting traffic source": "Помилка видалення джерела трафіку",
  "Preferences": "Налаштування",
  "Notifications": "Сповіщення",
  "System": "Система",
  "Profile information": "Інформація профілю",
  "Manage your basic account information": "Керуйте основною інформацією про акаунт",
  "Enter your full name": "Введіть ваше повне ім'я",
  "Enter your email": "Введіть вашу електронну пошту",
  "Save profile": "Зберегти профіль",
  "Change password": "Змінити пароль",
  "Update your password to keep your account secure": "Оновіть пароль, щоб захистити свій акаунт",
  "Current password": "Поточний пароль",
  "New password": "Новий пароль",
  "Confirm new password": "Підтвердіть новий пароль",
  "Enter current password": "Введіть поточний пароль",
  "Enter new password": "Введіть новий пароль",
  "New passwords do not match": "Нові паролі не збігаються",
  "New password must be at least 6 characters": "Новий пароль має містити щонайменше 6 символів",
  "Password changed successfully": "Пароль успішно змінено",
  "Profile updated successfully": "Профіль успішно оновлено",
  "Error updating profile": "Помилка оновлення профілю",
  "Error changing password": "Помилка зміни пароля",
  "Error loading settings": "Помилка завантаження налаштувань",
  "Error saving settings": "Помилка збереження налаштувань",
  "Error saving system settings": "Помилка збереження системних налаштувань",
  "User settings saved": "Налаштування користувача збережено",
  "System settings saved": "Системні налаштування збережено",
  "Interface preferences": "Налаштування інтерфейсу",
  "Customize the look and behavior of the app": "Налаштуйте вигляд і поведінку застосунку",
  "Timezone": "Часовий пояс",
  "Moscow (UTC+3)": "Москва (UTC+3)",
  "Kyiv (UTC+2)": "Київ (UTC+2)",
  "New York (UTC-5)": "Нью-Йорк (UTC-5)",
  "Language": "Мова",
  "Date format": "Формат дати",
  "Dashboard refresh rate (sec)": "Частота оновлення дашборду (сек)",
  "Save settings": "Зберегти налаштування",
  "Configure how you receive notifications": "Налаштуйте спосіб отримання сповіщень",
  "Email notifications": "Email-сповіщення",
  "SMS notifications": "SMS-сповіщення",
  "Get email notifications about important events": "Отримуйте email-сповіщення про важливі події",
  "Get SMS for critical events": "Отримуйте SMS про критичні події",
  "Save notification settings": "Зберегти налаштування сповіщень",
  "Tracking domains": "Трекінгові домени",
  "Configure domains for campaign tracking": "Налаштуйте домени для трекінгу кампаній",
  "Primary tracking domain": "Основний трекінговий домен",
  "Additional domains": "Додаткові домени",
  "Add domain": "Додати домен",
  "Add": "Додати",
  "Save domain settings": "Зберегти налаштування домену",
  "Security": "Безпека",
  "Security and access settings": "Налаштування безпеки та доступу",
  "Security settings": "Налаштування безпеки",
  "Coming in upcoming releases": "З'явиться в наступних версіях",
  "Active campaigns": "Активні кампанії",
  "Clicks today": "Кліки сьогодні",
  "For the current day": "За поточний день",
  "Confirmed": "Підтверджено",
  "Refresh": "Оновити",
  "Export": "Експорт",
  "Report exported": "Звіт експортовано",
  "Period:": "Період:",
  "Today": "Сьогодні",
  "7 days": "7 днів",
  "14 days": "14 днів",
  "30 days": "30 днів",
  "90 days": "90 днів",
  "Campaign:": "Кампанія:",
  "All campaigns": "Всі кампанії",
  "Overview": "Огляд",
  "Devices": "Пристрої",
  "Clicks and conversions": "Кліки та конверсії",
  "No data for the selected period": "Немає даних за вибраний період",
  "No data": "Немає даних",
  "Hourly activity": "Погодинна активність",
  "CR% by day": "CR% по днях",
  "Campaign stats": "Статистика кампаній",
  "Revenue": "Дохід",
  "No campaign data": "Немає даних по кампаніях",
  "Total revenue": "Загальний дохід",
  "Total spend": "Загальні витрати",
  "Profit": "Прибуток",
  "Net positive": "Чистий прибуток",
  "Net loss": "Чистий збиток",
  "Advanced notification preferences": "Розширені налаштування сповіщень",
  "Push notifications, webhook URL, alert categories": "Push-сповіщення, webhook URL, категорії алертів",
  "Configure": "Налаштувати",
  "All values shown in": "Всі значення показано в",
  "FX rates unavailable — non-USD revenue is excluded from the totals.": "Курси валют недоступні — дохід не в USD виключено із загальних сум.",
  "ROI by campaigns": "ROI по кампаніях",
  "No ROI data": "Немає даних ROI",
  "Clicks by country": "Кліки по країнах",
  "Geo table": "Таблиця GEO",
  "No geo data": "Немає даних GEO",
  "Country": "Країна",
  "Devices table": "Таблиця пристроїв",
  "Device type": "Тип пристрою",
  "Share": "Частка",
  "No device data": "Немає даних про пристрої",
  "Failed to load campaign": "Не вдалося завантажити кампанію",
  "Failed to load streams": "Не вдалося завантажити потоки",
  "Stream created": "Потік створено",
  "Failed to create stream": "Не вдалося створити потік",
  "Stream updated": "Потік оновлено",
  "Failed to update stream": "Не вдалося оновити потік",
  "Delete this stream?": "Видалити цей потік?",
  "Stream deleted": "Потік видалено",
  "Failed to delete stream": "Не вдалося видалити потік",
  "Catch": "Catch",
  "Fallback": "Fallback",
  "Normal": "Звичайний",
  "Stream name": "Назва потоку",
  "Stream type": "Тип потоку",
  "Position": "Позиція",
  "Weight (%)": "Вага (%)",
  "Click limit": "Ліміт кліків",
  "No limit": "Без ліміту",
  "Stream action": "Дія потоку",
  "Action type": "Тип дії",
  "Redirect": "Редирект",
  "Split test": "Split test",
  "Redirect URL": "URL редиректу",
  "Landings and offers": "Лендинги та офери",
  "Landings": "Лендинги",
  "No landings available": "Немає доступних лендингів",
  "No offers available": "Немає доступних оферів",
  "Traffic filters": "Фільтри трафіку",
  "Countries (ISO codes)": "Країни (коди ISO)",
  "Cities": "Міста",
  "Browsers": "Браузери",
  "Operating systems": "Операційні системи",
  "Languages": "Мови",
  "Don't filter": "Не фільтрувати",
  "Accept only unique": "Приймати лише унікальні",
  "Filter unique": "Фільтрувати унікальні",
  "Campaign streams": "Потоки кампанії",
  "Create stream": "Створити потік",
  "Configure stream for traffic distribution by conditions": "Налаштуйте потік для розподілу трафіку за умовами",
  "No streams": "Немає потоків",
  "Create streams to distribute traffic by conditions": "Створіть потоки для розподілу трафіку за умовами",
  "Weight": "Вага",
  "Bots filtered": "Боти відфільтровані",
  "Countries": "Країни",
  "Limit": "Ліміт",
  "Edit stream": "Редагувати потік",
  "Modify stream settings": "Змінити налаштування потоку",
  "Failed to load data": "Не вдалося завантажити дані",
  "Failed to load traffic rules": "Не вдалося завантажити правила трафіку",
  "Select a campaign": "Виберіть кампанію",
  "Traffic rule created": "Правило трафіку створено",
  "Failed to create rule": "Не вдалося створити правило",
  "Rule updated": "Правило оновлено",
  "Failed to update rule": "Не вдалося оновити правило",
  "Rule deleted": "Правило видалено",
  "Failed to delete rule": "Не вдалося видалити правило",
  "Landing created": "Лендинг створено",
  "Failed to create landing": "Не вдалося створити лендинг",
  "Failed to create offer": "Не вдалося створити офер",
  "Traffic management": "Управління трафіком",
  "Select campaign": "Виберіть кампанію",
  "Traffic rules": "Правила трафіку",
  "Traffic distribution rules": "Правила розподілу трафіку",
  "Create rule": "Створити правило",
  "Create traffic rule": "Створити правило трафіку",
  "Edit rule": "Редагувати правило",
  "Configure conditions and actions for traffic distribution": "Налаштуйте умови та дії для розподілу трафіку",
  "Rule name": "Назва правила",
  "Priority": "Пріоритет",
  "Rule description": "Опис правила",
  "Conditions (leave empty for any value)": "Умови (залиште порожнім для будь-якого значення)",
  "Update": "Оновити",
  "No traffic rules": "Немає правил трафіку",
  "Create rules to distribute traffic by conditions": "Створіть правила для розподілу трафіку за умовами",
  "Stopped": "Зупинено",
  "Any": "Будь-який",
  "Redirects": "Редиректи",
  "Select a campaign to manage traffic rules": "Виберіть кампанію для керування правилами трафіку",
  "Add landing": "Додати лендинг",
  "Add a new landing to the library": "Додати новий лендинг до бібліотеки",
  "Landing name": "Назва лендингу",
  "Landing description": "Опис лендингу",
  "No landings": "Немає лендингів",
  "Add landings to use in traffic rules": "Додайте лендинги для використання в правилах трафіку",
  "Add a new offer to monetize traffic": "Додайте новий офер для монетизації трафіку",
  "Offer name": "Назва офера",
  "Add offers to monetize traffic": "Додайте офери для монетизації трафіку",
  "A/B Testing": "A/B Тестування",
  "Create A/B test": "Створити A/B тест",
  "Set up split testing to optimize conversions": "Налаштуйте спліт-тестування для оптимізації конверсій",
  "Test name": "Назва тесту",
  "Landing page test": "Тест лендингу",
  "Test description": "Опис тесту",
  "Test type": "Тип тесту",
  "Traffic paths": "Потоки трафіку",
  "Confidence level (%)": "Рівень довіри (%)",
  "Minimum sample size": "Мінімальний розмір вибірки",
  "Test variants": "Варіанти тесту",
  "Add variant": "Додати варіант",
  "Variant {n}": "Варіант {n}",
  "Variant name": "Назва варіанту",
  "URL (or pick below)": "URL (або оберіть нижче)",
  "Pick landing page": "Обрати лендинг",
  "Pick offer": "Обрати офер",
  "Traffic weight (%)": "Вага трафіку (%)",
  "Total weight": "Загальна вага",
  "Create test": "Створити тест",
  "No A/B tests": "Немає A/B тестів",
  "Create split tests to optimize conversions": "Створіть спліт-тести для оптимізації конверсій",
  "Visitors": "Відвідувачі",
  "Significance": "Значущість",
  "Variants": "Варіанти",
  "Progress to minimum sample": "Прогрес до мінімальної вибірки",
  "A/B test results": "Результати A/B тесту",
  "Variant performance analysis": "Аналіз ефективності варіантів",
  "Conversion": "Конверсія",
  "Confidence interval": "Довірчий інтервал",
  "Not enough data for analysis": "Недостатньо даних для аналізу",
  "Close": "Закрити",
  "Running": "Активний",
  "Completed": "Завершено",
  "Draft": "Чернетка",
  "Delete this A/B test?": "Видалити цей A/B тест?",
  "A/B test deleted": "A/B тест видалено",
  "Failed to delete test": "Не вдалося видалити тест",
  "A/B test created": "A/B тест створено",
  "Failed to create A/B test": "Не вдалося створити A/B тест",
  "A/B test started": "A/B тест запущено",
  "Failed to start test": "Не вдалося запустити тест",
  "A/B test paused": "A/B тест призупинено",
  "Failed to pause test": "Не вдалося призупинити тест",
  "Failed to load results": "Не вдалося завантажити результати",
  "Failed to load A/B tests": "Не вдалося завантажити A/B тести",
  "At least 2 variants required": "Потрібно щонайменше 2 варіанти",
  "Webhooks": "Webhooks",
  "Import costs and conversions": "Імпорт витрат і конверсій",
  "Sync campaigns and conversions": "Синхронізація кампаній і конверсій",
  "Import ad statistics": "Імпорт рекламної статистики",
  "VKontakte integration": "Інтеграція з VKontakte",
  "Automatic traffic import": "Автоматичний імпорт трафіку",
  "Server-to-server postbacks": "Постбеки сервер-сервер",
  "Custom API integration": "Користувацька інтеграція API",
  "Telegram notifications": "Сповіщення Telegram",
  "Click": "Клік",
  "Campaign paused": "Кампанію призупинено",
  "Campaign started": "Кампанію запущено",
  "Fraud detected": "Виявлено фрод",
  "Threshold reached": "Досягнуто порогу",
  "Fill in type and name": "Заповніть тип і назву",
  "Integration created": "Інтеграцію створено",
  "Error creating": "Помилка створення",
  "Integration updated": "Інтеграцію оновлено",
  "Error updating": "Помилка оновлення",
  "Delete integration?": "Видалити інтеграцію?",
  "Integration deleted": "Інтеграцію видалено",
  "Error deleting": "Помилка видалення",
  "Fill in name and URL": "Заповніть назву та URL",
  "Webhook created": "Webhook створено",
  "Error creating webhook": "Помилка створення webhook",
  "Webhook updated": "Webhook оновлено",
  "Delete webhook?": "Видалити webhook?",
  "Webhook deleted": "Webhook видалено",
  "Test succeeded (HTTP {code})": "Тест успішний (HTTP {code})",
  "Test error: {detail}": "Помилка тесту: {detail}",
  "Error testing webhook": "Помилка тестування webhook",
  "Integration type": "Тип інтеграції",
  "Select type": "Оберіть тип",
  "Configuration (key-value)": "Конфігурація (ключ-значення)",
  "Key (e.g. api_key)": "Ключ (напр. api_key)",
  "Value": "Значення",
  "My webhook": "Мій webhook",
  "Secret (optional)": "Секрет (необов'язково)",
  "Events": "Події",
  "Retry attempts": "Кількість повторних спроб",
  "Timeout (sec)": "Таймаут (сек)",
  "Add integration": "Додати інтеграцію",
  "New integration": "Нова інтеграція",
  "Configure connection to an external service": "Налаштуйте підключення до зовнішнього сервісу",
  "No integrations": "Немає інтеграцій",
  "Connect external services to automate workflows": "Підключіть зовнішні сервіси для автоматизації процесів",
  "Connected": "Підключено",
  "Disconnected": "Відключено",
  "Last sync": "Остання синхронізація",
  "Add webhook": "Додати webhook",
  "New webhook": "Новий webhook",
  "Configure a webhook to receive notifications": "Налаштуйте webhook для отримання сповіщень",
  "No webhooks": "Немає webhooks",
  "Create webhooks to send events to external systems": "Створюйте webhooks для надсилання подій до зовнішніх систем",
  "Success": "Успішно",
  "Errors": "Помилки",
  "Test": "Тест",
  "Edit integration": "Редагувати інтеграцію",
  "Edit webhook": "Редагувати webhook",
  "Anti-fraud system": "Антифрод-система",
  "Filter created": "Фільтр створено",
  "Failed to create filter": "Не вдалося створити фільтр",
  "Filter updated": "Фільтр оновлено",
  "Failed to update filter": "Не вдалося оновити фільтр",
  "Filter deleted": "Фільтр видалено",
  "Failed to delete filter": "Не вдалося видалити фільтр",
  "IP added to blacklist": "IP додано до чорного списку",
  "IP added to whitelist": "IP додано до білого списку",
  "Failed to add IP": "Не вдалося додати IP",
  "IP removed from blacklist": "IP видалено з чорного списку",
  "IP removed from whitelist": "IP видалено з білого списку",
  "Failed to remove IP": "Не вдалося видалити IP",
  "Activity marked as resolved": "Активність позначено як вирішену",
  "Failed to update activity": "Не вдалося оновити активність",
  "Filters": "Фільтри",
  "IP lists": "Списки IP",
  "Suspicious activity": "Підозріла активність",
  "Statistics": "Статистика",
  "Fraud filters": "Антифрод-фільтри",
  "Create filter": "Створити фільтр",
  "Edit filter": "Редагувати фільтр",
  "Create fraud filter": "Створити антифрод-фільтр",
  "Configure automatic filters to block suspicious traffic": "Налаштуйте автоматичні фільтри для блокування підозрілого трафіку",
  "Filter name": "Назва фільтра",
  "Filter type": "Тип фільтра",
  "Bot detection": "Виявлення ботів",
  "Click frequency": "Частота кліків",
  "Country block": "Блокування за країною",
  "ASN block": "Блокування за ASN",
  "Datacenter / hosting block": "Блокування датацентрів / хостингу",
  "Proxy / VPN / Tor block": "Блокування proxy / VPN / Tor",
  "External risk score": "Зовнішній показник ризику",
  "Filter description": "Опис фільтра",
  "Max clicks per minute": "Макс. кліків на хвилину",
  "Blocked countries (ISO codes)": "Заблоковані країни (коди ISO)",
  "ASN numbers": "Номери ASN",
  "ASN name substrings": "Підрядки назви ASN",
  "Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).": "Номери AS через кому (напр. 16509 = AWS, 24940 = Hetzner).",
  "Case-insensitive substring match against the ASN label.": "Пошук підрядка в мітці ASN без урахування регістру.",
  "Allowed ASNs (whitelist)": "Дозволені ASN (whitelist)",
  "Optional. Datacenter IPs that match these ASNs / labels are not blocked.": "Необов'язково. IP датацентрів, що відповідають цим ASN / міткам, не блокуються.",
  "Block Tor exit nodes": "Блокувати вихідні вузли Tor",
  "Block proxies (requires API key)": "Блокувати proxy (потрібен ключ API)",
  "Block VPNs (requires API key)": "Блокувати VPN (потрібен ключ API)",
  "External provider": "Зовнішній провайдер",
  "Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.": "Вкажіть IPQS_API_KEY або FRAUDSCORE_API_KEY у середовищі бекенду.",
  "Risk score threshold (0-100)": "Поріг показника ризику (0-100)",
  "Block when the provider returns a score >= this threshold (default 85).": "Блокувати, якщо провайдер повертає значення >= цього порогу (за замовчуванням 85).",
  "Block": "Блокувати",
  "Log only": "Лише логувати",
  "No active filters": "Немає активних фільтрів",
  "Create filters for automatic fraud protection": "Створіть фільтри для автоматичного захисту від фроду",
  "Blocked": "Заблоковано",
  "False positives": "Хибні спрацювання",
  "IP blacklist": "Чорний список IP",
  "IP whitelist": "Білий список IP",
  "Blacklist is empty": "Чорний список порожній",
  "Whitelist is empty": "Білий список порожній",
  "Blocked: {n} times": "Заблоковано: {n} разів",
  "View blocked samples": "Переглянути заблоковані зразки",
  "Blocked samples": "Заблоковані зразки",
  "Blocked samples: {name}": "Заблоковані зразки: {name}",
  "Most recent traffic caught by this filter. Use it to spot false positives.": "Найновіший трафік, спійманий цим фільтром. Використовуйте для виявлення хибних спрацювань.",
  "No blocked samples yet": "Заблокованих зразків ще немає",
  "Failed to load blocked samples": "Не вдалося завантажити заблоковані зразки",
  "(empty UA)": "(порожній UA)",
  "Add IP to blacklist": "Додати IP до чорного списку",
  "Add IP to whitelist": "Додати IP до білого списку",
  "IP address": "IP-адреса",
  "Reason": "Причина",
  "Reason for adding": "Причина додавання",
  "Notes (optional)": "Нотатки (необов'язково)",
  "Additional information": "Додаткова інформація",
  "No suspicious activity detected": "Підозрілої активності не виявлено",
  "The system automatically tracks suspicious actions": "Система автоматично відстежує підозрілі дії",
  "Resolved": "Вирішено",
  "Mark as resolved": "Позначити як вирішене",
  "User Agent": "User Agent",
  "Time": "Час",
  "Details": "Деталі",
  "Active filters": "Активні фільтри",
  "Blocked IPs": "Заблоковані IP",
  "Failed to load automation rules": "Не вдалося завантажити правила автоматизації",
  "Automation rule created": "Правило автоматизації створено",
  "Failed to create automation rule": "Не вдалося створити правило автоматизації",
  "Automation rule updated": "Правило автоматизації оновлено",
  "Failed to update automation rule": "Не вдалося оновити правило автоматизації",
  "Are you sure you want to delete this rule?": "Ви впевнені, що хочете видалити це правило?",
  "Automation rule deleted": "Правило автоматизації видалено",
  "Failed to delete automation rule": "Не вдалося видалити правило автоматизації",
  "Rule activated": "Правило активовано",
  "Rule deactivated": "Правило деактивовано",
  "Failed to change rule status": "Не вдалося змінити статус правила",
  "Notification settings saved": "Налаштування сповіщень збережено",
  "Failed to save notification settings": "Не вдалося зберегти налаштування сповіщень",
  "Pause campaign": "Призупинити кампанію",
  "Budget alert": "Сповіщення про бюджет",
  "Performance alert": "Сповіщення про ефективність",
  "Rules": "Правила",
  "Automation rules": "Правила автоматизації",
  "Create automation rule": "Створити правило автоматизації",
  "Configure automatic actions based on conditions": "Налаштуйте автоматичні дії на основі умов",
  "Rule type": "Тип правила",
  "Trigger conditions": "Умови спрацювання",
  "Maximum cost per click": "Максимальний CPC",
  "Minimum CR (%)": "Мінімальний CR (%)",
  "Budget percentage for alert": "Відсоток бюджету для сповіщення",
  "Execution settings": "Налаштування виконання",
  "Interval between executions (min)": "Інтервал між виконаннями (хв)",
  "Maximum executions per day": "Максимальна кількість виконань на день",
  "No automation rules": "Немає правил автоматизації",
  "Create rules to automatically manage campaigns": "Створіть правила для автоматичного керування кампаніями",
  "Executions": "Виконання",
  "Interval": "Інтервал",
  "{n} min": "{n} хв",
  "Daily limit": "Денний ліміт",
  "Last execution": "Останнє виконання",
  "Notification channels": "Канали сповіщень",
  "Receive notifications by email": "Отримувати сповіщення електронною поштою",
  "Receive SMS for critical events": "Отримувати SMS про критичні події",
  "Push notifications": "Push-сповіщення",
  "Browser notifications": "Сповіщення браузера",
  "Webhook URL": "Webhook URL",
  "Manage how and when you receive alerts": "Керуйте тим, як і коли ви отримуєте сповіщення",
  "Save preferences": "Зберегти налаштування",
  "Saving…": "Збереження…",
  "Delivery channels": "Канали доставки",
  "Choose how to receive notifications": "Оберіть спосіб отримання сповіщень",
  "Receive alerts via email": "Отримувати сповіщення електронною поштою",
  "Critical alerts via SMS": "Критичні сповіщення через SMS",
  "In-app and browser push": "Push у застосунку та браузері",
  "POST JSON payloads to your endpoint": "Надсилати POST-запити з JSON на ваш endpoint",
  "Alert categories": "Категорії сповіщень",
  "Choose which types of events trigger notifications": "Оберіть, які типи подій запускають сповіщення",
  "Campaign alerts": "Сповіщення кампаній",
  "Paused, resumed, daily cap reached": "Призупинено, відновлено, досягнуто денний ліміт",
  "Performance alerts": "Сповіщення про ефективність",
  "ROI drop, conversion rate change, EPC decline": "Падіння ROI, зміна CR, зниження EPC",
  "Fraud alerts": "Сповіщення про фрод",
  "Suspicious clicks, bot traffic, IP blacklist hits": "Підозрілі кліки, трафік ботів, потрапляння до чорного списку IP",
  "System alerts": "Системні сповіщення",
  "Domain verification, TLS expiry, billing": "Верифікація домену, закінчення терміну TLS, білінг",
  "Notification preferences saved": "Налаштування сповіщень збережено",
  "Failed to load notification settings": "Не вдалося завантажити налаштування сповіщень",
  "CSV exported": "CSV експортовано",
  "Export campaigns to CSV": "Експортувати кампанії до CSV",
  "Export offers to CSV": "Експортувати офери до CSV",
  "No domains yet": "Доменів ще немає",
  "Add a custom domain to serve tracking links from your own branded URL.": "Додайте власний домен, щоб роздавати трекінгові посилання зі свого брендованого URL.",
  "Create streams to split traffic by geo, device, OS, or custom conditions.": "Створюйте потоки для розподілу трафіку за GEO, пристроєм, ОС або власними умовами.",
  "Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.": "Створюйте правила для автоматичного призупинення, відновлення або коригування кампаній на основі порогів ефективності.",
  "No members yet": "Учасників ще немає",
  "Invite teammates above to collaborate.": "Запросіть учасників команди вище, щоб розпочати співпрацю.",
  "URL for receiving notifications in JSON format": "URL для отримання сповіщень у форматі JSON",
  "Alert types": "Типи сповіщень",
  "Campaign start, pause, completion": "Запуск, призупинення та завершення кампанії",
  "Changes in CR, ROI, cost": "Зміни CR, ROI, вартості",
  "Suspicious traffic detection": "Виявлення підозрілого трафіку",
  "Updates and technical information": "Оновлення та технічна інформація",
  "Execution history": "Історія виконань",
  "Execution history is empty": "Історія виконань порожня",
  "Records of automatic rule executions will appear here": "Тут з'являться записи про автоматичні виконання правил",
  "Edit automation rule": "Редагувати правило автоматизації",
  "Change automation rule settings": "Змінити налаштування правила автоматизації",
  "Geographic statistics": "Географічна статистика",
  "Loading geographic data...": "Завантаження географічних даних...",
  "By country": "За країною",
  "By city": "За містом",
  "No country data": "Немає даних про країни",
  "No city data": "Немає даних про міста",
  "Click map": "Карта кліків",
  "No data to display on map": "Немає даних для відображення на карті",
  "Geographic data will appear after the first clicks with resolvable coordinates": "Географічні дані з'являться після перших кліків із визначеними координатами",
  "Signed in successfully!": "Вхід виконано успішно!",
  "Sign in failed": "Помилка входу",
  "Registration successful!": "Реєстрацію завершено успішно!",
  "Registration failed": "Помилка реєстрації",
  "Signed out": "Вихід виконано",
  "One moment…": "Одну мить…",
  "Documentation": "Документація",
  "Help": "Довідка",
  "Step-by-step guide for every feature": "Покроковий посібник для кожної функції",
  "Search sections...": "Пошук розділів...",
  "Loading documentation...": "Завантаження документації...",
  "Back to top": "Нагору",
  "Domains": "Домени",
  "Tracker domains": "Домени трекера",
  "Custom domains": "Власні домени",
  "Bind your own domain to mask tracking links. Point a CNAME to our edge and verify ownership via TXT record.": "Підключіть власний домен, щоб замаскувати трекінгові посилання. Вкажіть CNAME на наш edge і підтвердіть право власності через TXT-запис.",
  "After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.": "Після додавання налаштуйте DNS для вашого домену (TXT-запис для верифікації, CNAME або A-запис для маршрутизації трафіку), а потім натисніть «Верифікувати».",
  "Verified": "Верифіковано",
  "Failed": "Помилка",
  "Pending": "Очікує",
  "Default": "За замовчуванням",
  "Set default": "Зробити основним",
  "Verify": "Верифікувати",
  "TXT verification record": "TXT-запис для верифікації",
  "Routing record (CNAME)": "Запис маршрутизації (CNAME)",
  "Copy value": "Копіювати значення",
  "Copied": "Скопійовано",
  "Tracking links will use": "Трекінгові посилання використовуватимуть",
  "Domain added": "Домен додано",
  "Failed to add domain": "Не вдалося додати домен",
  "Domain verified": "Домен верифіковано",
  "Verification failed": "Верифікацію не пройдено",
  "Default domain updated": "Основний домен оновлено",
  "Domain deleted": "Домен видалено",
  "Delete this domain?": "Видалити цей домен?",
  "Enable HTTPS": "Увімкнути HTTPS",
  "HTTPS active": "HTTPS активний",
  "Check TLS": "Перевірити TLS",
  "TLS validation records": "Записи валідації TLS",
  "TLS provisioning started": "Провізіонування TLS розпочато",
  "TLS provisioning failed": "Провізіонування TLS не вдалося",
  "Action failed": "Дія не вдалася",
  "Loading…": "Завантаження…",
  "Conversion API": "Conversion API",
  "Conversion forwarders": "Форвардери конверсій",
  "Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.": "Передавайте конверсії server-to-server до рекламних мереж (FB CAPI, Google Ads, TikTok). Спрацьовує автоматично при кожному постбеку.",
  "New forwarder": "Новий форвардер",
  "Edit forwarder": "Редагувати форвардер",
  "No forwarders yet": "Форвардерів ще немає",
  "Forwarder created": "Форвардер створено",
  "Forwarder updated": "Форвардер оновлено",
  "Forwarder deleted": "Форвардер видалено",
  "Delete forwarder?": "Видалити форвардер?",
  "Send test": "Надіслати тест",
  "Test event sent": "Тестову подію надіслано",
  "Test failed": "Тест не вдався",
  "No events yet": "Подій ще немає",
  "Provider": "Провайдер",
  "Event name": "Назва події",
  "Name is required": "Назва обов'язкова",
  "Missing fields": "Відсутні поля",
  "Sent": "Надіслано",
  "Event": "Подія",
  "Last sent": "Останнє надсилання",
  "Public API": "Публічний API",
  "API keys": "API-ключі",
  "New key": "Новий ключ",
  "New API key": "Новий API-ключ",
  "Use API keys to call the public /v1 REST API. Pass the key as": "Використовуйте API-ключі для звернень до публічного REST API /v1. Передайте ключ як",
  "or": "або",
  "Copy your key now — it will not be shown again": "Скопіюйте ключ зараз — він більше не відображатиметься",
  "Copy": "Копіювати",
  "Dismiss": "Закрити",
  "Quick start": "Швидкий старт",
  "Docs": "Документація",
  "No API keys yet": "API-ключів ще немає",
  "Scopes": "Дозволи",
  "Delete this key?": "Видалити цей ключ?",
  "Key deleted": "Ключ видалено",
  "last used": "востаннє використовувався",
  "never used": "ніколи не використовувався",
  "Team": "Команда",
  "Workspace": "Workspace",
  "Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.": "Запрошуйте учасників із ролями. Власник бачить усе; менеджер/адмін може редагувати; viewer має лише перегляд.",
  "Invite member": "Запросити учасника",
  "Invite": "Запросити",
  "Invite sent": "Запрошення надіслано",
  "Share this link with the invitee:": "Поділіться цим посиланням із запрошеним:",
  "Role": "Роль",
  "Members": "Учасники",
  "Revoke access?": "Відкликати доступ?",
  "Revoke access": "Відкликати доступ",
  "Access revoked": "Доступ відкликано",
  "Reset 2FA": "Скинути 2FA",
  "Reset this member's 2FA?": "Скинути 2FA цього учасника?",
  "2FA reset — member can re-enrol": "2FA скинуто — учасник може налаштувати його знову",
  "Member had no 2FA configured": "У цього учасника не було налаштовано 2FA",
  "2FA reset failed": "Не вдалося скинути 2FA",
  "Workspace currency": "Валюта workspace",
  "Display currency": "Валюта відображення",
  "Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.": "Звіти та дашборди буде нормалізовано до цієї валюти. Курси валют оновлюються щогодини.",
  "Workspace currency saved": "Валюту workspace збережено",
  "Could not save currency": "Не вдалося зберегти валюту",
  "Invited": "Запрошений",
  "Shared with me": "Поділились зі мною",
  "No shared workspaces": "Немає спільних workspace'ів",
  "Audit log": "Журнал аудиту",
  "Workspace-scoped trail of privileged actions. Retained for 90 days.": "Журнал привілейованих дій у межах workspace. Зберігається 90 днів.",
  "Target type": "Тип цілі",
  "Actor ID": "ID актора",
  "Since": "З",
  "Until": "По",
  "Apply": "Застосувати",
  "Actor": "Актор",
  "Target": "Ціль",
  "Payload": "Payload",
  "IP": "IP",
  "Load more": "Завантажити ще",
  "No audit entries match the current filters.": "Жоден запис аудиту не відповідає поточним фільтрам.",
  "Failed to load audit log": "Не вдалося завантажити журнал аудиту",
  "CAPI DLQ": "CAPI DLQ",
  "CAPI dead-letter queue": "CAPI dead-letter queue",
  "Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.": "Конверсії, що вичерпали ліміт повторних спроб. Replay повторно надсилає до форвардера; discard видаляє запис назавжди.",
  "Forwarder ID": "ID форвардера",
  "Conversion ID": "ID конверсії",
  "Since (ISO)": "Від (ISO)",
  "Until (ISO)": "До (ISO)",
  "Apply filters": "Застосувати фільтри",
  "No DLQ entries match these filters.": "Жоден запис DLQ не відповідає цим фільтрам.",
  "Forwarder": "Форвардер",
  "Attempts": "Спроби",
  "Last error": "Остання помилка",
  "Replay": "Повторити",
  "Discard": "Відхилити",
  "CAPI replay succeeded": "Повтор CAPI виконано успішно",
  "Replay failed:": "Повтор не вдався:",
  "Replay failed": "Повтор не вдався",
  "DLQ entry discarded": "Запис DLQ відхилено",
  "Discard failed": "Не вдалося відхилити",
  "Permanently discard this DLQ entry?": "Назавжди відхилити цей запис DLQ?",
  "Failed to load CAPI DLQ": "Не вдалося завантажити CAPI DLQ",
  "Activated {n}": "Активовано: {n}",
  "Paused {n}": "Призупинено: {n}",
  "Deleted {n}": "Видалено: {n}",
  "Skipped {n} (no access or not found)": "Пропущено: {n} (немає доступу або не знайдено)",
  "Bulk update failed": "Масове оновлення не вдалося",
  "Bulk delete failed": "Масове видалення не вдалося",
  "System health": "Стан системи",
  "System status": "Статус системи",
  "S2S log": "Лог S2S",
  "TLS fingerprints": "TLS-відбитки",
  "Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.": "Зведений стан CAPI / постбек / FX / синхронізації витрат по всіх воркспейсах, якими ви керуєте.",
  "CAPI delivery": "Доставка CAPI",
  "Conversion API dispatches in the last window.": "Відправки Conversion API за останній часовий проміжок.",
  "Total": "Всього",
  "Success rate": "Відсоток успіху",
  "No CAPI events in window.": "Немає подій CAPI у цьому часовому проміжку.",
  "Retry queue": "Черга повторів",
  "Pending CAPI re-attempts.": "Очікувані повтори CAPI.",
  "Due now": "До виконання зараз",
  "Oldest": "Найстаріший",
  "Dead-letter queue": "Dead-letter queue",
  "Conversions that exhausted the retry budget.": "Конверсії, що вичерпали ліміт повторів.",
  "Postback delivery": "Доставка постбеків",
  "S2S postback callouts in the last window.": "Виклики постбеку S2S за останній часовий проміжок.",
  "FX cache": "Кеш FX",
  "Per-base exchange-rate snapshot freshness.": "Актуальність знімків курсів валют для кожної базової валюти.",
  "Base": "База",
  "Refreshed": "Оновлено",
  "FX cache is empty.": "Кеш FX порожній.",
  "stale": "застарілий",
  "fresh": "актуальний",
  "Ad cost sync": "Синхронізація витрат на рекламу",
  "Active connections, last sync time, and recent errors.": "Активні підключення, час останньої синхронізації та останні помилки.",
  "No active ad-cost connections.": "Немає активних підключень для витрат на рекламу.",
  "error": "помилка",
  "ok": "ok",
  "Generated at": "Згенеровано о",
  "Window": "Часове вікно",
  "Failed to load admin health": "Не вдалося завантажити стан адміна",
  "Export CSV": "Експортувати CSV",
  "Audit log exported": "Журнал аудиту експортовано",
  "Audit export failed": "Помилка експорту аудиту",
  "Billing": "Білінг",
  "Plans & usage": "Плани та використання",
  "Current plan": "Поточний план",
  "Current": "Поточний",
  "Clicks this month": "Кліки цього місяця",
  "Plans & billing": "Плани та білінг",
  "Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.": "П'ять редакцій: кожен план включає повний трекер — оберіть розмір команди, масштаб доменів і рівень автоматизації. Кліки не обмежені.",
  "Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.": "Білінг ще не активовано на цьому сервері — всі функції доступні. Плани нижче показують, що буде діяти після запуску платежів.",
  "Trial": "Пробний період",
  "day(s) left": "дн. залишилось",
  "choose a plan to keep your traffic flowing without interruption.": "оберіть план, щоб ваш трафік не переривався.",
  "Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.": "Ваша підписка неактивна: обробку кліків і створення об'єктів призупинено. Оберіть план, щоб відновити роботу негайно.",
  "Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.": "Останній платіж не пройшов — трекер продовжує працювати, поки Stripe повторює спробу. Оновіть картку в розділі Керування білінгом.",
  "cancels at period end": "скасовується наприкінці періоду",
  "unlimited": "необмежено",
  "months": "місяців",
  "month": "місяць",
  "billed every": "оплата кожні",
  "user(s)": "користувач(ів)",
  "domain(s)": "домен(ів)",
  "Choose plan": "Обрати план",
  "Full tracker core": "Повне ядро трекера",
  "Unlimited clicks": "Необмежені кліки",
  "Landing page editor": "Редактор лендингів",
  "Online support": "Онлайн-підтримка",
  "Click API + API keys": "Click API + ключі API",
  "Facebook CAPI": "Facebook CAPI",
  "All 9 CAPI providers": "Усі 9 провайдерів CAPI",
  "Report by conversion date": "Звіт за датою конверсії",
  "White label branding": "White label брендинг",
  "Personal manager": "Персональний менеджер",
  "Priority support": "Пріоритетна підтримка",
  "Onboarding call": "Онбординг-дзвінок",
  "trialing": "пробний період",
  "active": "активна",
  "past_due": "прострочена оплата",
  "expired": "закінчилась",
  "canceled": "скасована",
  "exempt": "звільнена",
  "Manage billing": "Керувати білінгом",
  "Manage": "Керувати",
  "Upgrade": "Підвищити план",
  "Free forever": "Назавжди безкоштовно",
  "clicks/mo": "кліків/міс.",
  "campaigns": "кампаній",
  "team members": "членів команди",
  "Campaign parameters": "Параметри кампанії",
  "Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.": "Оголосіть параметри URL, які ви передаєте через рекламні мережі. Кожен рядок стає макросом виду {key}, доступним у постбеках і CAPI-пейлоадах.",
  "URL key": "Ключ URL",
  "Placeholder / default": "Placeholder / значення за замовчуванням",
  "Google Ads tag": "Тег Google Ads",
  "No parameters yet": "Параметрів ще немає",
  "Parameters have unsaved changes — clicks keep using the saved set until you save.": "Параметри мають незбережені зміни — кліки продовжують використовувати збережений набір, доки ви не збережете.",
  "Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.": "Значення, що записується в трекінгове посилання для цього ключа: макрос рекламної мережі, наприклад {campaignid}, або фіксоване значення, наприклад MCLV. Фіксоване значення також зберігається для кліків, що надходять без цього ключа; макрос у фігурних дужках — ні. Залиште порожнім для ключів, які рекламна мережа встановлює окремо для акаунта, наприклад tm і tml.",
  "Macro: filled by the ad network, not stored on clicks without this key": "Макрос: заповнюється рекламною мережею, не зберігається для кліків без цього ключа",
  "Google Ads conversion keys": "Ключі конверсій Google Ads",
  "Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign": "Розбивайте кліки та конверсії за sub1–sub30 або будь-яким параметром, оголошеним у кампанії",
  "Sub slot": "Sub-слот",
  "Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.": "Необов'язково: значення також зберігається як sub1…sub30 або іменоване поле (external_id, creative_id…). Призначайте одне й те саме завжди до одного слота в кожній кампанії (наприклад, team -> sub8) — одна колонка у звіті та макрос {sub_id_8} охоплять усіх медіабаєрів; external_id передається як {external_id} у постбеку джерела трафіку.",
  "Source postback": "Постбек джерела",
  "This source postback is already added": "Цей постбек джерела вже додано",
  "Source postback added — check its placeholders (REPLACE, XXXX…) and press Save": "Постбек джерела додано — перевірте його плейсхолдери (REPLACE, XXXX…) і натисніть Зберегти",
  "Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.": "Sale також спрацьовує для депозитів (ftd, dep, deposit), а Lead — для реєстрацій (reg, signup), як би їх не називав брокер.",
  "Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.": "Ключі без значення за замовчуванням (tm, tml, a…) не включаються до посилання: передавайте їх у рекламі, наприклад у суфіксі Final URL у Google Ads.",
  "= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.": "= мітка Submit Lead Form — встановіть цю конверсію як Primary. Спрацьовує з браузера відвідувача після успішного ліда.",
  "= Purchase / deposit label — set this conversion as Secondary. Sent by the \"Deposit → Purchase\" S2S rule; do not add an S2S rule for lead.": "= мітка Purchase / deposit — встановіть цю конверсію як Secondary. Надсилається правилом S2S «Deposit → Purchase»; не додавайте правило S2S для ліда.",
  "Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.": "Додайте обидві до суфікса Final URL кожного акаунта Google Ads (tml=AW-…/lead-label&tm=AW-…/purchase-label), а їхнє значення за замовчуванням тут залиште порожнім.",
  "Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.": "Ключі чутливі до регістру. Будь-який ключ (a, b, s, c…) зберігається на кліку, працює як макрос {key} і може бути обраний як групування у Звітах і звітах Sub-ID поряд із sub1…sub30. Призначте його до sub-слота, щоб забезпечити узгодженість між кампаніями.",
  "Use lowercase keys — the tracker does not read:": "Використовуйте ключі в нижньому регістрі — трекер не зчитає:",
  "Tracking URL preview": "Попередній перегляд трекінгового URL",
  "Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.": "Вставте це як Final URL (Google Ads) або трекінгове посилання (Facebook). За потреби замініть плейсхолдери {key} на реальні макроси рекламної мережі.",
  "Fire Google Ads gtag on redirect": "Запускати gtag Google Ads при редиректі",
  "When on, /r/ returns a tiny HTML page that calls gtag(\"event\",\"conversion\", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.": "Якщо увімкнено, /r/ повертає невелику HTML-сторінку, яка викликає gtag(\"event\",\"conversion\", …) з вашим тегом у простому режимі перед переадресацією. Використовуйте це, якщо не налаштовуєте суфікс Final URL на стороні Google Ads.",
  "S2S postbacks": "S2S постбеки",
  "Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.": "Вихідні HTTP-запити, що надсилаються щоразу, коли отримано постбек конверсії. Підтримує макроси: {click_id}, {payout} та всі параметри кампанії, оголошені вище.",
  "No postbacks yet": "Постбеків ще немає",
  "Method": "Метод",
  "Statuses": "Статуси",
  "Add postback": "Додати постбек",
  "Show recent log": "Показати останній лог",
  "Available macros": "Доступні макроси",
  "Campaign saved": "Кампанію збережено",
  "Postback fired": "Постбек надіслано",
  "Mode": "Режим",
  "Simple": "Простий",
  "Advanced": "Розширений",
  "Conversion tag": "Тег конверсії",
  "Conversion tag is required": "Тег конверсії є обов'язковим",
  "Paste the \"send_to\" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.": "Вставте значення \"send_to\" зі сніпету конверсії Google Ads (наприклад, AW-123456789/AbCdEf). OAuth не потрібен. Трекер зберігає його та передає через суфікс Final URL або gtag під час переадресації.",
  "OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.": "Завантаження конверсій кліків через OAuth — потребує developer token, customer ID та refresh token. Використовуйте лише якщо вам потрібне серверне завантаження з gclid.",
  "Campaign": "Кампанія",
  "Create a new xpnsr.tech account": "Створити новий акаунт xpnsr.tech",
  "Already have an account? Sign in": "Вже маєте акаунт? Увійдіть",
  "Only ZIP files are supported": "Підтримуються лише ZIP-файли",
  "Please enter a name for the landing page": "Введіть назву лендингу",
  "Please select a ZIP file": "Оберіть ZIP-файл",
  "Landing page uploaded successfully": "Лендинг успішно завантажено",
  "Error uploading landing page": "Помилка завантаження лендингу",
  "Upload ZIP": "Завантажити ZIP",
  "Upload Landing Page": "Завантажити лендинг",
  "Upload a ZIP file containing your landing page files (max 50MB)": "Завантажте ZIP-файл із файлами вашого лендингу (макс. 50 МБ)",
  "My landing page": "Мій лендинг",
  "tag1, tag2, tag3": "тег1, тег2, тег3",
  "Separate tags with commas": "Розділяйте теги комами",
  "ZIP File": "ZIP-файл",
  "Drag & drop or click to select": "Перетягніть або натисніть для вибору",
  "Select ZIP File": "Обрати ZIP-файл",
  "Uploading...": "Завантаження...",
  "Upload": "Завантажити",
  "History": "Історія",
  "Notification settings": "Налаштування сповіщень",
  "Please fill in name and select ZIP file": "Введіть назву та оберіть ZIP-файл",
  "Offer uploaded successfully": "Офер успішно завантажено",
  "Error uploading offer": "Помилка завантаження офера",
  "Upload Offer ZIP": "Завантажити ZIP офера",
  "Upload a ZIP file containing offer files": "Завантажте ZIP-файл із файлами офера",
  "Countries (comma-separated ISO codes, e.g. US,RU,DE)": "Країни (ISO-коди через кому, наприклад US,RU,DE)",
  "ZIP File (max 100MB)": "ZIP-файл (макс. 100 МБ)",
  "Change": "Змінити",
  "Select ZIP file": "Оберіть ZIP-файл",
  "Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.": "Завантажте ZIP-файл із HTML-сторінками, зображеннями та іншими ресурсами. Підтримується: _preview.png для попереднього перегляду, PHP-скрипти для обробки.",
  "Upload Offer": "Завантажити офер",
  "pages": "сторінки",
  "Choose entry point": "Оберіть точку входу",
  "Multiple HTML pages detected. Select the main page visitors will land on.": "Виявлено кілька HTML-сторінок. Оберіть головну сторінку, на яку потраплятимуть відвідувачі.",
  "Skip (use auto-detected)": "Пропустити (використати автовизначену)",
  "Confirm": "Підтвердити",
  "Edit files": "Редагувати файли",
  "File editor": "Редактор файлів",
  "Edit HTML, CSS, JS and other text files inside the uploaded archive": "Редагуйте HTML, CSS, JS та інші текстові файли всередині завантаженого архіву",
  "Files": "Файли",
  "Select a file from the sidebar to edit": "Оберіть файл із бічної панелі для редагування",
  "Binary file — not editable": "Бінарний файл — недоступний для редагування",
  "File saved": "Файл збережено",
  "Error loading files": "Помилка завантаження файлів",
  "Error loading file": "Помилка завантаження файлу",
  "Error saving file": "Помилка збереження файлу",
  "Discard unsaved changes?": "Відхилити незбережені зміни?",
  "Saving...": "Збереження...",
  "Bulk create": "Масове створення",
  "Bulk create Google Ads forwarders": "Масове створення форвардерів Google Ads",
  "Conversion tags (one per line)": "Теги конверсій (по одному на рядок)",
  "Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.": "Вставте теги AW-XXX/YYY, по одному на рядок. Кожен створює окремий форвардер.",
  "Bind to campaigns": "Прив'язати до кампаній",
  "Leave empty to fire on all campaigns": "Залиште порожнім, щоб спрацьовувало для всіх кампаній",
  "Add campaign…": "Додати кампанію…",
  "Create all": "Створити всі",
  "Creating…": "Створення…",
  "{count} forwarders created": "Створено форвардерів: {count}",
  "campaign": "кампанія",
  "Linked forwarders": "Пов'язані форвардери",
  "Conversion forwarders that fire for this campaign": "Форвардери конверсій, що спрацьовують для цієї кампанії",
  "Heatmap": "Теплова карта",
  "Funnel": "Воронка",
  "Activity heatmap": "Теплова карта активності",
  "Day-of-week x hour-of-day breakdown": "Розбивка за днем тижня та годиною доби",
  "Less": "Менше",
  "More": "Більше",
  "Peak": "Пік",
  "No heatmap data": "Немає даних теплової карти",
  "Conversion funnel": "Воронка конверсій",
  "Click-to-conversion pipeline with status breakdown": "Шлях від кліку до конверсії з розбивкою за статусами",
  "Status breakdown": "Розбивка за статусом",
  "No funnel data": "Немає даних воронки",
  "Mon": "Пн",
  "Tue": "Вт",
  "Wed": "Ср",
  "Thu": "Чт",
  "Fri": "Пт",
  "Sat": "Сб",
  "Sun": "Нд",
  "Ad-Account Connections": "Підключення рекламних акаунтів",
  "Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.": "Підключіть акаунти FB / Google Ads, щоб дані про витрати автоматично підтягувались у кампанії.",
  "Connect with Facebook": "Підключити через Facebook",
  "Connect with Google Ads": "Підключити Google Ads",
  "Ad account connected via OAuth": "Рекламний акаунт підключено через OAuth",
  "OAuth error: ": "Помилка OAuth: ",
  "Failed to start OAuth": "Не вдалося запустити OAuth",
  "Token refreshed": "Токен оновлено",
  "Refresh failed": "Оновлення не вдалося",
  "Refresh token": "Оновити токен",
  "Connect ad account": "Підключити рекламний акаунт",
  "Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.": "Токени зберігаються в зашифрованому вигляді. Використовуйте кнопки OAuth вище для FB / Google або введіть токени вручну нижче.",
  "Sync now": "Синхронізувати зараз",
  "Connect": "Підключити",
  "Failed to load connections": "Не вдалося завантажити підключення",
  "Connection created": "Підключення створено",
  "Connection deleted": "Підключення видалено",
  "Delete this connection?": "Видалити це підключення?",
  "Delete failed": "Видалення не вдалося",
  "Sync complete": "Синхронізацію завершено",
  "Sync failed": "Синхронізація не вдалася",
  "No connections yet. Connect FB or Google Ads to start importing cost.": "Підключень ще немає. Підключіть FB або Google Ads, щоб почати імпортувати витрати.",
  "Refresh token (optional)": "Refresh token (необов'язково)",
  "Display name": "Відображувана назва",
  "Account ID": "Account ID",
  "Access token": "Access token",
  "Save failed": "Збереження не вдалося",
  "Permissions": "Права доступу",
  "Permission matrix": "Матриця прав доступу",
  "Permission matrix saved": "Матрицю прав доступу збережено",
  "Failed to load permission matrix": "Не вдалося завантажити матрицю прав доступу",
  "Failed to save permission matrix": "Не вдалося зберегти матрицю прав доступу",
  "Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.": "Перевизначте мінімальну роль, необхідну для кожної дії в цьому workspace. Зберігаються лише комірки, що відрізняються від значення за замовчуванням.",
  "overrides": "перевизначення",
  "Read-only — only the workspace owner can edit the matrix.": "Лише для читання — редагувати матрицю може тільки власник workspace.",
  "Reset all to defaults": "Скинути все до значень за замовчуванням",
  "Custom": "Власний",
  "Reset to default": "Скинути до стандартного",
  "owner": "власник",
  "admin": "адмін",
  "manager": "менеджер",
  "viewer": "глядач",
  "Landings & offers": "Лендинги та офери",
  "Reports": "Звіти",
  "Audit": "Аудит",
  "Toggle navigation hints": "Перемкнути підказки навігації",
  "Show hints": "Показати підказки",
  "Hide hints": "Приховати підказки",
  "Tools": "Інструменти",
  "Admin": "Адмін",
  "Resources": "Ресурси",
  "Pre-landings": "Прелендинги",
  "Book demo": "Замовити демо",
  "Overview of clicks, conversions and active campaigns": "Огляд кліків, конверсій та активних кампаній",
  "Create ad campaigns and get tracking links": "Створюйте рекламні кампанії та отримуйте трекінгові посилання",
  "Upload landing pages (ZIP) or set a URL for split-tests": "Завантажте лендинги (ZIP) або вкажіть URL для спліт-тестів",
  "Warm-up pages shown before the offer": "Прогрівальні сторінки, що показуються перед офером",
  "Connect Facebook, Google, TikTok ad accounts": "Підключіть рекламні акаунти Facebook, Google, TikTok",
  "Two-factor auth, sessions and password": "Двофакторна автентифікація, сесії та пароль",
  "Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms": "Завантажені офери/фunneli + API-роутинг до партнерів (ваги, failover) + лід-форми",
  "Traffic sources with presets (Google Ads with tm & macros, etc.)": "Джерела трафіку з готовими пресетами (Google Ads з tm і макросами тощо)",
  "Manage flows and traffic distribution rules": "Керуйте потоками та правилами розподілу трафіку",
  "Split-test landings and offers with auto-distribution": "Спліт-тести лендингів та оферів з автоматичним розподілом",
  "Block bots, fraud and suspicious clicks": "Блокуйте ботів, фрод і підозрілі кліки",
  "Detailed reports: charts, geo, devices, ROI": "Детальні звіти: графіки, GEO, пристрої, ROI",
  "Full click log with IP, UserAgent, GEO and time": "Повний лог кліків з IP, UserAgent, GEO та часом",
  "Auto-rules: pause campaigns on low ROI, etc.": "Авто-правила: призупиняти кампанії при низькому ROI тощо",
  "Partner CRMs (TrackBox, Custom API) for API lead injection + notifications": "CRM партнерів (TrackBox, Custom API) для відправки лідів через API + сповіщення",
  "Add your own domains for tracking links": "Додайте власні домени для трекінгових посилань",
  "Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth": "Онлайн-конверсії до Google/FB/TikTok (S2S). Google — простий режим, без OAuth",
  "Keys to access the tracker REST API": "Ключі для доступу до REST API трекера",
  "Invite your team, assign roles and permissions": "Запрошуйте команду, призначайте ролі та права доступу",
  "Action log of all users for 90 days": "Лог дій усіх користувачів за 90 днів",
  "Cookie consent banner for GDPR compliance": "Банер згоди на cookies для відповідності GDPR",
  "Ready-made templates and integrations": "Готові шаблони та інтеграції",
  "Swagger REST API docs (opens in new tab)": "Документація Swagger REST API (відкривається у новій вкладці)",
  "Failed conversion dispatches — can be retried": "Невдалі відправки конверсій — можна повторити",
  "Server, queue and database status": "Статус серверів, черг та баз даних",
  "Plan, payment and usage limits": "Тариф, оплата та ліміти використання",
  "Profile, language, timezone and notifications": "Профіль, мова, часовий пояс та сповіщення",
  "(no label)": "(без мітки)",
  "180 days": "180 днів",
  "2FA disabled": "2FA вимкнено",
  "2FA enabled": "2FA увімкнено",
  "2FA is currently enabled": "2FA наразі увімкнено",
  "302 redirect (default)": "Редирект 302 (за замовчуванням)",
  "365 days": "365 днів",
  "A campaign groups your traffic sources and tracking links under one name.": "Кампанія об'єднує ваші джерела трафіку та трекінгові посилання під одною назвою.",
  "AI Optimizer": "AI Optimizer",
  "Accept button label": "Підпис кнопки прийняття",
  "Accepted": "Прийнято",
  "Accepting invitation…": "Прийняття запрошення…",
  "Action on trigger": "Дія при спрацюванні",
  "Activate": "Активувати",
  "Activate 2FA": "Активувати 2FA",
  "Add a forwarder to push conversions to ad networks automatically.": "Додайте форвардер, щоб автоматично надсилати конверсії в рекламні мережі.",
  "Add forwarder": "Додати форвардер",
  "Add the CNAME record shown on the Domains page, then click verify.": "Додайте CNAME-запис, вказаний на сторінці «Домени», а потім натисніть «Перевірити».",
  "Add vendor": "Додати постачальника",
  "Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.": "Агресивний: блокує будь-який клік, для якого відсутній або ще не класифікований JA3/JA4. Спочатку позначте хеші корпоративних проксі через Workspace Overrides.",
  "Alert if ROI drops below this %": "Сповіщати, якщо ROI впаде нижче цього %",
  "Algorithm": "Алгоритм",
  "All groups": "Всі групи",
  "All statuses": "Всі статуси",
  "Allowed metrics": "Дозволені метрики",
  "Always block these JA3 / JA4 hashes regardless of classification.": "Завжди блокувати ці хеші JA3 / JA4 незалежно від класифікації.",
  "Anonymous": "Анонімний",
  "Any type": "Будь-який тип",
  "Anyone with this link will lose access to the shared dashboard immediately.": "Усі, хто має це посилання, негайно втратять доступ до спільного дашборду.",
  "Applied {n} weight changes": "Застосовано {n} змін ваги",
  "Archive": "Архівувати",
  "Archived": "Архівовано",
  "Auto": "Авто",
  "Auto-refresh every 30s": "Автооновлення кожні 30с",
  "Available on enterprise plans. Hides the \"Powered by xpnsr\" footer.": "Доступно на тарифах enterprise. Приховує футер «Powered by xpnsr».",
  "Back to sign-in": "Повернутися до входу",
  "Backup codes (save now)": "Резервні коди (збережіть зараз)",
  "Bangkok (UTC+7)": "Бангкок (UTC+7)",
  "Banned": "Заблокований",
  "Banner copy": "Текст банера",
  "Banner status": "Статус банера",
  "Berlin (UTC+1)": "Берлін (UTC+1)",
  "Best cohort": "Найкраща когорта",
  "Block classification": "Класифікація для блокування",
  "Block fingerprints classified as bad": "Блокувати відбитки, класифіковані як шкідливі",
  "Block unknown fingerprints": "Блокувати невідомі відбитки",
  "Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.": "Блокувати, коли зведений показник ризику TLS+UA+IP перевищує цей поріг. За замовчуванням 0.7.",
  "Body": "Тіло",
  "Body (JSON)": "Тіло (JSON)",
  "Body copied to clipboard.": "Тіло скопійовано до буфера обміну.",
  "Body must be valid JSON.": "Тіло має бути валідним JSON.",
  "Branding": "Branding",
  "Branding cleared": "Branding очищено",
  "Branding saved": "Branding збережено",
  "Break down clicks and conversions by sub-ID parameters (sub1–sub15)": "Розбити кліки та конверсії за параметрами sub ID (sub1–sub15)",
  "Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.": "Переглядайте та встановлюйте шаблони постбеків, макросів, антифрод-правил і прелендингів від спільноти. Матеріали публікуються автоматично — спільнота самостійно регулює їх через видалення.",
  "Browser": "Браузер",
  "Build traffic rules, rotate landings and split-test offers for any campaign.": "Створюйте правила трафіку, ротуйте лендинги та спліт-тестуйте офери для будь-якої кампанії.",
  "Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.": "Об'єднуйте верифіковані домени в пул і ротуйте між ними трекінгові посилання. Виведіть заблокований домен із ротації одним кліком — без повторного розгортання рекламних оголошень.",
  "By browser": "За браузером",
  "By device": "За пристроєм",
  "By {author}": "Автор: {author}",
  "CR %": "CR %",
  "CR%": "CR%",
  "Campaign ID": "ID кампанії",
  "Campaign activated": "Кампанію активовано",
  "Campaign archived": "Кампанію заархівовано",
  "Campaign cloned successfully!": "Кампанію успішно клоновано!",
  "Campaign comparison": "Порівняння кампаній",
  "Campaign created": "Кампанію створено",
  "Campaign dashboard": "Дашборд кампанії",
  "Campaign restored": "Кампанію відновлено",
  "Cap": "Ліміт",
  "Cap timezone": "Часовий пояс cap",
  "Catalog": "Каталог",
  "Chicago (UTC-6)": "Chicago (UTC-6)",
  "Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).": "Оберіть пресет і за потреби розширте його додатковими кодами країн ISO-3166 (через кому, наприклад: BR, MX, AR).",
  "Clear": "Очистити",
  "Click ID forward parameter": "Параметр передачі click ID",
  "Click detail": "Деталі кліку",
  "Click to activate": "Натисніть, щоб активувати",
  "Click to pause": "Натисніть, щоб призупинити",
  "Clicks log": "Лог кліків",
  "Clipboard unavailable — copy the URL manually": "Буфер обміну недоступний — скопіюйте URL вручну",
  "Cloaked (iframe)": "Клоакінг (iframe)",
  "Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.": "Клоакінг через iframe зберігає домен трекера в адресному рядку — працює лише для ресурсів, які дозволяють фреймінг.",
  "Clone": "Клонувати",
  "Close navigation": "Закрити навігацію",
  "Cohort": "Когорта",
  "Cohort retention": "Утримання когорт",
  "Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.": "Список IP-адрес, яким дозволено надсилати постбеки (через кому). Залиште порожнім, щоб дозволити всім.",
  "Compare": "Порівняти",
  "Compare current to proposed weights. Apply persists the proposed column to the streams.": "Порівняйте поточні та запропоновані ваги. Застосування зберігає запропонований стовпець у потоках.",
  "Comparing…": "Порівняння…",
  "Compliance": "Відповідність",
  "Configure UTM templates and conversion postbacks for every ad network you run.": "Налаштуйте UTM-шаблони та постбеки конверсій для кожної рекламної мережі, яку ви використовуєте.",
  "Configure offers, payouts and target geos. Upload ZIPs or link external networks.": "Налаштуйте офери, виплати та цільові GEO. Завантажте ZIP-файли або підключіть зовнішні мережі.",
  "Configure stream": "Налаштувати потік",
  "Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.": "Налаштуйте банер cookies GDPR / CCPA, що відображається на лендингах вашого трекера. Банер враховує регіон — відвідувачі поза налаштованими регіонами його не бачать.",
  "Confirm action": "Підтвердити дію",
  "Connect external services and webhooks": "Підключити зовнішні сервіси та вебхуки",
  "Connect external services and webhooks to automate workflows.": "Підключіть зовнішні сервіси та вебхуки для автоматизації робочих процесів.",
  "Connection restored": "З'єднання відновлено",
  "Connections": "Підключення",
  "Consent banner": "Банер згоди",
  "Consent banner saved": "Банер згоди збережено",
  "Conv": "Конв",
  "Conv.": "Конв.",
  "Conversion rate comparison": "Порівняння показника конверсії",
  "Cookieless mode (skip xpnsr_vid first-party cookie)": "Режим без cookies (пропускає first-party cookie xpnsr_vid)",
  "Copied to clipboard.": "Скопійовано до буфера обміну.",
  "Copy link (/r/)": "Скопіювати посилання (/r/)",
  "Copy link (/{alias}/)": "Скопіювати посилання (/{alias}/)",
  "Cost": "Витрати",
  "Cost value": "Значення витрат",
  "Could not accept invitation": "Не вдалося прийняти запрошення",
  "Could not copy — please copy the link manually.": "Не вдалося скопіювати — скопіюйте посилання вручну.",
  "Could not create public link": "Не вдалося створити публічне посилання",
  "Could not load branding": "Не вдалося завантажити брендинг",
  "Could not load marketplace templates.": "Не вдалося завантажити шаблони з маркетплейсу.",
  "Could not load template detail.": "Не вдалося завантажити деталі шаблону.",
  "Could not load the shared dashboard.": "Не вдалося завантажити спільний дашборд.",
  "Could not reset branding": "Не вдалося скинути брендинг",
  "Could not save branding": "Не вдалося зберегти брендинг",
  "Country (ISO-2)": "Країна (ISO-2)",
  "Create a campaign first": "Спочатку створіть кампанію",
  "Create key": "Створити ключ",
  "Create landing page": "Створити лендинг",
  "Create link": "Створити посилання",
  "Create new landing page": "Створити новий лендинг",
  "Create new offer": "Створити новий офер",
  "Create offer": "Створити офер",
  "Create pool": "Створити пул",
  "Custom domain": "Власний домен",
  "Custom range": "Довільний діапазон",
  "Customise the dashboard for your agency or sub-account": "Налаштуйте дашборд для вашого агентства або субакаунту",
  "Daily cap": "Денний ліміт",
  "Dashboard hostname": "Hostname дашборду",
  "Decision": "Рішення",
  "Default offer URL": "URL офера за замовчуванням",
  "Defense": "Захист",
  "Delete A/B test": "Видалити A/B тест",
  "Delete API key": "Видалити ключ API",
  "Delete automation rule": "Видалити правило автоматизації",
  "Delete campaign": "Видалити кампанію",
  "Delete campaigns": "Видалити кампанії",
  "Delete connection": "Видалити з'єднання",
  "Delete domain": "Видалити домен",
  "Delete domain pool": "Видалити пул доменів",
  "Delete failed.": "Видалення не вдалося.",
  "Delete forwarder": "Видалити forwarder",
  "Delete integration": "Видалити інтеграцію",
  "Delete landing page": "Видалити лендинг",
  "Delete offer": "Видалити офер",
  "Delete pre-landing": "Видалити прелендинг",
  "Delete stream": "Видалити потік",
  "Delete traffic source": "Видалити джерело трафіку",
  "Delete webhook": "Видалити webhook",
  "Delete {n} selected campaign(s)? This cannot be undone.": "Видалити {n} вибрану(их) кампанію(ій)? Цю дію не можна скасувати.",
  "Denver (UTC-7)": "Денвер (UTC-7)",
  "Deselect all": "Зняти вибір з усіх",
  "Device": "Пристрій",
  "Disable 2FA": "Вимкнути 2FA",
  "Disable 2FA — enter a current code": "Вимкнути 2FA — введіть поточний код",
  "Disable auto-refresh": "Вимкнути автооновлення",
  "Disable failed": "Вимкнення не вдалося",
  "Disabled": "Вимкнено",
  "Discard DLQ entry": "Відхилити запис DLQ",
  "Dismissed": "Відхилено",
  "Do not block by classification": "Не блокувати за класифікацією",
  "Domain marked healthy": "Домен позначено як справний",
  "Domain not verified yet — check the DNS record.": "Домен ще не верифіковано — перевірте DNS-запис.",
  "Domain pool created": "Пул доменів створено",
  "Domain pool deleted": "Пул доменів видалено",
  "Domain pools": "Пули доменів",
  "Domain pulled from rotation": "Домен виведено з ротації",
  "Domain registered. Add the DNS record, then verify.": "Домен зареєстровано. Додайте DNS-запис, а потім верифікуйте.",
  "Done": "Готово",
  "Dubai (UTC+4)": "Дубай (UTC+4)",
  "EPC": "EPC",
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.": "Кожен рядок — це відвідувачі, які вперше прийшли за певний день. Стовпці показують накопичений CR за зміщенням у днях.",
  "Earnings per click": "Заробіток за клік",
  "Edit pre-landing": "Редагувати прелендинг",
  "Enable 2FA": "Увімкнути 2FA",
  "Enabled": "Увімкнено",
  "Enter a code from the app to confirm": "Введіть код із застосунку для підтвердження",
  "Enter a hostname": "Введіть hostname",
  "Enter an offer URL": "Введіть URL офера",
  "Enter the 6-digit code from your authenticator app, or one of your backup codes.": "Введіть 6-значний код із вашого застосунку автентифікації або один із резервних кодів.",
  "Epsilon (ε)": "Epsilon (ε)",
  "Error archiving campaign": "Помилка архівування кампанії",
  "Error cloning campaign": "Помилка клонування кампанії",
  "Expires": "Закінчується",
  "Expires after (days)": "Закінчується через (днів)",
  "Explicit blocked fingerprints (comma-separated)": "Явно заблоковані fingerprint-и (через кому)",
  "Export JSON": "Експортувати JSON",
  "Export XLSX": "Експортувати XLSX",
  "Extra countries (ISO-3166 alpha-2)": "Додаткові країни (ISO-3166 alpha-2)",
  "Failed to accept invite": "Не вдалося прийняти запрошення",
  "Failed to apply optimization": "Не вдалося застосувати оптимізацію",
  "Failed to compare": "Не вдалося порівняти",
  "Failed to copy tracking link": "Не вдалося скопіювати трекінгове посилання",
  "Failed to create campaign": "Не вдалося створити кампанію",
  "Failed to create pool": "Не вдалося створити пул",
  "Failed to delete key": "Не вдалося видалити ключ",
  "Failed to load campaigns": "Не вдалося завантажити кампанії",
  "Failed to load clicks log": "Не вдалося завантажити лог кліків",
  "Failed to load consent config": "Не вдалося завантажити конфігурацію згод",
  "Failed to load conversions": "Не вдалося завантажити конверсії",
  "Failed to load pre-landings": "Не вдалося завантажити прелендинги",
  "Failed to load profile": "Не вдалося завантажити профіль",
  "Failed to load sub-ID report": "Не вдалося завантажити звіт по sub ID",
  "Failed to preview optimization": "Не вдалося переглянути попередній перегляд оптимізації",
  "Failed to register domain": "Не вдалося зареєструвати домен",
  "Failed to revoke access": "Не вдалося відкликати доступ",
  "Failed to save": "Не вдалося зберегти",
  "Failed to update status": "Не вдалося оновити статус",
  "Fallback offer": "Резервний офер",
  "Filter junk traffic, block malicious IPs and review suspicious activity in one place.": "Фільтруйте сміттєвий трафік, блокуйте шкідливі IP та переглядайте підозрілу активність в одному місці.",
  "From (ISO-8601)": "Від (ISO-8601)",
  "GDPR: pseudonymize visitor IPs (hash before storage)": "GDPR: псевдонімізувати IP відвідувачів (хешувати перед збереженням)",
  "Generate a key to call the public REST API.": "Згенеруйте ключ для виклику публічного REST API.",
  "Go back": "Назад",
  "Go to Workspace": "Перейти до воркспейсу",
  "Group (optional)": "Група (необов'язково)",
  "Group by:": "Групувати за:",
  "Healthy": "Справна",
  "Hide xpnsr branding": "Приховати брендинг xpnsr",
  "Hosted pages and uploads": "Розміщені сторінки та файли",
  "Hostname": "Hostname",
  "Install": "Встановити",
  "Install failed.": "Встановлення не вдалося.",
  "Invalid 2FA code": "Невірний код 2FA",
  "Invalid SSO session": "Недійсна сесія SSO",
  "Invitation accepted!": "Запрошення прийнято!",
  "JS redirect (location.replace)": "JS-редирект (location.replace)",
  "Keyboard shortcuts": "Гарячі клавіші",
  "Keyboard shortcuts (?)": "Гарячі клавіші (?)",
  "Keyword exclude": "Виключення ключових слів",
  "Keyword include": "Включення ключових слів",
  "Label (operator-only)": "Мітка (лише для оператора)",
  "Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.": "Останні 200 записів згоди у цьому workspace. Використовуються як журнал аудиту для запитів DSAR / регуляторів.",
  "Last viewed": "Нещодавно переглянуті",
  "Layout": "Макет",
  "Layout & retention": "Макет і зберігання",
  "Live": "Наживо",
  "Live KPIs and breakdowns across campaigns, geos, devices.": "KPI в реальному часі та розбивки за кампаніями, GEO і пристроями.",
  "Loading marketplace…": "Завантаження marketplace…",
  "Loading...": "Завантаження...",
  "Login page subtitle": "Підзаголовок сторінки входу",
  "Logo URL": "URL логотипу",
  "London (UTC+0)": "Лондон (UTC+0)",
  "Lookback (days)": "Lookback (днів)",
  "Los Angeles (UTC-8)": "Лос-Анджелес (UTC-8)",
  "Make sure your tracking URLs include {key}=... parameter": "Переконайтеся, що ваші трекінгові посилання містять параметр {key}=...",
  "Manage profile, preferences, notifications and system configuration.": "Керуйте профілем, налаштуваннями, сповіщеннями та конфігурацією системи.",
  "Manage your offers and creatives": "Керуйте своїми оферами та креативами",
  "Manual entry secret": "Секрет для ручного введення",
  "Mark all read": "Позначити всі як прочитані",
  "Mark read": "Позначити як прочитане",
  "Marketplace": "Маркетплейс",
  "Match if referrer/params contain a keyword": "Збіг, якщо referrer/параметри містять ключове слово",
  "Meta refresh": "Meta refresh",
  "Metric": "Метрика",
  "Min clicks per stream": "Мін. кліків на потік",
  "Minimum ROI (%)": "Мінімальний ROI (%)",
  "Missing SSO session token": "Відсутній токен сесії SSO",
  "Missing invite token": "Відсутній токен запрошення",
  "Most clicks": "Найбільше кліків",
  "Most revenue": "Найбільше доходу",
  "Mumbai (UTC+5:30)": "Мумбаї (UTC+5:30)",
  "Must be an https:// URL. Leave blank to fall back to the xpnsr logo.": "Має бути адреса https://. Залиште порожнім, щоб використовувати логотип xpnsr.",
  "Name A→Z": "Назва А→Я",
  "Name Z→A": "Назва Я→А",
  "Name and target URL are required": "Назва та цільовий URL є обов'язковими",
  "Name is required.": "Назва є обов'язковою.",
  "New": "Новий",
  "New pre-landing": "Новий прелендинг",
  "New public dashboard link": "Нове публічне посилання на панель",
  "Newest first": "Спочатку нові",
  "Next": "Далі",
  "No active streams to optimize.": "Немає активних потоків для оптимізації.",
  "No clicks match these filters.": "Жодне клікання не відповідає цим фільтрам.",
  "No cohort data": "Немає когортних даних",
  "No consent records yet.": "Записів згод ще немає.",
  "No conversions yet": "Конверсій ще немає",
  "No data found for {key}": "Даних для {key} не знайдено",
  "No data yet.": "Даних ще немає.",
  "No description provided.": "Опис не надано.",
  "No internet connection": "Немає підключення до інтернету",
  "No notifications yet": "Сповіщень ще немає",
  "No performance data yet": "Даних про ефективність ще немає",
  "No pre-landings yet. Create one to start chaining traffic.": "Прелендингів ще немає. Створіть один, щоб почати ланцюжок трафіку.",
  "No public links yet. Create one to share read-only stats with advertisers.": "Публічних посилань ще немає. Створіть одне, щоб поділитися статистикою лише для читання з рекламодавцями.",
  "No results.": "Результатів немає.",
  "No templates match these filters.": "Жоден шаблон не відповідає цим фільтрам.",
  "No vendors disclosed.": "Постачальників не розкрито.",
  "No verified custom domains. Add one in Domains → Settings.": "Верифікованих власних доменів немає. Додайте один у розділі Домени → Налаштування.",
  "None": "Немає",
  "Notify only": "Лише сповістити",
  "Oldest first": "Спочатку старі",
  "Onboarding complete!": "Онбординг завершено!",
  "Only match if referrer contains one of these": "Збігатися лише якщо referrer містить одне з цих значень",
  "Open Campaigns": "Відкрити кампанії",
  "Open Domains page": "Відкрити сторінку доменів",
  "Open command palette": "Відкрити палітру команд",
  "Open landing pages": "Відкрити лендинги",
  "Open my tracking link": "Відкрити моє трекінгове посилання",
  "Operators host the static page; the tracker just routes clicks here first.": "Оператори розміщують статичну сторінку; трекер лише спочатку направляє кліки туди.",
  "Optimization": "Оптимізація",
  "Optional": "Необов'язково",
  "Pages library": "Бібліотека сторінок",
  "Parameter name, e.g. sub1": "Назва параметра, напр. sub1",
  "Pause": "Призупинити",
  "Performance": "Ефективність",
  "Performance overview": "Огляд ефективності",
  "Permanently discard this dead-letter entry? This cannot be undone.": "Назавжди видалити цей запис dead-letter? Цю дію неможливо скасувати.",
  "Please sign in first, then open the invite link again.": "Спочатку увійдіть в обліковий запис, а потім знову відкрийте посилання-запрошення.",
  "Please wait…": "Зачекайте…",
  "Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.": "Направте цей hostname на трекер через DNS. Відвідувачі побачать ваш брендинг до входу в систему.",
  "Pool name": "Назва пулу",
  "Postback IP whitelist": "Білий список IP для постбеків",
  "Pre-Landings": "Пре-лендинги",
  "Pre-landing created": "Пре-лендинг створено",
  "Pre-landing deleted": "Пре-лендинг видалено",
  "Pre-landing updated": "Пре-лендинг оновлено",
  "Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.": "Пре-лендинги дають змогу показати швидшу та більш комплаєнтну сторінку входу перед відправкою трафіку на офер. Ви можете додати її будь-коли.",
  "Preview": "Попередній перегляд",
  "Previous": "Назад",
  "Primary colour": "Основний колір",
  "Privacy policy URL": "URL політики конфіденційності",
  "Products": "Продукти",
  "Proposed": "Запропоновано",
  "Proposed drift": "Запропонований дрейф",
  "Proposed weights": "Запропоновані ваги",
  "Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.": "Захистіть свій обліковий запис TOTP-кодом із застосунку автентифікатора. Резервні коди дозволять увійти, якщо ви втратите пристрій.",
  "Public link created — copy it now, it won't be shown again.": "Публічне посилання створено — скопіюйте його зараз, воно більше не відображатиметься.",
  "Public link revoked.": "Публічне посилання відкликано.",
  "Public read-only links": "Публічні посилання лише для читання",
  "Publish": "Опублікувати",
  "Publishing…": "Публікація…",
  "Pull out of rotation": "Вивести з ротації",
  "Purpose (e.g. Analytics)": "Призначення (напр. Analytics)",
  "Quick start from template": "Швидкий старт із шаблону",
  "Quiz / review / bonus pages that intercept the click before the final landing or offer.": "Сторінки quiz / огляд / бонус, які перехоплюють клік перед фінальним лендингом або офером.",
  "ROI": "ROI",
  "ROI alert": "Сповіщення ROI",
  "Random seed (optional)": "Випадкове зерно (необов'язково)",
  "Read-only public view — generated by xpnsr-tracker.": "Публічний перегляд лише для читання — згенеровано xpnsr-tracker.",
  "Rebalance stream weights based on historical conversion rate using a multi-armed bandit.": "Перебалансувати ваги потоків на основі історичного CR за допомогою multi-armed bandit.",
  "Recent decisions": "Останні рішення",
  "Record retention (days)": "Зберігання записів (днів)",
  "Redirect method": "Метод редиректу",
  "Redirect mode": "Режим редиректу",
  "Referrer / Keyword filters": "Фільтри referrer / ключове слово",
  "Referrer exclude": "Виключити referrer",
  "Referrer include": "Включити referrer",
  "Region preset": "Пресет регіону",
  "Region scope": "Область регіону",
  "Register a custom hostname so your tracking links resolve under your own brand.": "Зареєструйте власний hostname, щоб ваші трекінгові посилання працювали під вашим брендом.",
  "Register hostname": "Зареєструвати hostname",
  "Reject button label": "Мітка кнопки відхилення",
  "Rejected": "Відхилено",
  "Remove": "Видалити",
  "Remove template": "Видалити шаблон",
  "Remove this template? This cannot be undone.": "Видалити цей шаблон? Цю дію не можна скасувати.",
  "Reset branding": "Скинути брендинг",
  "Reset to defaults": "Скинути до стандартних",
  "Resetting…": "Скидання…",
  "Restore": "Відновити",
  "Restore to rotation": "Повернути до ротації",
  "Return on investment": "Повернення на інвестиції",
  "Rev.": "Дохід",
  "Revenue comparison": "Порівняння доходів",
  "Revoke": "Відкликати",
  "Revoke failed": "Відкликання не вдалося",
  "Revoke public link": "Відкликати публічне посилання",
  "Risk score threshold (0.0 – 1.0)": "Поріг оцінки ризику (0.0 – 1.0)",
  "Round robin": "Round robin",
  "Routing": "Маршрутизація",
  "Row-level drill-down into incoming clicks: country, device, stream, and variant.": "Деталізація вхідних кліків по рядках: країна, пристрій, потік і варіант.",
  "Run a preview to see proposed weights.": "Запустіть попередній перегляд, щоб побачити запропоновані ваги.",
  "SSO failed": "Помилка SSO",
  "SSO is not configured": "SSO не налаштовано",
  "SSO sign-in failed": "Вхід через SSO не вдався",
  "Save branding": "Зберегти брендинг",
  "Scan the QR code with your authenticator app": "Відскануйте QR-код додатком автентифікатора",
  "Search": "Пошук",
  "Search by name, description, or slug. Filter by type or tag.": "Шукайте за назвою, описом або slug. Фільтруйте за типом або тегом.",
  "Search…": "Пошук…",
  "Secondary colour": "Додатковий колір",
  "Select all": "Вибрати все",
  "Select at least 2 campaigns": "Виберіть щонайменше 2 кампанії",
  "Select campaigns (2–10)": "Виберіть кампанії (2–10)",
  "Sending…": "Надсилання…",
  "Set up rules, notifications and triggered actions for your campaigns.": "Налаштуйте правила, сповіщення та автоматичні дії для своїх кампаній.",
  "Set up your tracker": "Налаштуйте свій трекер",
  "Setup failed": "Налаштування не вдалося",
  "Share a token-gated dashboard URL with advertisers without giving them an account.": "Поділіться з рекламодавцями URL дашборду, захищеним токеном, без створення їм облікового запису.",
  "Shareable URL": "URL для поширення",
  "Shared dashboard": "Спільний дашборд",
  "Side-by-side metrics for selected campaigns": "Метрики вибраних кампаній поруч",
  "Sign in with Google": "Увійти через Google",
  "Sign in with Microsoft": "Увійти через Microsoft",
  "Singapore (UTC+8)": "Сінгапур (UTC+8)",
  "Size": "Розмір",
  "Skip for now": "Пропустити зараз",
  "Skip if referrer contains one of these": "Пропустити, якщо referrer містить одне з наведених",
  "Skip if referrer/params contain a keyword": "Пропустити, якщо referrer/параметри містять ключове слово",
  "Skip this step until you have a campaign — you can finish setup from the Campaigns page.": "Пропустіть цей крок, поки у вас немає кампанії — налаштування можна завершити на сторінці «Кампанії».",
  "Skipped (below min_clicks_per_stream)": "Пропущено (нижче min_clicks_per_stream)",
  "Smoothed CR": "Згладжений CR",
  "Sort by": "Сортувати за",
  "Split traffic across variants to find what converts best.": "Розподіліть трафік між варіантами, щоб знайти той, що краще конвертує.",
  "Step {step} of {total}": "Крок {step} із {total}",
  "Sticky (per-visitor)": "Закріплений (per-visitor)",
  "Stream": "Потік",
  "Stream ID": "ID потоку",
  "Stream configured": "Потік налаштовано",
  "Streams decide which offer each visitor lands on. Configure your default stream and you\\'ll have a working tracking link.": "Потоки визначають, на який офер потрапить кожен відвідувач. Налаштуйте потік за замовчуванням — і ви отримаєте робоче трекінгове посилання.",
  "Sub-ID drill-down": "Деталізація за Sub ID",
  "Submission failed.": "Надсилання не вдалося.",
  "Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.": "Шаблони публікуються автоматично. Slug формується з назви; якщо він збігається з наявним шаблоном, додається числовий суфікс.",
  "Submit a template": "Надіслати шаблон",
  "Submit template": "Надіслати шаблон",
  "Sydney (UTC+11)": "Сідней (UTC+11)",
  "São Paulo (UTC-3)": "Сан-Паулу (UTC-3)",
  "TLS fingerprint (JA3 / JA4)": "TLS fingerprint (JA3 / JA4)",
  "Tags (comma-separated)": "Теги (через кому)",
  "Tags:": "Теги:",
  "Template": "Шаблон",
  "Template body copied to clipboard.": "Тіло шаблону скопійовано до буфера обміну.",
  "Template installed. Body shown in detail dialog.": "Шаблон встановлено. Тіло відображається у вікні деталей.",
  "Template marketplace": "Маркетплейс шаблонів",
  "Template published as {slug}.": "Шаблон опубліковано як {slug}.",
  "Template removed.": "Шаблон видалено.",
  "The token will only be shown once after creation — copy it immediately.": "Токен буде показано лише один раз після створення — скопіюйте його одразу.",
  "Third-party processors disclosed to the visitor (max 50).": "Сторонні процесори, розкриті відвідувачу (макс. 50).",
  "This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.": "Це посилання не потребує автентифікації. Будь-хто, хто має його, може переглядати вибрані метрики до закінчення терміну дії або відкликання.",
  "This member will lose access to this workspace immediately.": "Цей учасник негайно втратить доступ до цього воркспейсу.",
  "This shared link has expired or been revoked.": "Це спільне посилання закінчило термін дії або було відкликано.",
  "This shared link is not valid.": "Це спільне посилання недійсне.",
  "This will permanently delete \"{name}\" and all associated clicks, conversions and postback events. This cannot be undone.": "Це назавжди видалить \"{name}\" та всі пов'язані кліки, конверсії й події постбеку. Цю дію неможливо скасувати.",
  "This will permanently delete \"{name}\" and all its variants.": "Це назавжди видалить \"{name}\" та всі його варіанти.",
  "This will permanently delete \"{name}\" and remove it from all campaigns.": "Це назавжди видалить \"{name}\" і прибере його з усіх кампаній.",
  "This will permanently delete \"{name}\".": "Це назавжди видалить \"{name}\".",
  "This will permanently delete \"{name}\". Campaigns using this domain will fall back to the default domain.": "Це назавжди видалить \"{name}\". Кампанії, що використовують цей домен, переключаться на домен за замовчуванням.",
  "This will permanently delete \"{name}\". Campaigns using this source will lose their tracking parameters.": "Це назавжди видалить \"{name}\". Кампанії, що використовують це джерело трафіку, втратять свої трекінгові параметри.",
  "This will permanently delete pool \"{name}\".": "Це назавжди видалить пул \"{name}\".",
  "This will permanently delete rule \"{name}\".": "Це назавжди видалить правило \"{name}\".",
  "This will permanently delete stream \"{name}\".": "Це назавжди видалить потік \"{name}\".",
  "This will permanently delete this ad account connection. Cost syncing will stop.": "Це назавжди видалить це підключення рекламного акаунта. Синхронізацію витрат буде зупинено.",
  "This will permanently delete this conversion forwarder.": "Це назавжди видалить цей форвардер конверсій.",
  "This will permanently delete webhook \"{name}\". Events will no longer be forwarded.": "Це назавжди видалить вебхук \"{name}\". Події більше не пересилатимуться.",
  "This will permanently revoke this API key. Any integrations using it will stop working.": "Це назавжди відкличе цей API-ключ. Усі інтеграції, що його використовують, перестануть працювати.",
  "This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.": "Це скине всі налаштування брендингу до стандартних. Логотип, кольори та власний домен буде видалено.",
  "This will reset two-factor authentication for this member. They will need to re-enrol.": "Це скине двофакторну автентифікацію для цього учасника. Йому потрібно буде налаштувати її знову.",
  "Title": "Заголовок",
  "Title, body, and button labels shown to the visitor.": "Заголовок, текст і підписи кнопок, що відображаються відвідувачу.",
  "To (ISO-8601)": "До (ISO-8601)",
  "Toggle navigation": "Перемкнути навігацію",
  "Tokyo (UTC+9)": "Токіо (UTC+9)",
  "Too many requests — please retry in a moment.": "Забагато запитів — спробуйте ще раз за мить.",
  "Track click usage and switch plans. Billing renews monthly.": "Відстежуйте використання кліків і змінюйте тарифи. Оплата поновлюється щомісяця.",
  "Tracking domain": "Трекінговий домен",
  "Tracking link copied to clipboard": "Трекінгове посилання скопійовано до буфера обміну",
  "Tune the bandit before running a preview. Apply only writes weights to active streams.": "Налаштуйте бандита перед запуском попереднього перегляду. «Застосувати» записує ваги лише в активні потоки.",
  "Two-factor authentication": "Двофакторна автентифікація",
  "Two-factor code": "Код двофакторної автентифікації",
  "Type": "Тип",
  "Type a command or search…": "Введіть команду або пошуковий запит…",
  "Ungrouped": "Без групи",
  "Unlimited": "Без обмежень",
  "Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.": "Завантажте архів лендингу (.zip) або оберіть розміщений шаблон прелендингу з бібліотеки.",
  "Upload, organize and reuse landing pages across your campaigns.": "Завантажуйте, організовуйте та повторно використовуйте лендинги у своїх кампаніях.",
  "Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.": "Використовує базовий список (Python requests, Go net/http, curl, headless Chrome) плюс ваші налаштування воркспейсу.",
  "Vendor list": "Список вендорів",
  "Vendor name (e.g. Google Analytics)": "Назва вендора (напр. Google Analytics)",
  "Verify now": "Верифікувати зараз",
  "Verifying…": "Верифікація…",
  "View": "Перегляд",
  "Views": "Перегляди",
  "Visible metrics": "Видимі метрики",
  "Visitor": "Відвідувач",
  "Visual identity": "Візуальна ідентичність",
  "Weight floor (%)": "Мінімальна вага (%)",
  "Weighted": "Зважений",
  "Welcome to ACME Tracker — sign in to continue": "Ласкаво просимо до ACME Tracker — увійдіть, щоб продовжити",
  "When disabled, the public widget responds with required:false so landing pages skip rendering entirely.": "Якщо вимкнено, публічний віджет повертає required:false, тому лендинг повністю пропускає рендеринг.",
  "When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.": "Якщо задано, трекер автоматично додає ?<param>=<click_id> до URL-адрес переадресації. Залиште порожнім, щоб вимкнути. Використовуйте {click_id} у цільовому URL для повного контролю.",
  "Workflows": "Воркфлоу",
  "Workspace default domain": "Домен воркспейсу за замовчуванням",
  "Your tracking link": "Ваше трекінгове посилання",
  "clear tag": "очистити тег",
  "clicks": "кліки",
  "connections": "підключення",
  "domains": "домени",
  "e.g. 185.45.12.1, 91.108.0.0": "напр. 185.45.12.1, 91.108.0.0",
  "e.g. Facebook, Google, Tier 1": "напр. Facebook, Google, Tier 1",
  "e.g. MaxBounty CPA": "напр. MaxBounty CPA",
  "e.g. adcombo, cpa, status": "напр. adcombo, cpa, status",
  "group.<key>": "group.<key>",
  "installs": "інсталяції",
  "live": "наживо",
  "logo": "логотип",
  "max change": "макс. зміна",
  "no": "ні",
  "or continue with": "або продовжити з",
  "revoked": "відкликано",
  "rows": "рядки",
  "to close": "щоб закрити",
  "to navigate": "для навігації",
  "to select": "щоб вибрати",
  "weight units": "одиниці ваги",
  "yes": "так",
  "{count} conversions": "{count} конверсій",
  "{key} breakdown": "Розбивка за {key}",
  "{n} selected": "вибрано: {n}",
  "Δ": "Δ",
  "Sub-ID reports": "Звіти за sub ID",
  "Ad accounts": "Рекламні акаунти",
  "API docs": "Документація API",
  "Drill-down by sub1–sub15: clicks, conversions, CR": "Деталізація за sub1–sub15: кліки, конверсії, CR",
  "Side-by-side metrics for multiple campaigns": "Метрики кількох кампаній поруч",
  "Step-by-step user guide for every feature": "Покрокова інструкція для кожної функції",
  "Switch to dark theme": "Перейти на темну тему",
  "Switch to light theme": "Перейти на світлу тему",
  "Page not found": "Сторінку не знайдено",
  "The page you are looking for does not exist or has been moved.": "Сторінка, яку ви шукаєте, не існує або була переміщена.",
  "Access denied": "Доступ заборонено",
  "You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.": "У вас немає дозволу на перегляд цієї сторінки. Зверніться до адміністратора воркспейсу, якщо вважаєте, що це помилка.",
  "Server error": "Помилка сервера",
  "Something went wrong on our end. Please try again later or contact support.": "На нашому боці щось пішло не так. Спробуйте пізніше або зверніться до служби підтримки.",
  "View campaigns": "Переглянути кампанії",
  "List and open campaigns and their stats.": "Переглядайте список кампаній та їхню статистику.",
  "Create campaigns": "Створити кампанії",
  "Add new campaigns and their default streams.": "Додавайте нові кампанії та їхні потоки за замовчуванням.",
  "Edit campaigns": "Редагувати кампанії",
  "Change campaign settings, target URL, status.": "Змінюйте налаштування кампанії, цільовий URL та статус.",
  "Permanently remove a campaign and its history.": "Назавжди видаляє кампанію та її історію.",
  "View landings": "Переглянути лендинги",
  "Browse the landing-page library.": "Перегляньте бібліотеку лендингів.",
  "Edit landings": "Редагувати лендинги",
  "Upload, edit, and delete landings.": "Завантажуйте, редагуйте та видаляйте лендинги.",
  "View offers": "Переглянути офери",
  "Browse the offer library.": "Перегляньте бібліотеку оферів.",
  "Edit offers": "Редагувати офери",
  "Create, edit, and delete offers.": "Створюйте, редагуйте та видаляйте офери.",
  "View anti-fraud": "Переглянути антифрод",
  "Read filter list, blocked samples, audit feed.": "Перегляньте список фільтрів, заблоковані зразки та журнал аудиту.",
  "Edit anti-fraud filters": "Редагувати антифрод-фільтри",
  "Create / update / delete fraud filters and IP lists.": "Створюйте / оновлюйте / видаляйте фрод-фільтри та списки IP.",
  "Manage TLS fingerprint overrides": "Керувати перевизначеннями TLS-відбитків",
  "Pin JA3 / JA4 hashes per-workspace (overrides the seed list).": "Прив'яжіть хеші JA3 / JA4 для конкретного workspace (перевизначає базовий список).",
  "View reports": "Переглянути звіти",
  "Open the analytics dashboard and saved reports.": "Відкрийте аналітичну панель і збережені звіти.",
  "Export reports": "Експортувати звіти",
  "Download CSV / JSON report exports.": "Завантажуйте експорти звітів у форматі CSV / JSON.",
  "View automation rules": "Переглянути правила автоматизації",
  "Read the rules engine and execution history.": "Перегляньте рушій правил та історію виконань.",
  "Edit automation rules": "Редагувати правила автоматизації",
  "Create / update / delete automation rules.": "Створюйте / оновлюйте / видаляйте правила автоматизації.",
  "View integrations": "Переглянути інтеграції",
  "Browse integration configurations.": "Перегляньте конфігурації інтеграцій.",
  "Edit integrations": "Редагувати інтеграції",
  "Connect / disconnect ad accounts and webhooks.": "Підключайте / відключайте рекламні акаунти та вебхуки.",
  "View postbacks": "Переглянути постбеки",
  "Browse postbacks and the CAPI dead-letter queue.": "Перегляньте постбеки та чергу dead-letter CAPI.",
  "Edit postbacks": "Редагувати постбеки",
  "Configure postbacks, replay / discard CAPI DLQ entries.": "Налаштовуйте постбеки, повторно надсилайте / відхиляйте записи з DLQ CAPI.",
  "Invite members": "Запрошувати учасників",
  "Send invite links to new teammates.": "Надсилайте запрошувальні посилання новим учасникам команди.",
  "Change member role": "Змінити роль учасника",
  "Promote / demote existing members.": "Підвищуйте / знижуйте роль наявних учасників.",
  "Remove members": "Видаляти учасників",
  "Revoke a teammate's access.": "Відкликайте доступ учасника команди.",
  "Edit workspace settings": "Редагувати налаштування workspace",
  "Change workspace currency, timezone, branding.": "Змінюйте валюту, часовий пояс і брендинг workspace.",
  "Edit permission matrix": "Редагувати матрицю дозволів",
  "Override the default permission matrix for this workspace.": "Перевизначте матрицю дозволів за замовчуванням для цього workspace.",
  "View billing": "Переглянути білінг",
  "See plan, invoices, payment method.": "Перегляньте план, рахунки-фактури та спосіб оплати.",
  "Change plan, update payment method.": "Змінюйте план, оновлюйте спосіб оплати.",
  "View audit log": "Переглянути журнал аудиту",
  "Read the workspace audit feed.": "Перегляньте журнал аудиту workspace.",
  "View tracking domains": "Переглянути трекінгові домени",
  "Browse the tracking-domain list.": "Перегляньте список трекінгових доменів.",
  "Edit tracking domains": "Редагувати трекінгові домени",
  "Add / remove tracking domains.": "Додавайте / видаляйте трекінгові домени.",
  "View API keys": "Переглянути ключі API",
  "List existing API keys (does not reveal the secret).": "Список наявних ключів API (секрет не розкривається).",
  "Manage API keys": "Керувати ключами API",
  "Create / revoke API keys.": "Створюйте / відкликайте ключі API.",
  "Cloaking — send bots to a safe page": "Клоакінг — відправляйте ботів на безпечну сторінку",
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.": "Клоакінг на власному хостингу. Боти, модератори рекламних мереж, IP дата-центрів/проксі та пошукові краулери бачать безпечну (білу) сторінку; справжні користувачі потрапляють на реальний офер. Класифікація базується на власних механізмах трекера — перевірці ботів / IP / DNS краулерів — без сторонніх сервісів.",
  "Safe page URL": "URL безпечної сторінки",
  "The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.": "Сумісна сторінка, яку бачать боти/краулери. Має бути абсолютним URL http(s). У режимі SEO це сторінка, яку індексують верифіковані пошукові краулери.",
  "Bots & spoofed crawlers": "Боти та підроблені краулери",
  "Verified search crawlers": "Верифіковані пошукові краулери",
  "Datacenter / Tor IPs": "IP дата-центрів / Tor",
  "Proxy / VPN IPs": "IP проксі / VPN",
  "Enter a valid http(s) Safe page URL for cloaking": "Введіть коректний URL http(s) безпечної сторінки для клоакінгу",
  "Cloaked": "Клоаковано",
  "All traffic": "Весь трафік",
  "Cloaked only": "Лише клоаковані",
  "Real only": "Лише реальні",
  "Cloaking": "Клоакінг",
  "Bots and crawlers sent to the safe page vs humans to the offer": "Боти та краулери направляються на безпечну сторінку, користувачі — на офер",
  "last {n} days": "останні {n} днів",
  "Cloaked → safe page": "Клоаковані → безпечна сторінка",
  "Real → offer": "Реальні → офер",
  "Cloak rate": "Показник клоакінгу",
  "Spoofed crawlers": "Підроблені краулери",
  "Verified crawlers": "Верифіковані краулери",
  "Datacenter / Tor": "Дата-центр / Tor",
  "SEO split (crawlers → index, humans → funnel)": "SEO split (краулери → індекс, користувачі → воронка)",
  "SEO crawler split on: verified crawlers index the page, humans go to the funnel": "SEO split краулерів увімкнено: верифіковані краулери індексують сторінку, користувачі потрапляють у воронку",
  "SEO crawler split off": "SEO split краулерів вимкнено",
  "When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.": "Коли увімкнено, DNS-верифіковані пошукові краулери отримують індексну сторінку (для ранжування), а користувачі направляються у воронку прив'язаної кампанії. Потрібна індексна сторінка + кампанія, прив'язана до цього домену.",
  "Fallback robots/sitemap": "Fallback robots/sitemap",
  "Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.": "Роздавати згенерований robots.txt / sitemap.xml у корені домену ЛИШЕ якщо у вашому завантаженому бандлі їх немає. Ваші власні SEO-файли завжди мають пріоритет.",
  "Fallback robots.txt/sitemap.xml on (only when your bundle has none)": "Fallback robots.txt/sitemap.xml увімкнено (лише якщо у вашому бандлі їх немає)",
  "Fallback robots.txt/sitemap.xml off": "Fallback robots.txt/sitemap.xml вимкнено",
  "Root: stable index": "Root: стабільний індекс",
  "Root: SEO split": "Root: SEO split",
  "Root: funnel": "Root: воронка",
  "Root: 404": "Root: 404",
  "own": "власний",
  "fallback": "fallback",
  "none": "немає",
  "indexable": "індексований",
  "no-index": "no-index",
  "Registration": "Реєстрація",
  "Deposit": "Депозит",
  "Trash": "Кошик",
  "Hide": "Приховати",
  "Show": "Показати",
  "Import from source": "Імпортувати з джерела",
  "Postback token": "Токен постбеку",
  "Require postback token": "Вимагати токен постбеку",
  "Network macros": "Макроси мережі",
  "FTD · Deposit (sale)": "FTD · Депозит (продаж)",
  "Chargeback (reject)": "Chargeback (відхилення)",
  "This campaign has no source with parameters": "У цій кампанії немає джерела з параметрами",
  "Macros imported from the source — click Save": "Макроси імпортовано з джерела — натисніть Зберегти",
  "Save the campaign once to generate the token.": "Збережіть кампанію один раз, щоб згенерувати токен.",
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.": "Якщо УВІМКНЕНО, вхідні постбеки повинні містити токен цієї кампанії, інакше вони відхиляються (401). Вимкніть, якщо мережа (наприклад, TrackBox) надсилає ОДИН спільний постбек для всіх кампаній: видаліть &token=… з цього URL, і конверсії зіставлятимуться за click_id.",
  "Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).": "Перевірку токена вимкнено — постбеки приймаються за click_id без токена (видаліть &token=… з URL у вашій мережі).",
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.": "TrackBox: передайте свій click_id у параметрі Affclickid посилання офера, щоб {affclickid} повертався до цієї кампанії. Метод GET.",
  "Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.": "Generic: передайте свій click_id у посиланні офера, щоб він повертався до цієї кампанії як {click_id}. Метод GET.",
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.": "Subid: передайте свій click_id у параметрі subid посилання офера, щоб {subid} повертався до цієї кампанії. Метод GET.",
  "Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.": "Введіть токен бота і chat_id — будуть додані постбеки Lead і Deposit з готовим повідомленням (Кампанія, Sub1..4, Джерело, Payout). Потім натисніть Зберегти.",
  "What is XPNSR Tracker": "Що таке XPNSR Tracker",
  "Links & aliases": "Посилання та аліаси",
  "Postbacks": "Постбеки",
  "Macros": "Макроси",
  "Redirect modes": "Режими редиректу",
  "A/B tests": "A/B тести",
  "Glossary": "Глосарій",
  "Partners & lead forms": "Партнери та лід-форми",
  "Google Ads & conversions": "Google Ads та конверсії",
  "Reports (Report Builder)": "Звіти (Report Builder)",
  "Failed to copy": "Не вдалося скопіювати",
  "Domain opened for indexing": "Домен відкрито для індексування",
  "Domain closed from indexing": "Домен закрито від індексування",
  "Index page set": "Індексну сторінку встановлено",
  "Index page cleared": "Індексну сторінку очищено",
  "Server migration (admin only)": "Міграція сервера (тільки для адміна)",
  "Current server IP:": "Поточний IP сервера:",
  "Step 1. Provision a new server": "Крок 1. Підготуйте новий сервер",
  "Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.": "Створіть EC2-інстанс у AWS (Ubuntu, відкриті порти 80 і 443), підключіться через SSH і вставте всю цю команду. Наприкінці вона виведе IP нового сервера.",
  "Step 2. Enter the new IP": "Крок 2. Введіть новий IP",
  "Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.": "Вставте IP з Кроку 1 і натисніть Зберегти. Кожен клієнт одразу отримає новий IP для свого A-запису — перезапуск не потрібен.",
  "Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.": "Порада: якщо ви перепризначите старий Elastic IP новому серверу в AWS, тут нічого змінювати не потрібно — і у клієнтів теж.",
  "Open for search engines — click to close": "Відкрито для пошукових систем — натисніть, щоб закрити",
  "Closed from search engines — click to open": "Закрито від пошукових систем — натисніть, щоб відкрити",
  "Indexable": "Індексується",
  "No-index": "No-index",
  "Index page (SEO, served at the root with 200):": "Індексна сторінка (SEO, роздається в кореневому каталозі з кодом 200):",
  "— none (root opens the funnel) —": "— немає (корінь відкриває воронку) —",
  "Custom API (any CRM)": "Custom API (будь-який CRM)",
  "TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.": "Облікові дані акаунта TrackBox (dashboard → API Testing). Налаштуйте один раз для акаунта — офери посилатимуться на цього партнера.",
  "Username": "Ім'я користувача",
  "Signup path": "Шлях реєстрації",
  "Pull path": "Шлях pull",
  "Pull type": "Тип pull",
  "Auto pull-sync": "Автоматичний pull-sync",
  "Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.": "Універсальна інтеграція з будь-яким CRM партнера. Опишіть його API-запит для реєстрації лідів — трекер надішле туди дані форми та виконає редирект за посиланням із відповіді.",
  "API URL (base)": "API URL (базовий)",
  "Body format": "Формат body",
  "Headers": "Заголовки",
  "(one \"Key: value\" per line, macros allowed)": "(один рядок \"Key: value\", макроси дозволені)",
  "Body template (JSON)": "Шаблон body (JSON)",
  "(values are macros in curly braces)": "(значення — макроси у фігурних дужках)",
  "Redirect field": "Поле редиректу",
  "Success field (optional)": "Поле успіху (необов'язково)",
  "Success value (optional)": "Значення успіху (необов'язково)",
  "plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.": "плюс будь-які поля форми та параметри офера. Поле редиректу — це шлях у JSON-відповіді (наприклад, data.url); якщо порожнє, використовується перше знайдене посилання http(s) у відповіді.",
  "Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.": "Налаштуйте партнера/CRM тут один раз, і офери посилатимуться на нього. TrackBox / Tigloo — готовий адаптер; Custom API підходить для будь-якого іншого CRM. Ліди з форм оферів надсилаються до вибраного партнера.",
  "Affiliate routing (form offers)": "Роутинг до партнерів (офери з формою)",
  "Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.": "Направляйте цей офер до одного або кількох партнерів із вагами (спліт/ротація). Неактивні партнери пропускаються (наприклад, до узгодження умов). Лід розподіляється за вагою; у разі відхилення переходить до наступного партнера.",
  "Telegram lead alerts": "Сповіщення про ліди в Telegram",
  "(sent on EVERY submit — even test/error)": "(надсилається при КОЖНОМУ сабміті — навіть тестовому/помилковому)",
  "Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.": "Кожен лід, зібраний вашими оферами з формою, потрапляє сюди — прийняті, відхилені та тестові. Фільтруйте, експортуйте в CSV та перепродавайте. Статуси оновлюються через постбеки та pull-sync.",
  "Hint": "Підказка",
  "Cycle language": "Змінити мову",
  "Switch to {lang}": "Перейти на {lang}",
  "Current language: {lang}": "Поточна мова: {lang}",
  "Scroll to top": "Прокрутити вгору",
  "Something went wrong": "Щось пішло не так",
  "An unexpected error occurred.": "Сталася непередбачена помилка.",
  "Reload page": "Перезавантажити сторінку",
  "My first campaign": "Моя перша кампанія",
  "CPA Network": "CPA Network",
  "Main FB pixel": "Основний піксель FB",
  "zapier integration": "інтеграція з zapier",
  "Bot token": "Токен бота",
  "Chat ID": "Chat ID",
  "(no match)": "(немає збігів)",
  "+ Upload": "+ Завантажити",
  "A custom conversion type with its own reporting rules and status transitions.": "Власний тип конверсії з індивідуальними правилами звітності та переходами статусів.",
  "A formula over base metrics rendered as a report column.": "Формула на основі базових метрик, що відображається як колонка звіту.",
  "A/B testing": "A/B тестування",
  "Add a manual cost, or connect an ad account to sync spend automatically.": "Додайте витрати вручну або підключіть рекламний акаунт для автоматичної синхронізації витрат.",
  "Add cost": "Додати витрати",
  "Add from preset": "Додати з пресету",
  "Add manual cost": "Додати витрати вручну",
  "Add partner route": "Додати маршрут партнера",
  "Add range": "Додати діапазон",
  "Add value": "Додати значення",
  "Added to blacklist": "Додано до чорного списку",
  "Added to whitelist": "Додано до білого списку",
  "Adjust the period or campaign filter.": "Скоригуйте період або фільтр кампанії.",
  "Affiliate CRM — push leads via API": "Афіліатна CRM — надсилання лідів через API",
  "Affiliate network postback": "Постбек партнерської мережі",
  "All offers": "Всі офери",
  "All rows": "Всі рядки",
  "Allowed next statuses": "Дозволені наступні статуси",
  "Amount": "Сума",
  "Any date": "Будь-яка дата",
  "Any status": "Будь-який статус",
  "Arithmetic over base metrics. Supported: + - * / ( ) and numbers.": "Арифметичні дії над базовими метриками. Підтримуються: + - * / ( ) та числа.",
  "Back to streams": "Назад до потоків",
  "Base metrics": "Базові метрики",
  "Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.": "Прив'яжіть власний домен, щоб замаскувати трекінгові посилання. Направте A-запис на ваш трекінговий сервер і підтвердіть право власності через TXT-запис.",
  "Black": "Чорний",
  "Black / white lists": "Чорні / білі списки",
  "Blacklist": "Чорний список",
  "Blacklisted": "У чорному списку",
  "Blank referrer (JS)": "Порожній referrer (JS)",
  "Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.": "Зарахуйте витрати до кампанії. Вони враховуються у вартості кампанії, що використовується для ROI та дашбордів.",
  "Bot": "Бот",
  "Bot IP addresses": "IP-адреси ботів",
  "Bot User-Agent signatures": "User-Agent сигнатури ботів",
  "Bot lists": "Списки ботів",
  "Bot lists saved": "Списки ботів збережено",
  "Breakdown": "Розбивка",
  "Bucket": "Bucket",
  "Built-in statuses": "Вбудовані статуси",
  "By destination": "За призначенням",
  "By stream": "За потоком",
  "CPS (per sale)": "CPS (за продаж)",
  "CPuC (per unique click)": "CPuC (за унікальний клік)",
  "CRM": "CRM",
  "CRM response": "Відповідь CRM",
  "Cadence": "Каденція",
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": "Календарні дати, коли потік активний (часовий пояс власника). Залиште початок або кінець порожнім для відкритого діапазону. «Не є» інвертує діапазон.",
  "California, Bavaria, Moscow Oblast": "Каліфорнія, Баварія, Московська область",
  "Canonical status stored on each conversion. Auto-generated from the name if left blank.": "Канонічний статус, що зберігається при кожній конверсії. Генерується автоматично з назви, якщо залишити порожнім.",
  "Click API (server-to-server)": "Click API (server-to-server)",
  "Code (slug)": "Код (slug)",
  "Column key in reports. Auto-generated from the name if left blank.": "Ключ колонки у звітах. Генерується автоматично з назви, якщо залишити порожнім.",
  "Comma-separated email addresses.": "Адреси e-mail через кому.",
  "Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).": "Компенсує вартість трафіку, втраченого між джерелом і трекером: реальна вартість = база / (1 − втрата%/100).",
  "Configure any partner CRM lead API": "Налаштуйте API лідів будь-якого партнерського CRM",
  "Conversion date": "Дата конверсії",
  "Conversion statuses": "Статуси конверсій",
  "Conversion type created": "Тип конверсії створено",
  "Conversion type deleted": "Тип конверсії видалено",
  "Conversion type updated": "Тип конверсії оновлено",
  "Conversion types": "Типи конверсій",
  "Cookie (default)": "Cookie (за замовчуванням)",
  "Copy blacklist": "Копіювати чорний список",
  "Copy list": "Копіювати список",
  "Copy whitelist": "Копіювати білий список",
  "Cost entries": "Записи витрат",
  "Cost entry added": "Запис витрат додано",
  "Cost entry deleted": "Запис витрат видалено",
  "Count conversions of this type toward the offer daily cap.": "Враховувати конверсії цього типу в денний кап офера.",
  "Counts against offer cap": "Враховується в капі офера",
  "Counts in conversions": "Враховується в конверсіях",
  "Counts in revenue": "Враховується в доходах",
  "Counts vs cap": "Лічильник vs кап",
  "Create conversion type": "Створити тип конверсії",
  "Create custom metric": "Створити кастомну метрику",
  "Create metric": "Створити метрику",
  "Create one like uCR = conversions / unique_clicks * 100.": "Створіть таку як uCR = conversions / unique_clicks * 100.",
  "Create one to export campaign performance on demand.": "Створіть один, щоб експортувати результати кампанії на вимогу.",
  "Create one to map partner statuses like FTD or second deposit.": "Створіть один, щоб мапувати статуси партнера, наприклад FTD або другий депозит.",
  "Create one to receive recurring reports by email.": "Створіть один, щоб отримувати регулярні звіти на e-mail.",
  "Create type": "Створити тип",
  "Custom bot IPs/CIDRs and UA signatures for the bot-detection filter": "Кастомні IP/CIDR ботів і сигнатури UA для фільтра виявлення ботів",
  "Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.": "Кастомні IP/CIDR ботів і сигнатури User-Agent, що використовуються антифрод-фільтром виявлення ботів.",
  "Custom conversion types: map network statuses, reporting flags and transition rules": "Кастомні типи конверсій: мапування статусів мережі, прапорців звітності та правил переходів",
  "Custom metric created": "Кастомну метрику створено",
  "Custom metric deleted": "Кастомну метрику видалено",
  "Custom metric updated": "Кастомну метрику оновлено",
  "Custom metrics": "Кастомні метрики",
  "DSAR erasure completed": "Видалення даних DSAR завершено",
  "DSAR export ready": "Експорт DSAR готовий",
  "Daily": "Щодня",
  "Data subject": "Суб'єкт даних",
  "Data-subject access (Article 15) and erasure (Article 17) by identifier.": "Доступ до даних суб'єкта (Стаття 15) та їх видалення (Стаття 17) за ідентифікатором.",
  "Data-subject export (Art. 15) and erasure (Art. 17) by identifier": "Експорт даних суб'єкта (Ст. 15) та видалення (Ст. 17) за ідентифікатором",
  "Date": "Дата",
  "Date range": "Діапазон дат",
  "Day": "День",
  "Day of month (1-31)": "День місяця (1–31)",
  "Day of week": "День тижня",
  "Decimals": "Десяткові знаки",
  "Define a reusable report and its grouping/metrics.": "Визначте звіт для повторного використання та його групування/метрики.",
  "Define custom conversion types, map network statuses and control reporting semantics.": "Визначте власні типи конверсій, зіставте статуси мережі та керуйте семантикою звітування.",
  "Define formula-based report columns over base metrics (CR, EPC, ROI variants).": "Визначте колонки звіту на основі формул за базовими метриками (CR, EPC, варіанти ROI).",
  "Delete conversion type": "Видалити тип конверсії",
  "Delete cost entry": "Видалити запис витрат",
  "Delete custom metric": "Видалити власну метрику",
  "Delete file": "Видалити файл",
  "Delete report": "Видалити звіт",
  "Delete schedule": "Видалити розклад",
  "Delete this file?": "Видалити цей файл?",
  "Desktop, Mobile, Tablet": "Desktop, Mobile, Tablet",
  "Destination": "Призначення",
  "Distribution": "Розподіл",
  "Double meta (hide referrer)": "Подвійний мета (приховати referrer)",
  "Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.": "Виконайте тестові кліки через цю кампанію, щоб перевірити логіку потоку та фільтри — реальний трафік не записується.",
  "EPC (sensitive)": "EPC (чутливе)",
  "Edge server updated": "Edge-сервер оновлено",
  "Edit conversion type": "Редагувати тип конверсії",
  "Edit custom metric": "Редагувати власну метрику",
  "Enter a valid amount": "Введіть коректну суму",
  "Enter at least one identifier": "Введіть хоча б один ідентифікатор",
  "Enter bot token and chat id": "Введіть токен бота та chat id",
  "Enter the text to find": "Введіть текст для пошуку",
  "Equalize weights": "Вирівняти ваги",
  "Erase": "Видалити",
  "Erase data": "Видалити дані",
  "Erase subject data?": "Видалити дані суб'єкта?",
  "Erased": "Видалено",
  "Erasure is a hard delete and cannot be undone. It requires an admin role.": "Видалення є безповоротним і не може бути скасоване. Потрібна роль адміністратора.",
  "Error creating conversion type": "Помилка створення типу конверсії",
  "Error creating cost entry": "Помилка створення запису витрат",
  "Error creating custom metric": "Помилка створення власної метрики",
  "Error creating report": "Помилка створення звіту",
  "Error creating schedule": "Помилка створення розкладу",
  "Error deleting conversion type": "Помилка видалення типу конверсії",
  "Error deleting cost entry": "Помилка видалення запису витрат",
  "Error deleting custom metric": "Помилка видалення користувацької метрики",
  "Error deleting file": "Помилка видалення файлу",
  "Error deleting report": "Помилка видалення звіту",
  "Error deleting schedule": "Помилка видалення розкладу",
  "Error loading bot lists": "Помилка завантаження списків ботів",
  "Error loading conversion types": "Помилка завантаження типів конверсій",
  "Error loading cost entries": "Помилка завантаження записів витрат",
  "Error loading custom metrics": "Помилка завантаження користувацьких метрик",
  "Error loading reports": "Помилка завантаження звітів",
  "Error loading scheduled reports": "Помилка завантаження запланованих звітів",
  "Error saving bot lists": "Помилка збереження списків ботів",
  "Error updating conversion type": "Помилка оновлення типу конверсії",
  "Error updating custom metric": "Помилка оновлення користувацької метрики",
  "Error uploading file": "Помилка завантаження файлу",
  "Every submitted lead is stored here: filter, export (CSV) and resell": "Кожен надісланий лід зберігається тут: фільтруйте, експортуйте (CSV) та перепродавайте",
  "Export data": "Експортувати дані",
  "Export flows": "Експортувати потоки",
  "Exported": "Експортовано",
  "Failed to clone stream": "Не вдалося клонувати потік",
  "Failed to equalize weights": "Не вдалося вирівняти ваги",
  "Failed to erase DSAR": "Не вдалося видалити DSAR",
  "Failed to export DSAR": "Не вдалося експортувати DSAR",
  "Failed to export flows": "Не вдалося експортувати потоки",
  "Failed to export list": "Не вдалося експортувати список",
  "Failed to export report": "Не вдалося експортувати звіт",
  "Failed to import flows": "Не вдалося імпортувати потоки",
  "Failed to insert flow": "Не вдалося додати потік",
  "Failed to load leads": "Не вдалося завантажити ліди",
  "Failed to remove": "Не вдалося видалити",
  "Failed to replace URLs": "Не вдалося замінити URL",
  "Failed to run report": "Не вдалося запустити звіт",
  "Failed to update": "Не вдалося оновити",
  "Failed to update list": "Не вдалося оновити список",
  "Failed to update schedule": "Не вдалося оновити розклад",
  "Favourite": "Обране",
  "Favourite flows": "Обрані потоки",
  "Favourites": "Обране",
  "Fetched": "Отримано",
  "File deleted": "Файл видалено",
  "File uploaded": "Файл завантажено",
  "Filter rule": "Правило фільтра",
  "Find": "Знайти",
  "Find and replace a substring in flow redirect URLs (never landing/offer URLs).": "Знайдіть і замініть підрядок у URL переадресацій потоку (ніколи — у URL лендингів/оферів).",
  "Fire on statuses": "Спрацьовувати при статусах",
  "First 25 simulated clicks and how each was routed.": "Перші 25 симульованих кліків та спосіб їх маршрутизації.",
  "Flag clicks that arrive with no User-Agent header.": "Позначати кліки, що надходять без заголовка User-Agent.",
  "Flow tools": "Інструменти потоку",
  "Form submit (POST)": "Відправка форми (POST)",
  "Format": "Формат",
  "Formula": "Формула",
  "Formula is required": "Формула обов'язкова",
  "Formula-based report columns over base metrics (CR, EPC, ROI variants)": "Стовпці звіту на основі формул із базових метрик (CR, EPC, варіанти ROI)",
  "Friday": "П'ятниця",
  "From": "Від",
  "GDPR / DSAR": "GDPR / DSAR",
  "Group by": "Групувати за",
  "Has label": "Має мітку",
  "Headless click registration and the JS adapter for landing pages.": "Headless-реєстрація кліків та JS-адаптер для лендингів.",
  "Hour": "Година",
  "Hour (0-23)": "Година (0-23)",
  "How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.": "Як визначаються повторні відвідувачі для виявлення унікальних кліків: Cookie (за замовчуванням), IP, IP+UA або Параметр — ідентифікація за GET-параметром (наприклад, external_id), завдяки чому один і той самий користувач розпізнається попри зміни IP/cookie.",
  "IP + User-Agent": "IP + User-Agent",
  "IP of your tracking server": "IP вашого трекінг-сервера",
  "IPs": "IP",
  "ISP / carrier": "ISP / оператор",
  "Import flows": "Імпортувати потоки",
  "Imported": "Імпортовано",
  "In conversions": "У конверсіях",
  "In revenue": "У доході",
  "Include this type in the conversions column.": "Враховувати цей тип у стовпці конверсій.",
  "Include this type in the revenue column.": "Враховувати цей тип у стовпці доходу.",
  "Insert": "Вставити",
  "Integration": "Інтеграція",
  "JS adapter snippet": "Сніпет JS-адаптера",
  "Key (e.g. price)": "Ключ (наприклад, price)",
  "Key metrics over time buckets. Toggle to attribute conversions to their arrival date.": "Ключові метрики за часовими інтервалами. Перемкніть, щоб атрибутувати конверсії до дати їх надходження.",
  "Keys": "Ключі",
  "Label color": "Колір мітки",
  "Last run": "Останній запуск",
  "Lead export failed": "Експорт лідів не вдався",
  "Lead storage": "Зберігання лідів",
  "Leads": "Ліди",
  "Leads exported": "Ліди експортовано",
  "Leave empty to count every conversion.": "Залиште порожнім, щоб враховувати кожну конверсію.",
  "Leave the period blank to record spend as of now.": "Залиште період порожнім, щоб записати витрати починаючи з цього моменту.",
  "Lists": "Списки",
  "Manager": "Менеджер",
  "Manual": "Вручну",
  "Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.": "Вручну фіксуйте витрати кампанії, які синхронізація рекламного акаунта не бачить, — фіксовані платежі, офлайн-медіа, коригування.",
  "Manually record campaign spend — flat fees, offline media, corrections": "Записуйте витрати кампанії вручну — фіксовані платежі, офлайн-медіа, коригування",
  "Marked values are reusable as report filters and copyable for ad networks.": "Позначені значення можна повторно використовувати як фільтри звітів і копіювати для рекламних мереж.",
  "Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.": "Зіставте заголовок X-Requested-With для виявлення webview / браузера in-app. Пошук підрядка — наприклад, com.android охоплює webview Android; @empty охоплює кліки без заголовка.",
  "Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.": "Зіставте пошукову систему, визначену з параметрів se / se_referrer або хоста реферера — наприклад, google, bing, yandex.",
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": "Зіставте назву організації ISP / ASN відвідувача (з офлайн-таблиці IP-intel). Підтримуються маски, /regex/ та @empty — наприклад, AMAZON*, *Comcast*.",
  "Matched": "Збіг знайдено",
  "Metrics": "Метрики",
  "Metrics over time buckets (hour/day/weekday/month) + conversion-date view": "Метрики за часовими інтервалами (година/день/день тижня/місяць) + перегляд за датою конверсії",
  "Monday": "Понеділок",
  "Monthly": "Щомісяця",
  "Moscow, New York": "Москва, Нью-Йорк",
  "Moscow, New York, London": "Москва, Нью-Йорк, Лондон",
  "Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.": "Іменовані пари ключ/значення, що підставляються в URL лендингу/оферу/постбеку через макрос {offer_value:NAME}.",
  "Network preset…": "Пресет мережі…",
  "Network status values": "Значення статусу мережі",
  "New report": "Новий звіт",
  "New saved report": "Новий збережений звіт",
  "New schedule": "Новий розклад",
  "New scheduled report": "Новий запланований звіт",
  "No cost entries yet": "Записів витрат ще немає",
  "No custom conversion types yet": "Власних типів конверсій ще немає",
  "No custom metrics yet": "Власних метрик ще немає",
  "No data for this period": "Даних за цей період немає",
  "No favourite flows yet. Star a flow to reuse it here.": "Обраних потоків ще немає. Додайте потік до обраного, щоб використовувати його тут.",
  "No label": "Без мітки",
  "No leads yet": "Лідів ще немає",
  "No list entries yet. Use the thumbs buttons on report rows.": "Записів у списку ще немає. Використовуйте кнопки «палець» у рядках звіту.",
  "No match": "Збігів немає",
  "No offer values. Add a key like price, then use {offer_value:price} in URLs.": "Значень оферу немає. Додайте ключ, наприклад price, а потім використовуйте {offer_value:price} в URL.",
  "No partner routes — this is a plain redirect/upload offer.": "Маршрутів партнера немає — це звичайний офер із редиректом/завантаженням.",
  "No recipients set": "Одержувачів не вказано",
  "No saved reports yet": "Збережених звітів ще немає",
  "No scheduled reports yet": "Запланованих звітів ще немає",
  "No status values added": "Значень статусу не додано",
  "Not accepted": "Не прийнято",
  "Note": "Примітка",
  "Offer": "Офер",
  "Offer values": "Значення оферу",
  "One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).": "По одному IP або блоку CIDR на рядок (наприклад, 203.0.113.7 або 10.0.0.0/8).",
  "One per line: substring, mask (*) or /regex/.": "По одному на рядок: підрядок, маска (*) або /regex/.",
  "One value per line (or comma-separated). Each simulated query samples one value from each list.": "По одному значенню на рядок (або через кому). Кожен симульований запит вибирає одне значення з кожного списку.",
  "Only these conversion statuses are sent to the ad platform. Default: sale.": "До рекламної платформи надсилаються лише ці статуси конверсій. За замовчуванням: sale.",
  "Open Domains": "Відкрити домени",
  "Overrides": "Перевизначення",
  "Owner": "Власник",
  "POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.": "POST /v1/click з API-ключем (scope запису). Повертає рішення про маршрутизацію без редиректу в браузері.",
  "Parameter name, e.g. external_id": "Назва параметра, напр. external_id",
  "Parameters": "Параметри",
  "Paste on a landing page to auto-append the click id and forward the visitor.": "Вставте на лендинг, щоб автоматично додавати click ID та перенаправляти відвідувача.",
  "Per-query trace": "Трейс на запит",
  "Period": "Період",
  "Period end": "Кінець періоду",
  "Period start": "Початок періоду",
  "Phone": "Телефон",
  "Pick a report, cadence and recipients.": "Оберіть звіт, частоту та отримувачів.",
  "Postback added from preset": "Постбек додано з пресету",
  "Postback macro": "Макрос постбеку",
  "Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.": "Вкажіть принаймні один ідентифікатор. Це вплине на відповідні кліки та конверсії в усіх доступних вам воркспейсах.",
  "Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.": "Отримати статуси лідів та депозити з TrackBox (останні 7 днів) і оновити збережені ліди. Спочатку вкажіть Pull x-api-key в інтеграції.",
  "Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.": "Отримати статуси лідів з OpenAFF за кількість днів, задану в інтеграції, і оновити збережені ліди. Спочатку вкажіть в інтеграції токен API статусів.",
  "Pull sync": "Pull-синхронізація",
  "Pull sync (statuses/deposits)": "Pull-синхронізація (статуси/депозити)",
  "Pull sync done": "Pull-синхронізацію завершено",
  "Queries": "Запити",
  "ROI %": "ROI %",
  "ROI (sensitive)": "ROI (чутливе)",
  "Raw status strings partner networks send that should map to this type (case-insensitive).": "Рядки статусів, які партнерські мережі надсилають і які мають відповідати цьому типу (без урахування регістру).",
  "Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.": "Сирі статуси, що трактуються як TRASH (записуються, але виключаються з виплат). Напр. trash, invalid.",
  "Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.": "Сирі статуси, що трактуються як DEPOSIT (основний тип конверсії). Напр. dep, ftd, deposit.",
  "Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.": "Сирі статуси, що трактуються як REGISTRATION (основний тип конверсії). Напр. reg, signup.",
  "Read-only — only the workspace owner can edit the matrix": "Тільки для читання — матрицю може редагувати лише власник воркспейсу",
  "Recipients": "Отримувачі",
  "Recurring reports emailed on a daily/weekly/monthly cadence": "Циклічні звіти, що надсилаються на пошту щодня/щотижня/щомісяця",
  "Recurring reports emailed to recipients on a daily/weekly/monthly cadence.": "Циклічні звіти, що надсилаються отримувачам на пошту щодня/щотижня/щомісяця.",
  "Removed": "Видалено",
  "Replace": "Замінити",
  "Replace URL": "Замінити URL",
  "Replace with": "Замінити на",
  "Report deleted": "Звіт видалено",
  "Report queued": "Звіт у черзі",
  "Report saved": "Звіт збережено",
  "Report type": "Тип звіту",
  "Request": "Запит",
  "Response sample": "Приклад відповіді",
  "Reusable partner networks: postback, offer params, inbound URL": "Багаторазові партнерські мережі: постбек, параметри офера, вхідний URL",
  "Reusable report definitions you can export to CSV or XLSX on demand.": "Багаторазові визначення звітів, які можна експортувати до CSV або XLSX на вимогу.",
  "Reusable report definitions, exportable to CSV/XLSX on demand": "Багаторазові визначення звітів, що експортуються до CSV/XLSX на вимогу",
  "RevShare (% of payout)": "RevShare (% від виплати)",
  "Revenue (sensitive)": "Дохід (чутливе)",
  "Routing record (A record)": "Запис маршрутизації (A-запис)",
  "Run now": "Запустити зараз",
  "Run pull sync": "Запустити pull-синхронізацію",
  "Run simulation": "Запустити симуляцію",
  "Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.": "Запускає ковзну синхронізацію за 7 днів. Використовуйте це, щоб перевірити відповідь перед увімкненням автоматичної pull-синхронізації.",
  "Sample datasets": "Зразкові набори даних",
  "Saturday": "Субота",
  "Saved reports": "Збережені звіти",
  "Schedule created": "Розклад створено",
  "Schedule deleted": "Розклад видалено",
  "Scheduled reports": "Заплановані звіти",
  "Search conversion types": "Пошук типів конверсій",
  "Search custom metrics": "Пошук користувацьких метрик",
  "Search engines": "Пошукові системи",
  "Search presets": "Пошук пресетів",
  "Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.": "Надішліть синтетичний лід до CRM і перевірте відповідь. Якщо не вкажете інше нижче, буде використано одноразовий e-mail/телефон.",
  "Send test lead": "Надіслати тестовий лід",
  "Set another entry page first": "Спочатку вкажіть іншу сторінку входу",
  "Show shortcuts": "Показати гарячі клавіші",
  "Simulate": "Симулювати",
  "Simulating…": "Симуляція…",
  "Simulation failed": "Симуляція не вдалася",
  "Source": "Джерело",
  "Starred flows from any campaign. Insert a copy into this campaign.": "Потоки зі зірочкою з будь-якої кампанії. Вставте копію в цю кампанію.",
  "Stored form leads: name/email/phone/geo/status, filter + CSV export for resale": "Збережені ліди з форм: ім'я/e-mail/телефон/GEO/статус, фільтр + експорт CSV для перепродажу",
  "Stream cloned": "Потік клоновано",
  "Streams changed": "Потоки змінено",
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": "Потоки визначають, на який офер потрапляє кожен відвідувач. Налаштуйте потік за замовчуванням — і ви отримаєте робоче трекінгове посилання.",
  "Submitted leads from your offer forms will appear here.": "Тут з'являться ліди, надіслані з форм ваших оферів.",
  "Sunday": "Неділя",
  "Synced": "Синхронізовано",
  "Telegram postbacks added — press Save to apply": "Постбеки Telegram додано — натисніть «Зберегти», щоб застосувати",
  "Google Ads postbacks added — press Save to apply": "Постбеки Google Ads додано — натисніть «Зберегти», щоб застосувати",
  "Google Ads preset applied — press Save to apply": "Пресет Google Ads застосовано — натисніть «Зберегти», щоб застосувати",
  "Also add the standard Google Ads parameters (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) as defaults": "Також додати стандартні параметри Google Ads (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) як типові",
  "Google Ads postbacks added + click-time gtag turned off — press Save to apply": "Постбеки Google Ads додано + gtag під час кліку вимкнено — натисніть «Зберегти», щоб застосувати",
  "Adding these also turns OFF the click-time gtag (fire on redirect) for this campaign, so the same Google conversion is not counted twice.": "Додавання цього також ВИМИКАЄ gtag під час кліку (спрацьовує при редиректі) для цієї кампанії, щоб одна й та сама конверсія Google не рахувалася двічі.",
  "Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use \"Import from source\" to add them to a campaign.": "Параметри трекінгу (campaignid, adgroupid, keyword, tm, tml, sub1–3) оголошуються один раз у джерелі трафіку Google Ads — використовуйте «Імпортувати з джерела», щоб додати їх до кампанії.",
  "Google Ads conversions": "Конверсії Google Ads",
  "Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.": "Лише вихідні: ці HTTP-виклики сповіщають іншу систему після того, як XPNSR фіксує конверсію. Пресети партнерських мереж і вхідні URL належать на сторінці «Партнерські мережі» та мають бути вставлені в панель партнера — це не правила переадресації.",
  "Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.": "Вхідне налаштування партнера: параметри офера з click ID, маппінг статусів і URL постбека для вставки в панель партнера. Це не надсилає ліди до CRM і не є S2S-переадресацією кампанії.",
  "Inbound postback URL template": "Шаблон URL вхідного постбека",
  "Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.": "Вхідний URL, який партнерська мережа викликає при передачі ліда, продажу, відхилення або іншого статусу. Скопіюйте його в панель партнера; XPNSR не викликає цей URL як вихідний постбек кампанії.",
  "Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.": "Виберіть готовий пресет вхідного постбека або налаштуйте умови з партнером з нуля. Для передачі лідів із форми до CRM створіть Інтеграцію і прив'яжіть її до офера.",
  "Google Ads deposit postback added + click-time gtag kept off — press Save to apply": "Постбек депозиту Google Ads додано + gtag під час кліку залишається вимкненим — натисніть «Зберегти», щоб застосувати",
  "Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.": "Конверсія при кліку (застаріла): спрацьовує на /r/ до будь-якої реєстрації чи депозиту. Тримайте це вимкненим при оптимізації під ліди/депозити. Реальні ліди надсилаються автоматично з хостингових лендингів після успішної відповіді /api/lead.",
  "Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.": "Тримайте це ВИМКНЕНИМ для оптимізації під реальні конверсії. Ліди відправляються онлайн з хостингового лендингу лише після успішного /api/lead; депозити можна передавати нижче через S2S на постбеку продажу брокера. Увімкнення цього змусить Google оптимізуватися під кліки та може призвести до подвійного підрахунку конверсій.",
  "Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.": "Додає лише S2S постбек для депозиту/Purchase. Спрацьовує на постбеку продажу брокера та зіставляє клік Google за {gclid}. ID акаунту та мітка депозиту беруться з тегу {tm} для кожного кліку (AW-<account>/<deposit-label>) у суфіксі Final URL оголошення.",
  "Deposit → Purchase (with payout value) — fires on sale": "Депозит → Purchase (з сумою виплати) — спрацьовує при продажу",
  "Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.": "S2S для ліда навмисно не додається: хостинговий лендинг вже надсилає конверсію Lead онлайн через клієнтський gtag після того, як CRM приймає /api/lead. Додавання правила S2S для ліда створює ризик подвійного підрахунку того самого ліда.",
  "For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep \"Fire Google Ads gtag on redirect\" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.": "Для онлайн-лідів передавайте tml=AW-<account>/<lead-label> у суфіксі Final URL кожного рекламного акаунту. Тримайте «Fire Google Ads gtag on redirect» ВИМКНЕНИМ: трекер вбудовує окремий gtag для ліда в хостингові лендинги та запускає його лише після успішної відправки ліда. Налаштуйте Lead як Primary при ставках на ліди; тримайте Purchase як secondary, доки не перевірите звітність по депозитах, а потім скоригуйте цілі відповідно до вашої стратегії ставок.",
  "Sends the Google Ads conversion server-side on the broker postback, matched by {gclid} — no gtag on the landing and no API. Account id and label are read from the {tm} tag (AW-<account>/<label>) you already put in the ad Final URL suffix.": "Надсилає конверсію Google Ads на стороні сервера при постбеку брокера, зіставляючи за {gclid} — без gtag на лендингу та без API. ID акаунту та мітка зчитуються з тегу {tm} (AW-<account>/<label>), який ви вже вказали в суфіксі Final URL оголошення.",
  "Deposit → Purchase (primary, with value) — fires on sale": "Deposit → Purchase (primary, з вартістю) — спрацьовує при продажу",
  "Registration → Lead (secondary) — fires on lead": "Реєстрація → Lead (secondary) — спрацьовує при ліді",
  "For the Lead tag add its label to the ad Final URL suffix as tml=<label> (same AW account). If tml is empty the Lead beacon is skipped automatically. Keep Lead as Secondary in Google so optimization stays on deposits.": "Для тегу Lead додайте його мітку до суфіксу Final URL оголошення як tml=<label> (той самий AW-акаунт). Якщо tml порожній, beacon Lead пропускається автоматично. Тримайте Lead як Secondary у Google, щоб оптимізація залишалась на депозитах.",
  "Test integration": "Тестувати інтеграцію",
  "Test lead accepted": "Тестовий лід прийнято",
  "Test lead not accepted": "Тестовий лід не прийнято",
  "This permanently deletes all matching clicks and conversions. This cannot be undone.": "Це назавжди видалить усі відповідні кліки та конверсії. Цю дію неможливо скасувати.",
  "This permanently deletes the conversion type. Existing conversions keep their stored status.": "Це назавжди видалить тип конверсії. Наявні конверсії збережуть свій записаний статус.",
  "This permanently deletes the metric column from reports.": "Це назавжди видалить колонку метрики зі звітів.",
  "This permanently deletes the saved report definition.": "Це назавжди видалить збережене визначення звіту.",
  "This permanently deletes the scheduled report.": "Це назавжди видалить запланований звіт.",
  "This removes the manual cost and reverses its contribution to the campaign spend.": "Це видалить ручну витрату та скасує її вплив на витрати кампанії.",
  "Thursday": "Четвер",
  "To": "До",
  "Total leads": "Усього лідів",
  "Tracking domains are managed on the Domains page — add and verify a custom domain there.": "Домени для трекінгу керуються на сторінці «Домени» — там можна додати та верифікувати власний домен.",
  "Traffic Simulation": "Симуляція трафіку",
  "Traffic loss %": "% втрати трафіку",
  "Traffic trends": "Тренди трафіку",
  "Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.": "Правила переходів: до яких статусів може переходити конверсія цього типу. Залиште все невибраним, щоб дозволити будь-який перехід.",
  "Treat empty User-Agent as bot": "Вважати порожній User-Agent ботом",
  "Trends": "Тренди",
  "Tuesday": "Вівторок",
  "US, CA, GB": "US, CA, GB",
  "US, CA, GB, RU": "US, CA, GB, RU",
  "US, GB, DE": "US, GB, DE",
  "US,RU,DE": "US,RU,DE",
  "Uniqueness method": "Метод унікальності",
  "Update reporting semantics and status transitions.": "Оновити семантику звітності та переходи статусів.",
  "Update the formula, format or decimals.": "Оновити формулу, формат або кількість знаків після коми.",
  "Use a negative amount to book a correction.": "Використовуйте від'ємну суму для внесення коригування.",
  "Viewer": "Глядач",
  "Visitor ID": "Visitor ID",
  "Wednesday": "Середа",
  "Weekly": "Щотижня",
  "Weights equalized": "Ваги вирівняно",
  "White": "Біла",
  "Whitelist": "Whitelist",
  "Whitelisted": "У whitelist",
  "X-Requested-With": "X-Requested-With",
  "analyst": "аналітик",
  "box/goal id": "id боксу/голу",
  "buy, cheap, discount": "купити, дешево, знижка",
  "cpa, nutra, en": "cpa, nutra, en",
  "day": "день",
  "days": "днів",
  "e.g. Q3 influencer flat fee": "напр. фіксована ставка за інфлюенсера Q3",
  "e.g. Second deposit": "напр. Другий депозит",
  "e.g. Unique CR": "напр. Унікальний CR",
  "e.g. Weekly digest": "напр. Щотижневий дайджест",
  "e.g. Weekly performance": "напр. Тижнева ефективність",
  "email / phone / name": "email / телефон / ім'я",
  "free, demo": "безкоштовно, демо",
  "redirect": "redirect",
  "statuses on schedule": "статуси за розкладом",
  "Remove variant": "Видалити варіант",
  "Start test": "Запустити тест",
  "Pause test": "Призупинити тест",
  "View test results": "Переглянути результати тесту",
  "Remove parameter": "Видалити параметр",
  "Remove status mapping": "Видалити маппінг статусу",
  "Copy postback URL template": "Копіювати шаблон URL постбеку",
  "Copy inbound postback URL": "Копіювати вхідний URL постбеку",
  "Remove IP from blacklist": "Видалити IP з чорного списку",
  "Remove IP from whitelist": "Видалити IP з білого списку",
  "Copy curl command": "Копіювати команду curl",
  "Copy JS snippet": "Копіювати JS-сніпет",
  "Copy snippet": "Копіювати сніпет",
  "Remove postback": "Видалити постбек",
  "Campaign actions": "Дії з кампанією",
  "Remove vendor": "Видалити постачальника",
  "Remove campaign": "Видалити кампанію",
  "Remove value": "Видалити значення",
  "Remove field": "Видалити поле",
  "Copy webhook URL": "Копіювати URL вебхука",
  "Copy landing page URL": "Копіювати URL лендингу",
  "Open landing page": "Відкрити лендинг",
  "Remove partner route": "Видалити маршрут партнера",
  "Copy lead-form URL": "Копіювати URL lead-форми",
  "Copy offer URL": "Копіювати URL офера",
  "Delete list entry": "Видалити запис зі списку",
  "Copy secret": "Копіювати секрет",
  "Remove time range": "Видалити часовий діапазон",
  "Remove date range": "Видалити діапазон дат",
  "Pause stream": "Призупинити потік",
  "Resume stream": "Відновити потік",
  "Open redirect URL": "Відкрити URL редиректу",
  "Open offer URL": "Відкрити URL офера",
  "Copy postback URL": "Копіювати URL постбеку",
  "Delete rule": "Видалити правило",
  "Delete filter": "Видалити фільтр",
  "Delete traffic rule": "Видалити правило трафіку",
  "This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.": "Це назавжди видалить правило трафіку. Трафік перейде до решти правил або до налаштувань кампанії за замовчуванням.",
  "Delete fraud filter": "Видалити антифрод-фільтр",
  "This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.": "Це назавжди видалить антифрод-фільтр. Трафік, який він зараз блокує або оцінює, більше не перевірятиметься цим правилом.",
  "Action (no page — hand off to the offer)": "Action (без сторінки — передача на офер)",
  "After click (at redirect)": "Після кліку (при редиректі)",
  "Before click (at landing — enables offer macros)": "До кліку (на лендингу — вмикає макроси офера)",
  "Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.": "Визначати мобільного оператора з edge-заголовка X-Carrier. Підтримуються маски, /regex/ та @empty — наприклад, Vodafone*, /^T-Mobile/.",
  "Mobile operator / carrier": "Мобільний оператор / carrier",
  "Offer selection moment": "Момент вибору офера",
  "Preload (serve the page from the tracker domain)": "Preload (роздавати сторінку з домену трекера)",
  "Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.": "Preload завантажує сторінку на стороні сервера та роздає її під доменом вашого трекера; Action нічого не показує і дозволяє потоку вибрати офер.",
  "QR code": "QR-код",
  "Redirect (send visitor to the URL)": "Redirect (відправити відвідувача на URL)",
  "Remote rotator (fetch target)": "Віддалений ротатор (отримує ціль)",
  "Scan to open the tracking link on a device.": "Відскануйте, щоб відкрити трекінгове посилання на пристрої.",
  "Transparent (server-side fetch)": "Прозорий (отримання на стороні сервера)",
  "When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.": "Коли вибирати офер для цього потоку. Після (за замовчуванням): під час переадресації. До: під час відображення лендингу, щоб макроси {offer_name} / {offer_value:*} рендерилися на лендингу.",
  "Added to favourites": "Додано до обраного",
  "Credentials and settings for this partner. Fields marked * are required.": "Облікові дані та налаштування цього партнера. Поля, позначені *, є обов'язковими.",
  "Key created": "Ключ створено",
  "Removed from favourites": "Видалено з обраного",
  "Affiliate network archived": "Партнерську мережу заархівовано",
  "Archive affiliate network": "Архівувати партнерську мережу",
  "Archive landing page": "Архівувати лендинг",
  "Archive offer": "Архівувати офер",
  "Archive stream": "Архівувати потік",
  "Archive traffic source": "Архівувати джерело трафіку",
  "Archived at": "Заархівовано",
  "Archived items are hidden from your lists. Restore them or delete them permanently.": "Заархівовані елементи приховані зі списків. Відновіть їх або видаліть назавжди.",
  "Delete permanently": "Видалити назавжди",
  "Deleted permanently": "Видалено назавжди",
  "Error loading archive": "Помилка завантаження архіву",
  "Error restoring": "Помилка відновлення",
  "Landing page archived": "Лендинг заархівовано",
  "No archived items": "Немає заархівованих елементів",
  "Offer archived": "Офер заархівовано",
  "Restored": "Відновлено",
  "Stream archived": "Потік заархівовано",
  "This will move \"{name}\" to the archive. You can restore it or delete it permanently from the Archive page.": "Це перемістить \"{name}\" до архіву. Ви зможете відновити його або видалити назавжди на сторінці Архіву.",
  "This will permanently delete \"{name}\". This action cannot be undone.": "Це назавжди видалить \"{name}\". Цю дію неможливо скасувати.",
  "Traffic source archived": "Джерело трафіку заархівовано",
  "View archived": "Показати заархівовані",
  "Start date is required": "Дата початку обов'язкова",
  "Enter a valid cost": "Введіть коректну вартість",
  "Updated {n} clicks": "Оновлено {n} кліків",
  "Failed to update costs": "Не вдалося оновити витрати",
  "Statistics deleted": "Статистику видалено",
  "Failed to delete statistics": "Не вдалося видалити статистику",
  "Maintenance & costs": "Обслуговування та витрати",
  "Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.": "Ретроактивно перезаписуйте вартість кліків, скидайте статистику або отримуйте альтернативне трекінгове посилання.",
  "Update costs": "Оновити витрати",
  "Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.": "Ретроактивно (пере)записати вартість за клік для кліків у заданому діапазоні дат. Режим «Загальна сума» розподіляє суму між відповідними кліками; режим «За клік» застосовує її до кожного окремо.",
  "Start date": "Дата початку",
  "End date": "Дата закінчення",
  "Total (spread across clicks)": "Загальна сума (розподілена між кліками)",
  "Per click": "За клік",
  "Only unique clicks": "Лише унікальні кліки",
  "Skip bot clicks": "Пропускати кліки ботів",
  "Clean statistics": "Очистити статистику",
  "Alternative link prefixes": "Альтернативні префікси посилань",
  "Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.": "Кожен із цих префіксів шляху веде до того самого tracking id — чергуйте їх між джерелами трафіку, щоб обходити блок-листи.",
  "Delete statistics": "Видалити статистику",
  "This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.": "Це назавжди видалить усі кліки та конверсії цієї кампанії. Конфігурація кампанії збережеться. Цю дію неможливо скасувати.",
  "Error loading S2S log": "Помилка завантаження логу S2S",
  "S2S postback log": "Лог постбеків S2S",
  "Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.": "Усі вихідні постбеки конверсій по всіх кампаніях — фільтруйте за кампанією, статусом або результатом.",
  "Any result": "Будь-який результат",
  "Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.": "Вихідні постбеки конверсій з'являться тут, коли ваші кампанії почнуть передавати конверсії.",
  "Result": "Результат",
  "HTTP": "HTTP",
  "Error loading system status": "Помилка завантаження стану системи",
  "Paste the Tor exit list first": "Спочатку вставте список вихідних вузлів Tor",
  "Tor exit list updated": "Список вихідних вузлів Tor оновлено",
  "Failed to update Tor exit list": "Не вдалося оновити список вихідних вузлів Tor",
  "Process uptime, database size, data-processing queue and host metrics.": "Час роботи процесу, розмір бази даних, черга обробки даних та метрики хоста.",
  "Process": "Процес",
  "Uptime": "Аптайм",
  "Started": "Запущено",
  "Python": "Python",
  "Platform": "Платформа",
  "Database": "База даних",
  "Total documents": "Загальна кількість документів",
  "Data processing": "Обробка даних",
  "Analytics backend": "Аналітичний бекенд",
  "Ingest mode": "Режим прийому даних",
  "Queue depth": "Глибина черги",
  "Click uniqueness": "Унікальність кліків",
  "Redis ping": "Redis ping",
  "Host": "Хост",
  "Load average": "Середнє навантаження",
  "Disk used": "Використано диску",
  "Disk free": "Вільно на диску",
  "Cron": "Cron",
  "Last cost sync": "Остання синхронізація витрат",
  "FX rates": "Курси валют",
  "No FX rates cached.": "Кеш курсів валют порожній.",
  "Tor exit list": "Список вихідних вузлів Tor",
  "Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.": "Вставте список вихідних вузлів Tor, розділених новим рядком (наприклад, з torbulkexitlist), щоб оновити блок-лист у пам'яті.",
  "Replace list": "Замінити список",
  "Error loading fingerprints": "Помилка завантаження відбитків",
  "Fingerprint updated": "Відбиток оновлено",
  "Failed to update fingerprint": "Не вдалося оновити відбиток",
  "JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.": "Перевизначення відбитків JA3 / JA4 — позначте відбиток як хороший або поганий, щоб налаштувати виявлення ботів.",
  "All classifications": "Усі класифікації",
  "All kinds": "Усі типи",
  "No fingerprint overrides yet": "Немає перевизначень відбитків",
  "As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.": "Коли надходить трафік, тут з'являються відбитки JA3/JA4 — ви можете позначати відомих хороших або поганих клієнтів.",
  "Fingerprint": "Відбиток",
  "Kind": "Тип",
  "Label": "Мітка",
  "Hits": "Хіти",
  "Last seen": "Востаннє бачено",
  "Classification": "Класифікація",
  "Telegram alerts": "Сповіщення в Telegram",
  "Deploy + server-error notifications for the operator.": "Сповіщення про деплой та помилки сервера для оператора.",
  "Configured": "Налаштовано",
  "Not configured": "Не налаштовано",
  "Topic": "Топік",
  "Topic ID (optional)": "ID топіка (необов'язково)",
  "Leave the token empty to keep the saved one.": "Залиште токен порожнім, щоб зберегти поточний.",
  "Save & send test": "Зберегти та надіслати тест",
  "Test message delivered": "Тестове повідомлення доставлено",
  "Send failed": "Помилка надсилання",
  "Chat ID is required": "Chat ID є обов'язковим",
  "Nightly DB backups": "Нічне резервне копіювання БД",
  "A full copy of the database every night, kept on the persistent volume.": "Повна копія бази даних щоночі, що зберігається на постійному томі.",
  "Daily at": "Щодня о",
  "Copies kept": "Копій зберігається",
  "Stored": "Збережено",
  "Latest": "Остання",
  "No backups yet": "Резервних копій ще немає",
  "Run backup now": "Створити копію зараз",
  "Backup started — the result will arrive in the monitoring topic.": "Резервне копіювання розпочато — результат з'явиться в топіку моніторингу.",
  "Platform admin": "Адмін платформи",
  "Operator": "Оператор",
  "Cross-tenant back-office: accounts, access and platform health.": "Back-office для всіх акаунтів: доступи, акаунти та стан платформи.",
  "Accounts": "Акаунти",
  "New sign-ups": "Нові реєстрації",
  "Last 30 days": "Останні 30 днів",
  "Clicks (24h)": "Кліки (24г)",
  "Clicks (30d)": "Кліки (30д)",
  "Conversions (30d)": "Конверсії (30д)",
  "Platform state": "Стан платформи",
  "Self-signup": "Самостійна реєстрація",
  "Open": "Відкрита",
  "Closed": "Закрита",
  "Controlled by the DISABLE_REGISTRATION variable on Railway.": "Керується змінною DISABLE_REGISTRATION у Railway.",
  "Root admins": "Root-адміни",
  "From PLATFORM_ADMIN_EMAILS — manage the list on Railway.": "З PLATFORM_ADMIN_EMAILS — керуйте списком у Railway.",
  "Granted admins": "Призначені адміни",
  "Every registered account. Block access or grant platform admin.": "Усі зареєстровані акаунти. Заблокуйте доступ або призначте адміна платформи.",
  "Search by email or name…": "Пошук за email або іменем…",
  "Plan": "План",
  "Last click": "Останній клік",
  "No accounts found": "Акаунти не знайдено",
  "Root admin": "Root-адмін",
  "Client": "Клієнт",
  "Managed on Railway": "Керується в Railway",
  "Grant platform admin": "Призначити адміна платформи",
  "Grant platform admin?": "Призначити адміна платформи?",
  "Make admin": "Призначити адміна",
  "Revoke platform admin": "Відкликати адміна платформи",
  "Revoke platform admin?": "Відкликати адміна платформи?",
  "Revoke admin": "Відкликати адміна",
  "Block account": "Заблокувати акаунт",
  "Block this account?": "Заблокувати цей акаунт?",
  "The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.": "Користувач одразу втратить доступ — кожна сесія відхилятиметься, доки ви його не розблокуєте. Його кампанії та трекінгові посилання продовжать обслуговувати трафік.",
  "Reason (optional)": "Причина (необов'язково)",
  "Visible to admins only": "Видно лише адмінам",
  "Unblock": "Розблокувати",
  "Unblock account": "Розблокувати акаунт",
  "Unblock this account?": "Розблокувати цей акаунт?",
  "The user will be able to sign in again immediately.": "Користувач зможе увійти знову одразу.",
  "This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.": "Цей користувач отримує доступ оператора: бек-офіс платформи, всі акаунти та налаштування платформи. Призначення фіксується в журналі аудиту.",
  "The user keeps their account but loses operator access.": "Користувач зберігає акаунт, але втрачає доступ оператора.",
  "Account blocked": "Акаунт заблоковано",
  "Account unblocked": "Акаунт розблоковано",
  "Platform admin granted": "Адміна платформи призначено",
  "Platform admin revoked": "Адміна платформи відкликано",
  "Failed to load platform overview": "Не вдалося завантажити огляд платформи",
  "Failed to load users": "Не вдалося завантажити користувачів",
  "{count} accounts": "{count} акаунтів",
  "Page {page} of {total}": "Сторінка {page} з {total}",
  "Change plan": "Змінити план",
  "Plan updated": "План оновлено",
  "Sets the edition directly (status \"active\", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.": "Встановлює редакцію напряму (статус «active», без тріалу) — для ручних і безкоштовних акаунтів. Акаунти з активною підпискою Stripe мають змінювати план через Stripe.",
  "Account deleted": "Акаунт видалено",
  "Delete account": "Видалити акаунт",
  "Delete this account permanently?": "Видалити цей акаунт назавжди?",
  "This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.": "Це видалить акаунт і ВСІ його дані — кампанії, кліки, конверсії, офери, лендинги, домени, звіти. Дію неможливо скасувати.",
  "We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.": "Ми надіслали посилання для підтвердження на {email}. Відкрийте його, щоб активувати акаунт — посилання дійсне 24 години.",
  "Check your spam folder if it doesn't arrive within a minute.": "Якщо лист не надійде протягом хвилини, перевірте папку «Спам».",
  "Resend the email": "Надіслати листа повторно",
  "Sent — check your inbox": "Надіслано — перевірте вхідні",
  "Could not resend the email — try again.": "Не вдалося надіслати листа повторно — спробуйте ще раз.",
  "Back to sign in": "Назад до входу",
  "Confirming your email…": "Підтверджуємо вашу електронну адресу…",
  "This takes a second.": "Це займе секунду.",
  "Email confirmed — welcome aboard!": "Електронну адресу підтверджено — ласкаво просимо!",
  "Taking you to your dashboard…": "Переходимо до вашої панелі…",
  "Verification failed — the link may have expired.": "Верифікація не вдалася — посилання могло застаріти.",
  "The verification link is incomplete — open the link from the email again.": "Посилання для верифікації неповне — відкрийте посилання з листа ще раз.",
  "Use 8–128 characters; long passphrases are recommended": "Використовуйте 8–128 символів; рекомендуються довгі парольні фрази",
  "Users": "Користувачі",
  "Error": "Помилка",
  "Failed to load documentation.": "Не вдалося завантажити документацію.",
  "Production readiness": "Готовність до продакшну",
  "Ready": "Готово",
  "Attention required": "Потрібна увага",
  "Secret-free checks for runtime configuration and isolation controls.": "Перевірки конфігурації середовища та ізоляції без розкриття секретів.",
  "Environment": "Середовище",
  "production": "продакшн",
  "development": "розробка",
  "Rate limiter": "Rate limiter",
  "Access token TTL": "TTL токена доступу",
  "Backend root": "Backend від root",
  "Blocking checks": "Блокуючі перевірки",
  "Failed to load integrity status": "Не вдалося завантажити статус цілісності",
  "Traffic suspended": "Трафік призупинено",
  "Traffic resumed": "Трафік відновлено",
  "Data integrity": "Цілісність даних",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Обов'язкові унікальні індекси захищають атрибуцію кліків, конверсії та ідемпотентність білінгу.",
  "All mandatory indexes are present and unique.": "Усі обов'язкові індекси присутні та унікальні.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "Не ігноруйте це попередження. Перегляньте логи запуску бекенду перед зміною індексів.",
  "Missing": "Відсутній",
  "Not unique": "Не унікальний",
  "Resume campaign traffic": "Відновити трафік кампанії",
  "Resume traffic": "Відновити трафік",
  "Suspend campaign traffic": "Призупинити трафік кампанії",
  "Suspend traffic": "Призупинити трафік",
  "Suspend all campaign traffic for this account?": "Призупинити весь трафік кампаній для цього акаунту?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "Публічні трекінгові посилання повертатимуть відповідь для неактивної кампанії. Налаштування кампаній залишаться без змін, а трафік можна відновити миттєво.",
  "Resume campaign traffic for this account?": "Відновити трафік кампаній для цього акаунту?",
  "Existing active campaigns and tracking links will start serving again.": "Активні кампанії та трекінгові посилання знову почнуть працювати.",
  "Password changed — other devices have been signed out": "Пароль змінено — на інших пристроях сесії завершено",
  "Sign out of every device, including this one? You will need to sign in again.": "Вийти з усіх пристроїв, включно з цим? Вам потрібно буде увійти знову.",
  "All sessions signed out": "Усі сесії завершено",
  "Error signing out sessions": "Помилка під час завершення сесій",
  "Changing your password also signs out every other device.": "Зміна пароля також завершує сесії на всіх інших пристроях.",
  "Active sessions": "Активні сесії",
  "Lost a laptop, or think someone else has your password? End every session at once.": "Загубили ноутбук або підозрюєте, що хтось знає ваш пароль? Завершіть усі сесії одразу.",
  "This signs out every device, including this one. Signing back in takes one password.": "Це завершить сесії на всіх пристроях, включно з цим. Щоб увійти знову, достатньо пароля.",
  "Sign out everywhere": "Вийти скрізь",
  "Pages": "Сторінки",
  "Copy path": "Копіювати шлях",
  "Choose your plan": "Оберіть план",
  "Every plan includes the whole tracker.": "Кожен план включає повний трекер.",
  "{n} days free": "{n} днів безкоштовно",
  "Billed today": "Оплата сьогодні",
  "Continue": "Продовжити",
  "Start and Pro: {n} days free, card required. Charged automatically on day {next} unless you cancel. One free trial per account.": "Start і Pro: {n} днів безкоштовно, потрібна картка. Автоматичне списання на день {next}, якщо не скасуєте. Один безкоштовний пробний період на акаунт.",
  "Could not load plans.": "Не вдалося завантажити плани.",
  "Try again": "Спробувати ще раз",
  "Opening secure payment…": "Відкриття захищеної оплати…",
  "Could not open the payment page. Choose a plan to continue.": "Не вдалося відкрити сторінку оплати. Оберіть план, щоб продовжити.",
  "Start and Pro come with {n} days free. A card is required up front: Stripe checks it but charges nothing until day {next}, then the plan renews automatically. Cancel any time before the trial ends and you pay nothing. Team and Network are billed on the day you subscribe. One free trial per account.": "Start і Pro мають {n} днів безкоштовно. Картка потрібна одразу: Stripe перевіряє її, але нічого не списує до дня {next}, після чого план поновлюється автоматично. Скасуйте будь-коли до закінчення пробного періоду — і ви нічого не платите. Team і Network оплачуються в день оформлення підписки. Один безкоштовний пробний період на акаунт.",
  "Choose a plan to open your workspace.": "Оберіть план, щоб відкрити свій workspace.",
  "Payment was not completed. Choose a plan to continue.": "Оплату не завершено. Оберіть план, щоб продовжити.",
  "Confirming your payment…": "Підтвердження оплати…",
  "Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.": "Оплату отримано, але підтвердження займає більше часу, ніж зазвичай. Оновіть цю сторінку за хвилину.",
  "Payment confirmed. Welcome aboard!": "Оплату підтверджено. Ласкаво просимо!",
  "Free trial until {date}. Your card will be charged automatically on that day — nothing to do. Cancel before then in Manage billing and you pay nothing.": "Безкоштовний пробний період до {date}. Того дня з картки буде автоматично списано кошти — нічого робити не потрібно. Скасуйте раніше в розділі Manage billing — і ви нічого не платите.",
  "Start {n}-day free trial": "Почати {n}-денний безкоштовний пробний період",
  "Subscribe": "Підписатися",
  "Your free trial has already been used, so this plan is billed today.": "Ваш безкоштовний пробний період вже використано, тому цей план оплачується сьогодні.",
  "To switch plans, contact support — we move you without losing paid days.": "Щоб змінити план, зверніться до підтримки — ми перенесемо вас без втрати оплачених днів.",
  "Everything in Network, on your own server or cloud, installed with one command. Unlimited users, domains and history.": "Усе з Network, на вашому власному сервері або в хмарі, встановлюється однією командою. Необмежена кількість користувачів, доменів та історія без обмежень.",
  "After payment you issue your licence key on the page Self-hosted and install the tracker yourself with one command, following the step-by-step guide. If you prefer, we set it up for you or move you off your old tracker. The hosting is billed to you by your provider.": "Після оплати ви згенеруєте ліцензійний ключ на сторінці Self-hosted і встановите трекер самостійно однією командою, дотримуючись покрокової інструкції. За бажанням ми налаштуємо все за вас або перенесемо вас зі старого трекера. Хостинг оплачується вами безпосередньо у свого провайдера.",
  "Install on your own server": "Встановлення на власному сервері",
  "Or we set it up for you, on request": "Або ми налаштуємо це за вас, на запит",
  "Your own server or a dedicated cloud, with a licence key.": "Ваш власний сервер або виділена хмара з ліцензійним ключем.",
  "Monthly or 12 months": "Щомісяця або 12 місяців",
  "Cannot reach the server. Check your connection and try again.": "Не вдається з'єднатися з сервером. Перевірте з'єднання та спробуйте ще раз.",
  "Clicks are never counted": "Кліки не тарифікуються",
  "However much traffic you send, the invoice does not move.": "Скільки б трафіку ви не надіслали, рахунок не змінюється.",
  "Bots filtered on arrival": "Боти фільтруються одразу",
  "Datacenter, VPN and proxy traffic is handled before a page loads.": "Трафік із датацентрів, VPN і проксі обробляється до завантаження сторінки.",
  "First link in five minutes": "Перше посилання за п'ять хвилин",
  "Add a source, create a campaign, copy the link.": "Додайте джерело трафіку, створіть кампанію, скопіюйте посилання.",
  "Your workspace": "Ваш workspace",
  "Everything is already running": "Все вже працює",
  "Your workspace, your campaigns, your numbers.": "Ваш workspace, ваші кампанії, ваша статистика.",
  "Confirm your email": "Підтвердіть e-mail",
  "Open the link we sent and your workspace is ready.": "Відкрийте посилання, яке ми надіслали, і ваш робочий простір готовий.",
  "Enter your code": "Введіть код",
  "Six digits from your authenticator app.": "Шість цифр із вашого застосунку автентифікації.",
  "Create your account": "Створіть акаунт",
  "Two fields and a password. Tracking is live in minutes.": "Два поля та пароль. Трекінг запущено за кілька хвилин.",
  "We sent a confirmation link to": "Ми надіслали посилання для підтвердження на",
  "Check spam if it is not there within a minute. The link lasts 24 hours.": "Якщо лист не надійшов протягом хвилини, перевірте спам. Посилання дійсне 24 години.",
  "Sent again. Give it a moment.": "Надіслано повторно. Зачекайте хвилинку.",
  "Sending": "Надсилання",
  "Use a different account": "Використати інший акаунт",
  "Verification code": "Код підтвердження",
  "Checking": "Перевірка",
  "Signing in": "Вхід",
  "Your name": "Ваше ім'я",
  "At least 8 characters.": "Щонайменше 8 символів.",
  "Creating": "Створення",
  "Continue with": "Продовжити через",
  "No account yet?": "Ще немає акаунту?",
  "Create one": "Створити",
  "New accounts are closed at the moment.": "Реєстрація нових акаунтів наразі закрита.",
  "Terms": "Умови",
  "and": "та",
  "Privacy": "Конфіденційність",
  "History kept forever": "Історія зберігається назавжди",
  "Light theme": "Світла тема",
  "Dark theme": "Темна тема",
  "Match system": "Як у системі",
  "Theme": "Тема",
  "Navigate": "Навігація",
  "Not included on your plan. Open Billing to upgrade.": "Недоступно у вашому тарифі. Відкрийте Білінг для оновлення.",
  "Talk to us": "Зв'яжіться з нами",
  "Automatic flow optimiser": "Автоматичний оптимізатор потоку",
  "Learning bot detection": "Виявлення ботів із самонавчанням",
  "Lead forms into a CRM": "Лід-форми до CRM",
  "Roles and 31 permissions": "Ролі та 31 дозвіл",
  "Single sign on": "Єдиний вхід (SSO)",
  "We move you off your old tracker": "Перенесемо вас зі старого трекера",
  "90 days of history": "90 днів історії",
  "1 year of history": "1 рік історії",
  "2 years of history": "2 роки історії",
  "History kept": "Збереження історії",
  "Your first campaigns, with nothing to set up.": "Ваші перші кампанії — без жодного налаштування.",
  "Everything that makes the work run itself.": "Усе, що дозволяє роботі йти самій.",
  "A team, with roles and a paper trail.": "Команда з ролями та журналом змін.",
  "A network, under your own brand.": "Мережа під вашим власним брендом.",
  "Run the tracker on your own server or in a dedicated cloud. Your licence key activates one production server and one test server.": "Запустіть трекер на власному сервері або у виділеному хмарному середовищі. Ваш ліцензійний ключ активує один продакшн-сервер і один тестовий сервер.",
  "Self-hosted installs come with the Enterprise plan. Servers activated earlier stop once their current licence runs out.": "Встановлення на власному сервері доступне в плані Enterprise. Сервери, активовані раніше, зупиняться після закінчення поточної ліцензії.",
  "This is the only time the key is shown. Store it somewhere safe: you enter it when you install the tracker.": "Це єдиний момент, коли ключ відображається. Збережіть його в надійному місці: ви вводите його під час встановлення трекера.",
  "A new key replaces the current one at once. Servers that still use the old key cannot renew their licence and stop within {days} days unless you enter the new key on them.": "Новий ключ одразу замінює поточний. Сервери, які досі використовують старий ключ, не зможуть поновити ліцензію і зупиняться протягом {days} днів, якщо ви не введете на них новий ключ.",
  "The server loses its slot right away and stops within {days} days. Use this when you move the tracker to another server.": "Сервер одразу втрачає своє місце і зупиняється протягом {days} днів. Використовуйте це, коли переносите трекер на інший сервер.",
  "Each server checks in with us once a day and receives a licence valid for {days} days. If it cannot check in, or the subscription ends, it keeps working until that licence runs out and then stops. A test server is limited to {clicks} clicks a day. Only technical data is sent: licence, server id and version, never data about your traffic or your clients.": "Кожен сервер зв'язується з нами раз на день і отримує ліцензію, дійсну протягом {days} днів. Якщо він не може зв'язатися або підписка закінчується, він продовжує працювати до закінчення ліцензії, а потім зупиняється. Тестовий сервер обмежений до {clicks} кліків на день. Надсилаються лише технічні дані: ліцензія, ID сервера та версія — ніколи дані про ваш трафік чи ваших клієнтів.",
  "Run this command as root on a fresh server. In about ten minutes it installs everything (Kubernetes, HTTPS certificates, the database and the tracker). Running it again upgrades the install and keeps the data.": "Виконайте цю команду від імені root на чистому сервері. Приблизно за десять хвилин вона встановить усе (Kubernetes, HTTPS-сертифікати, базу даних і трекер). Повторний запуск оновлює встановлення та зберігає дані.",
  "Self-hosted": "Self-hosted",
  "Enterprise": "Enterprise",
  "Licence key": "Ліцензійний ключ",
  "Issue licence key": "Видати ліцензійний ключ",
  "Rotate key": "Ротація ключа",
  "Rotate licence key?": "Виконати ротацію ліцензійного ключа?",
  "Licence key issued": "Ліцензійний ключ видано",
  "Server deactivated": "Сервер деактивовано",
  "Deactivate this server?": "Деактивувати цей сервер?",
  "Servers": "Сервери",
  "Production": "Продакшн",
  "Revoked": "Відкликано",
  "Deactivated": "Деактивовано",
  "Deactivate": "Деактивувати",
  "Issued": "Видано",
  "Version": "Версія",
  "See plans": "Переглянути плани",
  "No servers activated yet.": "Жодного активованого сервера поки немає.",
  "Transfers left (30 days)": "Залишок трансферів (30 днів)",
  "Could not load this page.": "Не вдалося завантажити цю сторінку.",
  "Licensing is temporarily unavailable. Try again later.": "Ліцензування тимчасово недоступне. Спробуйте пізніше.",
  "Your server: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu or Debian (x86-64). The tracker installs with one command.": "Ваш сервер: 4 ядра CPU, 8 ГБ RAM, 50 ГБ SSD, Ubuntu або Debian (x86-64). Трекер встановлюється однією командою.",
  "Put your licence key in place of the X: it is shown once, when you issue or rotate it.": "Вставте ваш ліцензійний ключ замість X: він відображається лише один раз — під час видачі або ротації.",
  "The first account signed up with this email gets administrator rights on the server.": "Перший акаунт, зареєстрований з цим email, отримує права адміністратора на сервері.",
  "Without --domain the tracker starts on an address like 1-2-3-4.sslip.io. For your own domain, first point tracker.example.com and api.tracker.example.com at the server, then add --domain tracker.example.com.": "Без --domain трекер запускається за адресою виду 1-2-3-4.sslip.io. Для власного домену спочатку направте tracker.example.com і api.tracker.example.com на сервер, а потім додайте --domain tracker.example.com.",
  "Install on your server": "Встановлення на вашому сервері",
  "Server requirements": "Вимоги до сервера",
  "Production server": "Продакшн-сервер",
  "Test server": "Тестовий сервер",
  "Operating system": "Операційна система",
  "Disk space": "Місце на диску",
  "Connection": "Підключення",
  "Ubuntu 22.04 / 24.04 or Debian 12, x86-64": "Ubuntu 22.04 / 24.04 або Debian 12, x86-64",
  "4 cores (2 at least)": "4 ядра (мінімум 2)",
  "8 GB (4 GB at least)": "8 ГБ (мінімум 4 ГБ)",
  "50 GB SSD (30 GB free at least)": "50 ГБ SSD (мінімум 30 ГБ вільного місця)",
  "Public IP address, ports 80 and 443 open": "Публічна IP-адреса, відкриті порти 80 і 443",
  "After the install": "Після встановлення",
  "Server state and licence": "Стан сервера та ліцензії",
  "Upgrade to the newest signed release": "Оновити до найновішого підписаного релізу",
  "Back up the database to /var/backups/xpnsr": "Резервна копія бази даних у /var/backups/xpnsr",
  "Copy command": "Скопіювати команду",
  "Install the tracker on your own server in about 15 minutes. You do not need to know Kubernetes or Linux: you copy one command and the installer does the rest.": "Встановіть трекер на власному сервері приблизно за 15 хвилин. Вам не потрібно знати Kubernetes або Linux: скопіюйте одну команду — інсталятор зробить решту.",
  "Install guide": "Інструкція з встановлення",
  "Step-by-step guide": "Покрокова інструкція",
  "Back to Self-hosted": "Назад до Self-hosted",
  "Step": "Крок",
  "Get a server": "Отримайте сервер",
  "Optional: your own domain": "Необов'язково: власний домен",
  "Issue your licence key": "Згенерувати ліцензійний ключ",
  "Connect to the server": "Підключитися до сервера",
  "Run the install command": "Запустити команду встановлення",
  "Open your tracker": "Відкрийте свій трекер",
  "Keep it running": "Підтримка роботи",
  "Rent a VPS or cloud server from any provider, for example Hetzner, DigitalOcean, OVH, Vultr or AWS Lightsail: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). It usually costs 15–60 USD a month, billed to you by the provider.": "Орендуйте VPS або хмарний сервер у будь-якого провайдера, наприклад Hetzner, DigitalOcean, OVH, Vultr або AWS Lightsail: 4 ядра CPU, 8 ГБ RAM, 50 ГБ SSD, Ubuntu 24.04 (x86-64). Зазвичай це коштує 15–60 USD на місяць — рахунок виставляє провайдер.",
  "Take a fresh server with nothing else installed, and make sure ports 80 and 443 are open in the provider's firewall.": "Використовуйте чистий сервер без жодного встановленого ПЗ та переконайтеся, що порти 80 і 443 відкриті у файрволі провайдера.",
  "Note the server's IP address and the root password or SSH key from the provider's panel.": "Запишіть IP-адресу сервера, а також root-пароль або SSH-ключ із панелі провайдера.",
  "For your own address, create two DNS records of type A that point at the server's IP address, for example tracker.example.com and api.tracker.example.com. Skip this to start on a free address like 1-2-3-4.sslip.io; you can switch later.": "Для власної адреси створіть два DNS-записи типу A, що вказують на IP-адресу сервера, наприклад tracker.example.com і api.tracker.example.com. Пропустіть цей крок, щоб почати з безкоштовною адресою на кшталт 1-2-3-4.sslip.io; змінити це можна пізніше.",
  "On the page Self-hosted click Issue licence key and save the key somewhere safe: it is shown only once.": "На сторінці Self-hosted натисніть «Згенерувати ліцензійний ключ» і збережіть ключ у надійному місці: він відображається лише один раз.",
  "On Mac or Linux open Terminal, on Windows open PowerShell, and type the command below with your server's IP address. Answer yes to the first question and enter the password.": "На Mac або Linux відкрийте Terminal, на Windows — PowerShell, і введіть команду нижче з IP-адресою вашого сервера. На перше запитання відповідайте yes і введіть пароль.",
  "Copy the command from the page Self-hosted (your key and email are already in it), paste it into the terminal and press Enter. For your own domain add --domain tracker.example.com to it.": "Скопіюйте команду зі сторінки Self-hosted (ваш ключ і email вже вбудовані в неї), вставте її в термінал і натисніть Enter. Для власного домену додайте до команди --domain tracker.example.com.",
  "The install takes about 10 minutes. If the connection drops, the install keeps going: reconnect and follow it with the command below.": "Встановлення займає близько 10 хвилин. Якщо з'єднання перервалося, інсталяція продовжується: підключіться знову і стежте за нею за допомогою команди нижче.",
  "At the end the installer prints the address of your workspace. Open it and sign up with the administrator email from the command: that account gets administrator rights. The licence activates on its own.": "Наприкінці інсталятор виведе адресу вашого workspace. Відкрийте її та зареєструйтеся з email адміністратора, вказаним у команді: цей акаунт отримає права адміністратора. Ліцензія активується автоматично.",
  "To check everything, run the command below: the licence line should say \"state\":\"active\".": "Щоб перевірити все, запустіть команду нижче: у рядку ліцензії має бути \"state\":\"active\".",
  "Updates: the command below installs the newest signed release and keeps your data.": "Оновлення: команда нижче встановлює найновіший підписаний реліз і зберігає ваші дані.",
  "Backups: the command below saves the database to /var/backups/xpnsr. Copy it off the server regularly and turn on your provider's snapshots.": "Резервні копії: команда нижче зберігає базу даних у /var/backups/xpnsr. Регулярно копіюйте її за межі сервера та увімкніть снапшоти у свого провайдера.",
  "Test server: install a second server the same way, choosing Test server on the page Self-hosted.": "Тестовий сервер: встановіть другий сервер таким самим чином, вибравши «Тестовий сервер» на сторінці Self-hosted.",
  "If something goes wrong": "Якщо щось пішло не так",
  "ports 80/443 are already in use": "ports 80/443 are already in use",
  "Another web server runs on this machine. Use a fresh server or stop that web server, then run the command again.": "На цьому сервері вже працює інший веб-сервер. Використайте чистий сервер або зупиніть цей веб-сервер, а потім запустіть команду знову.",
  "The browser says the connection is not private": "Браузер повідомляє, що з'єднання не є приватним",
  "The HTTPS certificate is issued a few minutes after DNS points at the server. Wait five minutes; the command below should show READY True.": "HTTPS-сертифікат видається через кілька хвилин після того, як DNS починає вказувати на сервер. Зачекайте п'ять хвилин; команда нижче має показати READY True.",
  "The licence says the slot is in use": "Ліцензія повідомляє, що слот зайнятий",
  "The key is already active on another server. Deactivate that server on the page Self-hosted, then enter the key on the licence screen of your workspace, or wait up to an hour.": "Цей ключ вже активний на іншому сервері. Деактивуйте той сервер на сторінці Self-hosted, а потім введіть ключ на екрані ліцензії у своєму workspace, або зачекайте до однієї години.",
  "licence key not recognised": "licence key не розпізнано",
  "Paste the key again exactly as saved, or rotate it on the page Self-hosted and use the new one.": "Вставте ключ ще раз точно так, як його було збережено, або згенеруйте новий на сторінці Self-hosted і використайте його.",
  "Anything else": "Щось інше",
  "Run the install command again: it is always safe and continues where it stopped. If that does not help, send us the last lines of /var/log/xpnsr-install.log and the output of xpnsr status.": "Запустіть команду встановлення ще раз: це завжди безпечно, і вона продовжить з місця, де зупинилась. Якщо це не допоможе, надішліть нам останні рядки з /var/log/xpnsr-install.log та вивід xpnsr status.",
  "Prefer that we do it?": "Хочете, щоб ми зробили це за вас?",
  "We install the tracker for you, or move you off your old tracker with your campaigns. You open the server in your own hosting account and give us temporary access; it is included in Enterprise.": "Ми встановимо трекер для вас або перенесемо вас зі старого трекера разом із кампаніями. Ви відкриваєте сервер у власному хостинг-акаунті та надаєте нам тимчасовий доступ; це включено в Enterprise.",
  "Write to us": "Написати нам",
  "Fallback rules": "Резервні правила",
  "Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.": "Використовуються лише тоді, коли клік не відповідає жодному потоку кампанії. Налаштовуйте маршрутизацію в потоках; ці правила залишайте для рідкісних випадків.",
  "Add the banner to your landing page": "Додайте банер на свій лендинг",
  "Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.": "Вставте цей рядок у <head> кожного лендингу кампанії. Банер відображається лише тоді, коли він увімкнений вище, і лише для відвідувачів із вибраних регіонів.",
  "Copy code": "Скопіювати код",
  "No campaigns yet": "Кампаній ще немає",
  "Audience": "Аудиторія",
  "Updated at {time}": "Оновлено о {time}",
  "Download ZIP": "Завантажити ZIP",
  "Download failed": "Завантаження не вдалося",
  "Enter the licence key from your account (page Self-hosted). It activates this server, which then renews its licence once a day on its own.": "Введіть ліцензійний ключ зі свого акаунту (сторінка Self-hosted). Він активує цей сервер, який потім самостійно оновлює ліцензію раз на день.",
  "The licence of this installation has run out or is no longer valid, so the tracker is stopped. Check the Enterprise subscription and the key, then activate again.": "Ліцензія цієї інсталяції закінчилась або більше не є дійсною, тому трекер зупинено. Перевірте підписку Enterprise та ключ, а потім активуйте знову.",
  "The licence could not be renewed. The tracker keeps working until {date} and then stops unless a renewal succeeds.": "Не вдалося оновити ліцензію. Трекер працює до {date}, а потім зупиниться, якщо оновлення не відбудеться.",
  "Test server: limited to {n} clicks a day.": "Тестовий сервер: ліміт {n} кліків на день.",
  "This installation is not licensed. Ask the administrator to activate it.": "Ця інсталяція не має ліцензії. Зверніться до адміністратора для її активації.",
  "Licence activated": "Ліцензію активовано",
  "Licence expired": "Ліцензія недійсна",
  "Activate this installation": "Активувати цю інсталяцію",
  "Licensed to {who} · licence {id}": "Ліцензія: {who} · {id}",
  "Live clicks": "Кліки в реальному часі",
  "Open clicks log": "Відкрити лог кліків",
  "Could not load clicks": "Не вдалося завантажити кліки",
  "No clicks yet": "Кліків ще немає",
  "Send traffic to a tracking link and every click shows up here as it happens.": "Надішліть трафік на трекінгове посилання, і кожен клік з'являтиметься тут у реальному часі.",
  "cloaked": "клоакінг",
  "proxy": "proxy",
  "human": "людина",
  "{n}s ago": "{n} с тому",
  "Trend": "Тренд",
  "Clicks, last 14 days": "Кліки за останні 14 днів",
  "Add level": "Додати рівень",
  "Remove level": "Видалити рівень",
  "Last {n} days": "Останні {n} днів",
  "All time": "За весь час",
  "JA3 / JA4 fingerprint overrides for bot detection": "Ручне налаштування відбитків JA3 / JA4 для виявлення ботів",
  "Uptime, DB size, data-processing queue and host metrics": "Uptime, розмір БД, черга обробки даних і метрики сервера",
  "Outbound conversion postbacks fired across your campaigns": "Вихідні постбеки конверсій, що надсилаються з усіх ваших кампаній",
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Normal — звичайний потік із фільтрами. Catch (перехоплювальний) — перевіряється раніше за Normal-потоки і першим забирає відповідний клік, наприклад боти або тестове GEO. Fallback — останній потік; отримує трафік, який не підійшов жодному іншому.",
  "Interface: search, shortcuts and language": "Інтерфейс: пошук, гарячі клавіші та мова",
  "CAPI": "CAPI",
  "FAQ": "FAQ",
  "Cost, integrations & ops": "Витрати, інтеграції та операції",
  "New campaign": "Нова кампанія",
  "Command palette": "Палітра команд",
  "Pre-landing page": "Прелендинг",
  "good": "добрий",
  "bad": "поганий",
  "unknown": "невідомий",
  "Error reports": "Звіти про помилки",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Помилки сервера та браузера, згруповані за причиною. «Вирішити» приховує звіт, доки помилка не виникне знову; «Ігнорувати» вимикає сповіщення про неї.",
  "Unresolved": "Невирішені",
  "Ignored": "Проігноровані",
  "All": "Всі",
  "All sources": "Всі джерела",
  "Server": "Сервер",
  "Search by error text": "Пошук за текстом помилки",
  "Count": "Кількість",
  "First seen": "Перша поява",
  "No error reports": "Звітів про помилки немає",
  "Could not load error reports": "Не вдалося завантажити звіти про помилки",
  "Could not load the report": "Не вдалося завантажити звіт",
  "Report updated": "Звіт оновлено",
  "Could not update the report": "Не вдалося оновити звіт",
  "Seen {n} times": "Зустрічалося {n} разів",
  "Mark resolved": "Позначити як вирішене",
  "Reopen": "Відкрити знову",
  "Datacenter / hosting VPN / Tor IPs": "IP дата-центрів / хостингових VPN / Tor",
  "Visitors from cloud and hosting networks, VPNs that run on them, and Tor exits get the safe page. Residential proxies cannot be recognised without a paid IP database.": "Відвідувачі з хмарних і хостингових мереж, VPN на їх основі та вихідні вузли Tor отримують білу сторінку. Резидентські проксі неможливо розпізнати без платної бази IP.",
  "Offer only with a Google Ads click ID": "Офер лише з click ID з Google Ads",
  "Real Google Ads clicks always carry gclid, gbraid or wbraid; reviewers and link checkers open the link without one. Visitors without a valid click ID get the safe page. Leave off if auto-tagging is disabled or the campaign gets other traffic.": "Справжні кліки з Google Ads завжди містять gclid, gbraid або wbraid; модератори та перевірювачі посилань відкривають посилання без нього. Відвідувачі без дійсного click ID отримують білу сторінку. Вимкніть, якщо авто-теґування відключено або кампанія отримує інший трафік.",
  "Show white page": "Показати white page",
  "Shows the campaign white page (the page bots get) instead of an offer. Put it in a Default stream with no filters to send visitors that no other stream accepts to the white page instead of the target URL.": "Показує white page кампанії (сторінку, яку бачать боти) замість офера. Розмістіть у потоці Default без фільтрів, щоб відвідувачі, яких не прийняв жоден інший потік, потрапляли на white page, а не на цільовий URL.",
  "Transparent mode fetches the page from our server, so the visitor IP and cookies never reach it. Use it only for your own landing pages, not for affiliate offer links, or conversions may not be counted.": "Прозорий режим завантажує сторінку з нашого сервера, тому IP та cookies відвідувача до неї не потрапляють. Використовуйте лише для власних лендингів, а не для посилань на афіліатні офери, інакше конверсії можуть не зараховуватися.",
  "Check failed": "Перевірку не пройдено",
  "Can be shown in iframe mode": "Може відображатися в режимі iframe",
  "Blocked: visitors will see an empty screen in iframe mode": "Заблоковано: у режимі iframe відвідувачі побачать порожній екран",
  "Could not confirm: test it on a real phone before launch": "Підтвердити не вдалося: протестуйте на реальному телефоні перед запуском",
  "Check that the page allows framing. Paste the final offer or landing URL your streams send visitors to.": "Перевірте, чи дозволяє сторінка відображення у фреймі. Вставте кінцевий URL офера або лендингу, на який ваші потоки надсилають трафік.",
  "Checking…": "Перевірка…",
  "Check framing": "Перевірити фрейм",
};

export default uk;
